
export class ActiveProblem implements IActiveProblem {
    id?: number;
    name?: string | undefined;

    constructor(data?: IActiveProblem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ActiveProblem {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveProblem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IActiveProblem {
    id?: number;
    name?: string | undefined;
}

export class Application implements IApplication {
    id?: number;
    applicationName?: string | undefined;
    parentApplicationID?: number | undefined;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    active?: boolean;
    childApplications?: Application[] | undefined;
    parentApplication?: Application;

    constructor(data?: IApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationName = _data["applicationName"];
            this.parentApplicationID = _data["parentApplicationID"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.active = _data["active"];
            if (Array.isArray(_data["childApplications"])) {
                this.childApplications = [] as any;
                for (let item of _data["childApplications"])
                    this.childApplications!.push(Application.fromJS(item));
            }
            this.parentApplication = _data["parentApplication"] ? Application.fromJS(_data["parentApplication"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Application {
        data = typeof data === 'object' ? data : {};
        let result = new Application();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationName"] = this.applicationName;
        data["parentApplicationID"] = this.parentApplicationID;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["active"] = this.active;
        if (Array.isArray(this.childApplications)) {
            data["childApplications"] = [];
            for (let item of this.childApplications)
                data["childApplications"].push(item.toJSON());
        }
        data["parentApplication"] = this.parentApplication ? this.parentApplication.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApplication {
    id?: number;
    applicationName?: string | undefined;
    parentApplicationID?: number | undefined;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    active?: boolean;
    childApplications?: Application[] | undefined;
    parentApplication?: Application;
}

export class AssignedSubApplications implements IAssignedSubApplications {
    subApplication_Name?: string | undefined;
    parentSubApplication_Name?: string | undefined;
    subApplication_Id?: number;

    constructor(data?: IAssignedSubApplications) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subApplication_Name = _data["subApplication_Name"];
            this.parentSubApplication_Name = _data["parentSubApplication_Name"];
            this.subApplication_Id = _data["subApplication_Id"];
        }
    }

    static fromJS(data: any): AssignedSubApplications {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedSubApplications();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subApplication_Name"] = this.subApplication_Name;
        data["parentSubApplication_Name"] = this.parentSubApplication_Name;
        data["subApplication_Id"] = this.subApplication_Id;
        return data;
    }
}

export interface IAssignedSubApplications {
    subApplication_Name?: string | undefined;
    parentSubApplication_Name?: string | undefined;
    subApplication_Id?: number;
}

export class Assignment implements IAssignment {
    id?: number;
    productlineId?: number;
    processId?: number;
    typeGroupId?: number | undefined;
    productLine?: ProductLine;
    process?: Process;
    resourceAssignments?: ResourceAssignment[] | undefined;
    typeGroup?: TypeGroup;

    constructor(data?: IAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productlineId = _data["productlineId"];
            this.processId = _data["processId"];
            this.typeGroupId = _data["typeGroupId"];
            this.productLine = _data["productLine"] ? ProductLine.fromJS(_data["productLine"]) : <any>undefined;
            this.process = _data["process"] ? Process.fromJS(_data["process"]) : <any>undefined;
            if (Array.isArray(_data["resourceAssignments"])) {
                this.resourceAssignments = [] as any;
                for (let item of _data["resourceAssignments"])
                    this.resourceAssignments!.push(ResourceAssignment.fromJS(item));
            }
            this.typeGroup = _data["typeGroup"] ? TypeGroup.fromJS(_data["typeGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Assignment {
        data = typeof data === 'object' ? data : {};
        let result = new Assignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productlineId"] = this.productlineId;
        data["processId"] = this.processId;
        data["typeGroupId"] = this.typeGroupId;
        data["productLine"] = this.productLine ? this.productLine.toJSON() : <any>undefined;
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        if (Array.isArray(this.resourceAssignments)) {
            data["resourceAssignments"] = [];
            for (let item of this.resourceAssignments)
                data["resourceAssignments"].push(item.toJSON());
        }
        data["typeGroup"] = this.typeGroup ? this.typeGroup.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAssignment {
    id?: number;
    productlineId?: number;
    processId?: number;
    typeGroupId?: number | undefined;
    productLine?: ProductLine;
    process?: Process;
    resourceAssignments?: ResourceAssignment[] | undefined;
    typeGroup?: TypeGroup;
}

export class BitBreaker implements IBitBreaker {
    id?: number;
    sapNumber?: string | undefined;
    drawingNumber?: string | undefined;
    breakerBarID?: number;
    liftingApparatusID?: number;
    breakerLength?: number;
    breakerWidth?: number;
    insideWidth?: number;
    shortShank?: boolean;
    maxBitSize?: number;
    minBitSize?: number;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    steelMinBitSize?: number | undefined;
    steelMaxBitSize?: number | undefined;
    matrixMinBitSize?: number | undefined;
    matrixMaxBitSize?: number | undefined;
    upperSections?: Uppersection[] | undefined;
    breakerBar?: BreakerBar;
    liftingApparatus?: LiftingApparatus;
    bitCans?: BitCan[] | undefined;
    orD_Uppersection?: ORD_Uppersection[] | undefined;

    constructor(data?: IBitBreaker) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sapNumber = _data["sapNumber"];
            this.drawingNumber = _data["drawingNumber"];
            this.breakerBarID = _data["breakerBarID"];
            this.liftingApparatusID = _data["liftingApparatusID"];
            this.breakerLength = _data["breakerLength"];
            this.breakerWidth = _data["breakerWidth"];
            this.insideWidth = _data["insideWidth"];
            this.shortShank = _data["shortShank"];
            this.maxBitSize = _data["maxBitSize"];
            this.minBitSize = _data["minBitSize"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.steelMinBitSize = _data["steelMinBitSize"];
            this.steelMaxBitSize = _data["steelMaxBitSize"];
            this.matrixMinBitSize = _data["matrixMinBitSize"];
            this.matrixMaxBitSize = _data["matrixMaxBitSize"];
            if (Array.isArray(_data["upperSections"])) {
                this.upperSections = [] as any;
                for (let item of _data["upperSections"])
                    this.upperSections!.push(Uppersection.fromJS(item));
            }
            this.breakerBar = _data["breakerBar"] ? BreakerBar.fromJS(_data["breakerBar"]) : <any>undefined;
            this.liftingApparatus = _data["liftingApparatus"] ? LiftingApparatus.fromJS(_data["liftingApparatus"]) : <any>undefined;
            if (Array.isArray(_data["bitCans"])) {
                this.bitCans = [] as any;
                for (let item of _data["bitCans"])
                    this.bitCans!.push(BitCan.fromJS(item));
            }
            if (Array.isArray(_data["orD_Uppersection"])) {
                this.orD_Uppersection = [] as any;
                for (let item of _data["orD_Uppersection"])
                    this.orD_Uppersection!.push(ORD_Uppersection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BitBreaker {
        data = typeof data === 'object' ? data : {};
        let result = new BitBreaker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sapNumber"] = this.sapNumber;
        data["drawingNumber"] = this.drawingNumber;
        data["breakerBarID"] = this.breakerBarID;
        data["liftingApparatusID"] = this.liftingApparatusID;
        data["breakerLength"] = this.breakerLength;
        data["breakerWidth"] = this.breakerWidth;
        data["insideWidth"] = this.insideWidth;
        data["shortShank"] = this.shortShank;
        data["maxBitSize"] = this.maxBitSize;
        data["minBitSize"] = this.minBitSize;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["steelMinBitSize"] = this.steelMinBitSize;
        data["steelMaxBitSize"] = this.steelMaxBitSize;
        data["matrixMinBitSize"] = this.matrixMinBitSize;
        data["matrixMaxBitSize"] = this.matrixMaxBitSize;
        if (Array.isArray(this.upperSections)) {
            data["upperSections"] = [];
            for (let item of this.upperSections)
                data["upperSections"].push(item.toJSON());
        }
        data["breakerBar"] = this.breakerBar ? this.breakerBar.toJSON() : <any>undefined;
        data["liftingApparatus"] = this.liftingApparatus ? this.liftingApparatus.toJSON() : <any>undefined;
        if (Array.isArray(this.bitCans)) {
            data["bitCans"] = [];
            for (let item of this.bitCans)
                data["bitCans"].push(item.toJSON());
        }
        if (Array.isArray(this.orD_Uppersection)) {
            data["orD_Uppersection"] = [];
            for (let item of this.orD_Uppersection)
                data["orD_Uppersection"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBitBreaker {
    id?: number;
    sapNumber?: string | undefined;
    drawingNumber?: string | undefined;
    breakerBarID?: number;
    liftingApparatusID?: number;
    breakerLength?: number;
    breakerWidth?: number;
    insideWidth?: number;
    shortShank?: boolean;
    maxBitSize?: number;
    minBitSize?: number;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    steelMinBitSize?: number | undefined;
    steelMaxBitSize?: number | undefined;
    matrixMinBitSize?: number | undefined;
    matrixMaxBitSize?: number | undefined;
    upperSections?: Uppersection[] | undefined;
    breakerBar?: BreakerBar;
    liftingApparatus?: LiftingApparatus;
    bitCans?: BitCan[] | undefined;
    orD_Uppersection?: ORD_Uppersection[] | undefined;
}

export class BitCan implements IBitCan {
    id?: number;
    description?: string | undefined;
    sapMaterialNumber?: number;
    bitMin?: number;
    bitMax?: number;
    maxLength?: number;
    subPslId?: number;
    isObsolete?: boolean | undefined;
    bitBreakerId?: number | undefined;
    subPsl?: SubPSL;
    bitBreaker?: BitBreaker;

    constructor(data?: IBitCan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.sapMaterialNumber = _data["sapMaterialNumber"];
            this.bitMin = _data["bitMin"];
            this.bitMax = _data["bitMax"];
            this.maxLength = _data["maxLength"];
            this.subPslId = _data["subPslId"];
            this.isObsolete = _data["isObsolete"];
            this.bitBreakerId = _data["bitBreakerId"];
            this.subPsl = _data["subPsl"] ? SubPSL.fromJS(_data["subPsl"]) : <any>undefined;
            this.bitBreaker = _data["bitBreaker"] ? BitBreaker.fromJS(_data["bitBreaker"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BitCan {
        data = typeof data === 'object' ? data : {};
        let result = new BitCan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["sapMaterialNumber"] = this.sapMaterialNumber;
        data["bitMin"] = this.bitMin;
        data["bitMax"] = this.bitMax;
        data["maxLength"] = this.maxLength;
        data["subPslId"] = this.subPslId;
        data["isObsolete"] = this.isObsolete;
        data["bitBreakerId"] = this.bitBreakerId;
        data["subPsl"] = this.subPsl ? this.subPsl.toJSON() : <any>undefined;
        data["bitBreaker"] = this.bitBreaker ? this.bitBreaker.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBitCan {
    id?: number;
    description?: string | undefined;
    sapMaterialNumber?: number;
    bitMin?: number;
    bitMax?: number;
    maxLength?: number;
    subPslId?: number;
    isObsolete?: boolean | undefined;
    bitBreakerId?: number | undefined;
    subPsl?: SubPSL;
    bitBreaker?: BitBreaker;
}

export class BitOption implements IBitOption {
    id?: number;
    subPSL?: string | undefined;
    letter?: string | undefined;
    description?: string | undefined;
    order?: number;
    isObsolete?: boolean;
    bitFeatures?: Features[] | undefined;

    constructor(data?: IBitOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subPSL = _data["subPSL"];
            this.letter = _data["letter"];
            this.description = _data["description"];
            this.order = _data["order"];
            this.isObsolete = _data["isObsolete"];
            if (Array.isArray(_data["bitFeatures"])) {
                this.bitFeatures = [] as any;
                for (let item of _data["bitFeatures"])
                    this.bitFeatures!.push(Features.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BitOption {
        data = typeof data === 'object' ? data : {};
        let result = new BitOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subPSL"] = this.subPSL;
        data["letter"] = this.letter;
        data["description"] = this.description;
        data["order"] = this.order;
        data["isObsolete"] = this.isObsolete;
        if (Array.isArray(this.bitFeatures)) {
            data["bitFeatures"] = [];
            for (let item of this.bitFeatures)
                data["bitFeatures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBitOption {
    id?: number;
    subPSL?: string | undefined;
    letter?: string | undefined;
    description?: string | undefined;
    order?: number;
    isObsolete?: boolean;
    bitFeatures?: Features[] | undefined;
}

export class Blade implements IBlade {
    number?: number;
    armNumber?: number;
    row_numbers?: number[] | undefined;
    cutterCount?: number;
    row?: number;
    readonly rows?: Row[] | undefined;
    cutters?: BladeCutter[] | undefined;
    sequence?: number;

    constructor(data?: IBlade) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.armNumber = _data["armNumber"];
            if (Array.isArray(_data["row_numbers"])) {
                this.row_numbers = [] as any;
                for (let item of _data["row_numbers"])
                    this.row_numbers!.push(item);
            }
            this.cutterCount = _data["cutterCount"];
            this.row = _data["row"];
            if (Array.isArray(_data["rows"])) {
                (<any>this).rows = [] as any;
                for (let item of _data["rows"])
                    (<any>this).rows!.push(Row.fromJS(item));
            }
            if (Array.isArray(_data["cutters"])) {
                this.cutters = [] as any;
                for (let item of _data["cutters"])
                    this.cutters!.push(BladeCutter.fromJS(item));
            }
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): Blade {
        data = typeof data === 'object' ? data : {};
        let result = new Blade();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["armNumber"] = this.armNumber;
        if (Array.isArray(this.row_numbers)) {
            data["row_numbers"] = [];
            for (let item of this.row_numbers)
                data["row_numbers"].push(item);
        }
        data["cutterCount"] = this.cutterCount;
        data["row"] = this.row;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        if (Array.isArray(this.cutters)) {
            data["cutters"] = [];
            for (let item of this.cutters)
                data["cutters"].push(item.toJSON());
        }
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IBlade {
    number?: number;
    armNumber?: number;
    row_numbers?: number[] | undefined;
    cutterCount?: number;
    row?: number;
    rows?: Row[] | undefined;
    cutters?: BladeCutter[] | undefined;
    sequence?: number;
}

export class BladeCutter implements IBladeCutter {
    id?: number;
    rowNumber?: number;

    constructor(data?: IBladeCutter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowNumber = _data["rowNumber"];
        }
    }

    static fromJS(data: any): BladeCutter {
        data = typeof data === 'object' ? data : {};
        let result = new BladeCutter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowNumber"] = this.rowNumber;
        return data;
    }
}

export interface IBladeCutter {
    id?: number;
    rowNumber?: number;
}

export class Bom_DrawingLogOrderAssociation implements IBom_DrawingLogOrderAssociation {
    id?: number;
    drawingLog_Id?: number;
    order_Id?: number;
    createdBy?: number;
    createDate?: Date;
    drawingLog?: DrawingLog;
    order?: ORD_Order;
    user?: User;

    constructor(data?: IBom_DrawingLogOrderAssociation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.drawingLog_Id = _data["drawingLog_Id"];
            this.order_Id = _data["order_Id"];
            this.createdBy = _data["createdBy"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.drawingLog = _data["drawingLog"] ? DrawingLog.fromJS(_data["drawingLog"]) : <any>undefined;
            this.order = _data["order"] ? ORD_Order.fromJS(_data["order"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Bom_DrawingLogOrderAssociation {
        data = typeof data === 'object' ? data : {};
        let result = new Bom_DrawingLogOrderAssociation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["drawingLog_Id"] = this.drawingLog_Id;
        data["order_Id"] = this.order_Id;
        data["createdBy"] = this.createdBy;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["drawingLog"] = this.drawingLog ? this.drawingLog.toJSON() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBom_DrawingLogOrderAssociation {
    id?: number;
    drawingLog_Id?: number;
    order_Id?: number;
    createdBy?: number;
    createDate?: Date;
    drawingLog?: DrawingLog;
    order?: ORD_Order;
    user?: User;
}

export class BreakerBar implements IBreakerBar {
    id?: number;
    sapNumber?: number;
    drawingNumber?: string | undefined;
    length?: number;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    bitBreakers?: BitBreaker[] | undefined;

    constructor(data?: IBreakerBar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sapNumber = _data["sapNumber"];
            this.drawingNumber = _data["drawingNumber"];
            this.length = _data["length"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["bitBreakers"])) {
                this.bitBreakers = [] as any;
                for (let item of _data["bitBreakers"])
                    this.bitBreakers!.push(BitBreaker.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BreakerBar {
        data = typeof data === 'object' ? data : {};
        let result = new BreakerBar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sapNumber"] = this.sapNumber;
        data["drawingNumber"] = this.drawingNumber;
        data["length"] = this.length;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        if (Array.isArray(this.bitBreakers)) {
            data["bitBreakers"] = [];
            for (let item of this.bitBreakers)
                data["bitBreakers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBreakerBar {
    id?: number;
    sapNumber?: number;
    drawingNumber?: string | undefined;
    length?: number;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    bitBreakers?: BitBreaker[] | undefined;
}

export class CerebroInfluenceType implements ICerebroInfluenceType {
    id?: number;
    name?: string | undefined;
    rank?: number;
    orD_CerebroInfluence?: ORD_CerebroInfluence[] | undefined;

    constructor(data?: ICerebroInfluenceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.rank = _data["rank"];
            if (Array.isArray(_data["orD_CerebroInfluence"])) {
                this.orD_CerebroInfluence = [] as any;
                for (let item of _data["orD_CerebroInfluence"])
                    this.orD_CerebroInfluence!.push(ORD_CerebroInfluence.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CerebroInfluenceType {
        data = typeof data === 'object' ? data : {};
        let result = new CerebroInfluenceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["rank"] = this.rank;
        if (Array.isArray(this.orD_CerebroInfluence)) {
            data["orD_CerebroInfluence"] = [];
            for (let item of this.orD_CerebroInfluence)
                data["orD_CerebroInfluence"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICerebroInfluenceType {
    id?: number;
    name?: string | undefined;
    rank?: number;
    orD_CerebroInfluence?: ORD_CerebroInfluence[] | undefined;
}

export class Check implements ICheck {
    id?: number;
    processId?: number;
    productlineId?: number;
    typeGroupId?: number;
    checkOrder?: number;
    parent_CheckId?: number | undefined;
    checkSheet_ItemId?: number;
    productLine?: ProductLine;
    child_Check?: Check[] | undefined;
    parent_Check?: Check;
    checkSheet_Item?: CheckSheet_Item;
    process?: Process;
    typeGroup?: TypeGroup;
    checkSheets?: CheckSheet[] | undefined;
    checkUpdates?: CheckUpdate[] | undefined;

    constructor(data?: ICheck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processId = _data["processId"];
            this.productlineId = _data["productlineId"];
            this.typeGroupId = _data["typeGroupId"];
            this.checkOrder = _data["checkOrder"];
            this.parent_CheckId = _data["parent_CheckId"];
            this.checkSheet_ItemId = _data["checkSheet_ItemId"];
            this.productLine = _data["productLine"] ? ProductLine.fromJS(_data["productLine"]) : <any>undefined;
            if (Array.isArray(_data["child_Check"])) {
                this.child_Check = [] as any;
                for (let item of _data["child_Check"])
                    this.child_Check!.push(Check.fromJS(item));
            }
            this.parent_Check = _data["parent_Check"] ? Check.fromJS(_data["parent_Check"]) : <any>undefined;
            this.checkSheet_Item = _data["checkSheet_Item"] ? CheckSheet_Item.fromJS(_data["checkSheet_Item"]) : <any>undefined;
            this.process = _data["process"] ? Process.fromJS(_data["process"]) : <any>undefined;
            this.typeGroup = _data["typeGroup"] ? TypeGroup.fromJS(_data["typeGroup"]) : <any>undefined;
            if (Array.isArray(_data["checkSheets"])) {
                this.checkSheets = [] as any;
                for (let item of _data["checkSheets"])
                    this.checkSheets!.push(CheckSheet.fromJS(item));
            }
            if (Array.isArray(_data["checkUpdates"])) {
                this.checkUpdates = [] as any;
                for (let item of _data["checkUpdates"])
                    this.checkUpdates!.push(CheckUpdate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Check {
        data = typeof data === 'object' ? data : {};
        let result = new Check();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processId"] = this.processId;
        data["productlineId"] = this.productlineId;
        data["typeGroupId"] = this.typeGroupId;
        data["checkOrder"] = this.checkOrder;
        data["parent_CheckId"] = this.parent_CheckId;
        data["checkSheet_ItemId"] = this.checkSheet_ItemId;
        data["productLine"] = this.productLine ? this.productLine.toJSON() : <any>undefined;
        if (Array.isArray(this.child_Check)) {
            data["child_Check"] = [];
            for (let item of this.child_Check)
                data["child_Check"].push(item.toJSON());
        }
        data["parent_Check"] = this.parent_Check ? this.parent_Check.toJSON() : <any>undefined;
        data["checkSheet_Item"] = this.checkSheet_Item ? this.checkSheet_Item.toJSON() : <any>undefined;
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        data["typeGroup"] = this.typeGroup ? this.typeGroup.toJSON() : <any>undefined;
        if (Array.isArray(this.checkSheets)) {
            data["checkSheets"] = [];
            for (let item of this.checkSheets)
                data["checkSheets"].push(item.toJSON());
        }
        if (Array.isArray(this.checkUpdates)) {
            data["checkUpdates"] = [];
            for (let item of this.checkUpdates)
                data["checkUpdates"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICheck {
    id?: number;
    processId?: number;
    productlineId?: number;
    typeGroupId?: number;
    checkOrder?: number;
    parent_CheckId?: number | undefined;
    checkSheet_ItemId?: number;
    productLine?: ProductLine;
    child_Check?: Check[] | undefined;
    parent_Check?: Check;
    checkSheet_Item?: CheckSheet_Item;
    process?: Process;
    typeGroup?: TypeGroup;
    checkSheets?: CheckSheet[] | undefined;
    checkUpdates?: CheckUpdate[] | undefined;
}

export class CheckSheet implements ICheckSheet {
    id?: number;
    checkId?: number;
    orderId?: number;
    checked?: boolean;
    notApplicable?: boolean;
    designerId?: number | undefined;
    designer_CheckDate?: Date | undefined;
    designer_Comment?: string | undefined;
    peerId?: number | undefined;
    peer_CheckDate?: Date | undefined;
    peer_CheckStatus?: boolean | undefined;
    peer_Comment?: string | undefined;
    approver_Id?: number | undefined;
    approver_CheckDate?: Date | undefined;
    approver_CheckStatus?: boolean | undefined;
    approver_Comment?: string | undefined;
    info_FileId?: number | undefined;
    automation_Check?: boolean | undefined;

    constructor(data?: ICheckSheet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.checkId = _data["checkId"];
            this.orderId = _data["orderId"];
            this.checked = _data["checked"];
            this.notApplicable = _data["notApplicable"];
            this.designerId = _data["designerId"];
            this.designer_CheckDate = _data["designer_CheckDate"] ? new Date(_data["designer_CheckDate"].toString()) : <any>undefined;
            this.designer_Comment = _data["designer_Comment"];
            this.peerId = _data["peerId"];
            this.peer_CheckDate = _data["peer_CheckDate"] ? new Date(_data["peer_CheckDate"].toString()) : <any>undefined;
            this.peer_CheckStatus = _data["peer_CheckStatus"];
            this.peer_Comment = _data["peer_Comment"];
            this.approver_Id = _data["approver_Id"];
            this.approver_CheckDate = _data["approver_CheckDate"] ? new Date(_data["approver_CheckDate"].toString()) : <any>undefined;
            this.approver_CheckStatus = _data["approver_CheckStatus"];
            this.approver_Comment = _data["approver_Comment"];
            this.info_FileId = _data["info_FileId"];
            this.automation_Check = _data["automation_Check"];
        }
    }

    static fromJS(data: any): CheckSheet {
        data = typeof data === 'object' ? data : {};
        let result = new CheckSheet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["checkId"] = this.checkId;
        data["orderId"] = this.orderId;
        data["checked"] = this.checked;
        data["notApplicable"] = this.notApplicable;
        data["designerId"] = this.designerId;
        data["designer_CheckDate"] = this.designer_CheckDate ? this.designer_CheckDate.toISOString() : <any>undefined;
        data["designer_Comment"] = this.designer_Comment;
        data["peerId"] = this.peerId;
        data["peer_CheckDate"] = this.peer_CheckDate ? this.peer_CheckDate.toISOString() : <any>undefined;
        data["peer_CheckStatus"] = this.peer_CheckStatus;
        data["peer_Comment"] = this.peer_Comment;
        data["approver_Id"] = this.approver_Id;
        data["approver_CheckDate"] = this.approver_CheckDate ? this.approver_CheckDate.toISOString() : <any>undefined;
        data["approver_CheckStatus"] = this.approver_CheckStatus;
        data["approver_Comment"] = this.approver_Comment;
        data["info_FileId"] = this.info_FileId;
        data["automation_Check"] = this.automation_Check;
        return data;
    }
}

export interface ICheckSheet {
    id?: number;
    checkId?: number;
    orderId?: number;
    checked?: boolean;
    notApplicable?: boolean;
    designerId?: number | undefined;
    designer_CheckDate?: Date | undefined;
    designer_Comment?: string | undefined;
    peerId?: number | undefined;
    peer_CheckDate?: Date | undefined;
    peer_CheckStatus?: boolean | undefined;
    peer_Comment?: string | undefined;
    approver_Id?: number | undefined;
    approver_CheckDate?: Date | undefined;
    approver_CheckStatus?: boolean | undefined;
    approver_Comment?: string | undefined;
    info_FileId?: number | undefined;
    automation_Check?: boolean | undefined;
}

export class CheckSheet_Item implements ICheckSheet_Item {
    id?: number;
    name?: string | undefined;
    parent?: boolean;
    checks?: Check[] | undefined;

    constructor(data?: ICheckSheet_Item) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parent = _data["parent"];
            if (Array.isArray(_data["checks"])) {
                this.checks = [] as any;
                for (let item of _data["checks"])
                    this.checks!.push(Check.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CheckSheet_Item {
        data = typeof data === 'object' ? data : {};
        let result = new CheckSheet_Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parent"] = this.parent;
        if (Array.isArray(this.checks)) {
            data["checks"] = [];
            for (let item of this.checks)
                data["checks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICheckSheet_Item {
    id?: number;
    name?: string | undefined;
    parent?: boolean;
    checks?: Check[] | undefined;
}

export class CheckSheet_Template implements ICheckSheet_Template {
    id?: number;
    processId?: number;
    typeGroupId?: number;
    productlineId?: number;
    version?: string | undefined;
    active?: boolean;
    productLine?: ProductLine;
    process?: Process;
    typeGroup?: TypeGroup;

    constructor(data?: ICheckSheet_Template) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processId = _data["processId"];
            this.typeGroupId = _data["typeGroupId"];
            this.productlineId = _data["productlineId"];
            this.version = _data["version"];
            this.active = _data["active"];
            this.productLine = _data["productLine"] ? ProductLine.fromJS(_data["productLine"]) : <any>undefined;
            this.process = _data["process"] ? Process.fromJS(_data["process"]) : <any>undefined;
            this.typeGroup = _data["typeGroup"] ? TypeGroup.fromJS(_data["typeGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CheckSheet_Template {
        data = typeof data === 'object' ? data : {};
        let result = new CheckSheet_Template();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processId"] = this.processId;
        data["typeGroupId"] = this.typeGroupId;
        data["productlineId"] = this.productlineId;
        data["version"] = this.version;
        data["active"] = this.active;
        data["productLine"] = this.productLine ? this.productLine.toJSON() : <any>undefined;
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        data["typeGroup"] = this.typeGroup ? this.typeGroup.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICheckSheet_Template {
    id?: number;
    processId?: number;
    typeGroupId?: number;
    productlineId?: number;
    version?: string | undefined;
    active?: boolean;
    productLine?: ProductLine;
    process?: Process;
    typeGroup?: TypeGroup;
}

export class CheckUpdate implements ICheckUpdate {
    id?: number;
    checkId?: number;
    oldVal?: string | undefined;
    newVal?: string | undefined;
    modifiedBy?: number;
    modifiedDate?: Date;
    user?: User;
    check?: Check;

    constructor(data?: ICheckUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.checkId = _data["checkId"];
            this.oldVal = _data["oldVal"];
            this.newVal = _data["newVal"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.check = _data["check"] ? Check.fromJS(_data["check"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CheckUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new CheckUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["checkId"] = this.checkId;
        data["oldVal"] = this.oldVal;
        data["newVal"] = this.newVal;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["check"] = this.check ? this.check.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICheckUpdate {
    id?: number;
    checkId?: number;
    oldVal?: string | undefined;
    newVal?: string | undefined;
    modifiedBy?: number;
    modifiedDate?: Date;
    user?: User;
    check?: Check;
}

export class Communication implements ICommunication {
    id?: number;
    orderId?: number;
    userId?: number;
    message?: string | undefined;
    timestamp?: Date;
    displayName?: string | undefined;
    loginID?: string | undefined;
    email?: string | undefined;

    constructor(data?: ICommunication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.userId = _data["userId"];
            this.message = _data["message"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.displayName = _data["displayName"];
            this.loginID = _data["loginID"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): Communication {
        data = typeof data === 'object' ? data : {};
        let result = new Communication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["userId"] = this.userId;
        data["message"] = this.message;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["displayName"] = this.displayName;
        data["loginID"] = this.loginID;
        data["email"] = this.email;
        return data;
    }
}

export interface ICommunication {
    id?: number;
    orderId?: number;
    userId?: number;
    message?: string | undefined;
    timestamp?: Date;
    displayName?: string | undefined;
    loginID?: string | undefined;
    email?: string | undefined;
}

export class ComponentCost implements IComponentCost {
    basedOnD63?: boolean;
    bitSize?: string | undefined;
    gauge?: string | undefined;
    blades?: string | undefined;
    minBitSize?: number;
    maxBitSize?: number;
    minGaugeLength?: number;
    maxGaugeLength?: number;
    minNoOfBlade?: number;
    maxNoOfBlade?: number;
    averageCost?: number | undefined;
    averageQuantity?: number | undefined;
    unKnown?: boolean;
    name?: string | undefined;

    constructor(data?: IComponentCost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.basedOnD63 = _data["basedOnD63"];
            this.bitSize = _data["bitSize"];
            this.gauge = _data["gauge"];
            this.blades = _data["blades"];
            this.minBitSize = _data["minBitSize"];
            this.maxBitSize = _data["maxBitSize"];
            this.minGaugeLength = _data["minGaugeLength"];
            this.maxGaugeLength = _data["maxGaugeLength"];
            this.minNoOfBlade = _data["minNoOfBlade"];
            this.maxNoOfBlade = _data["maxNoOfBlade"];
            this.averageCost = _data["averageCost"];
            this.averageQuantity = _data["averageQuantity"];
            this.unKnown = _data["unKnown"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ComponentCost {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentCost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basedOnD63"] = this.basedOnD63;
        data["bitSize"] = this.bitSize;
        data["gauge"] = this.gauge;
        data["blades"] = this.blades;
        data["minBitSize"] = this.minBitSize;
        data["maxBitSize"] = this.maxBitSize;
        data["minGaugeLength"] = this.minGaugeLength;
        data["maxGaugeLength"] = this.maxGaugeLength;
        data["minNoOfBlade"] = this.minNoOfBlade;
        data["maxNoOfBlade"] = this.maxNoOfBlade;
        data["averageCost"] = this.averageCost;
        data["averageQuantity"] = this.averageQuantity;
        data["unKnown"] = this.unKnown;
        data["name"] = this.name;
        return data;
    }
}

export interface IComponentCost {
    basedOnD63?: boolean;
    bitSize?: string | undefined;
    gauge?: string | undefined;
    blades?: string | undefined;
    minBitSize?: number;
    maxBitSize?: number;
    minGaugeLength?: number;
    maxGaugeLength?: number;
    minNoOfBlade?: number;
    maxNoOfBlade?: number;
    averageCost?: number | undefined;
    averageQuantity?: number | undefined;
    unKnown?: boolean;
    name?: string | undefined;
}

export class Cost implements ICost {
    totalCost?: number;
    primaryCutterCost?: number;
    secondaryCutterCost?: number;
    backupElementCost?: number;
    powder?: ComponentCost;
    binder?: ComponentCost;
    hardFacing?: ComponentCost;
    matrixToSteel?: number | undefined;
    upperSection?: ComponentCost;
    isOnePiece?: boolean;
    leachingDepth?: string | undefined;
    leachingRID?: number | undefined;

    constructor(data?: ICost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCost = _data["totalCost"];
            this.primaryCutterCost = _data["primaryCutterCost"];
            this.secondaryCutterCost = _data["secondaryCutterCost"];
            this.backupElementCost = _data["backupElementCost"];
            this.powder = _data["powder"] ? ComponentCost.fromJS(_data["powder"]) : <any>undefined;
            this.binder = _data["binder"] ? ComponentCost.fromJS(_data["binder"]) : <any>undefined;
            this.hardFacing = _data["hardFacing"] ? ComponentCost.fromJS(_data["hardFacing"]) : <any>undefined;
            this.matrixToSteel = _data["matrixToSteel"];
            this.upperSection = _data["upperSection"] ? ComponentCost.fromJS(_data["upperSection"]) : <any>undefined;
            this.isOnePiece = _data["isOnePiece"];
            this.leachingDepth = _data["leachingDepth"];
            this.leachingRID = _data["leachingRID"];
        }
    }

    static fromJS(data: any): Cost {
        data = typeof data === 'object' ? data : {};
        let result = new Cost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCost"] = this.totalCost;
        data["primaryCutterCost"] = this.primaryCutterCost;
        data["secondaryCutterCost"] = this.secondaryCutterCost;
        data["backupElementCost"] = this.backupElementCost;
        data["powder"] = this.powder ? this.powder.toJSON() : <any>undefined;
        data["binder"] = this.binder ? this.binder.toJSON() : <any>undefined;
        data["hardFacing"] = this.hardFacing ? this.hardFacing.toJSON() : <any>undefined;
        data["matrixToSteel"] = this.matrixToSteel;
        data["upperSection"] = this.upperSection ? this.upperSection.toJSON() : <any>undefined;
        data["isOnePiece"] = this.isOnePiece;
        data["leachingDepth"] = this.leachingDepth;
        data["leachingRID"] = this.leachingRID;
        return data;
    }
}

export interface ICost {
    totalCost?: number;
    primaryCutterCost?: number;
    secondaryCutterCost?: number;
    backupElementCost?: number;
    powder?: ComponentCost;
    binder?: ComponentCost;
    hardFacing?: ComponentCost;
    matrixToSteel?: number | undefined;
    upperSection?: ComponentCost;
    isOnePiece?: boolean;
    leachingDepth?: string | undefined;
    leachingRID?: number | undefined;
}

export class CustomerRequirement implements ICustomerRequirement {
    id?: number;
    name?: string | undefined;
    orderId?: number;

    constructor(data?: ICustomerRequirement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): CustomerRequirement {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRequirement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["orderId"] = this.orderId;
        return data;
    }
}

export interface ICustomerRequirement {
    id?: number;
    name?: string | undefined;
    orderId?: number;
}

export class Cutter implements ICutter {
    id?: number;
    cutterNumber?: number;
    redundantTo?: number;
    facePosition?: string | undefined;
    bladeNumber?: number;
    rowNumber?: number;
    zone?: string | undefined;
    numberOnRow?: number;
    pdcType?: string | undefined;
    pdcCutterName?: string | undefined;
    pdcCutterId?: number;
    cutterId?: number;
    groupNumber?: number;
    groupColor?: string | undefined;
    scribe?: boolean;
    bullet?: boolean;
    diameter?: number;
    length?: number;
    bulletLength?: string | undefined;
    chamfer?: string | undefined;
    isBackupElement?: boolean;
    isBackup?: boolean;
    isOnGauge?: boolean;
    pdcPartFileName?: string | undefined;
    pdcType_regex?: string | undefined;
    allowedChamfer?: string[] | undefined;
    allowedSize?: string[] | undefined;
    allowedPDCTypes?: string[] | undefined;
    pdcCutterTypes?: PDCCutterType[] | undefined;
    modifiedDate?: Date;
    modifiedBy?: number;
    createdBy?: number;
    createdDate?: Date;
    rowCont?: number;
    isFirstPadCutter?: boolean;
    isFirstConeCutter?: boolean;
    isFirstNoseCutter?: boolean;
    isFirstShoulderCutter?: boolean;
    isFirstGageCutter?: boolean;
    sapnumber?: number;
    size?: string | undefined;
    isSelected?: boolean;
    price?: number;
    autoMapper?: boolean;
    impactGeometry?: string | undefined;
    commitChange?: boolean;
    allowChange?: boolean;
    isJuggernaut?: boolean;
    image?: string | undefined;
    geometryText?: string | undefined;
    bucketType?: string | undefined;
    armNumber?: number;

    constructor(data?: ICutter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cutterNumber = _data["cutterNumber"];
            this.redundantTo = _data["redundantTo"];
            this.facePosition = _data["facePosition"];
            this.bladeNumber = _data["bladeNumber"];
            this.rowNumber = _data["rowNumber"];
            this.zone = _data["zone"];
            this.numberOnRow = _data["numberOnRow"];
            this.pdcType = _data["pdcType"];
            this.pdcCutterName = _data["pdcCutterName"];
            this.pdcCutterId = _data["pdcCutterId"];
            this.cutterId = _data["cutterId"];
            this.groupNumber = _data["groupNumber"];
            this.groupColor = _data["groupColor"];
            this.scribe = _data["scribe"];
            this.bullet = _data["bullet"];
            this.diameter = _data["diameter"];
            this.length = _data["length"];
            this.bulletLength = _data["bulletLength"];
            this.chamfer = _data["chamfer"];
            this.isBackupElement = _data["isBackupElement"];
            this.isBackup = _data["isBackup"];
            this.isOnGauge = _data["isOnGauge"];
            this.pdcPartFileName = _data["pdcPartFileName"];
            this.pdcType_regex = _data["pdcType_regex"];
            if (Array.isArray(_data["allowedChamfer"])) {
                this.allowedChamfer = [] as any;
                for (let item of _data["allowedChamfer"])
                    this.allowedChamfer!.push(item);
            }
            if (Array.isArray(_data["allowedSize"])) {
                this.allowedSize = [] as any;
                for (let item of _data["allowedSize"])
                    this.allowedSize!.push(item);
            }
            if (Array.isArray(_data["allowedPDCTypes"])) {
                this.allowedPDCTypes = [] as any;
                for (let item of _data["allowedPDCTypes"])
                    this.allowedPDCTypes!.push(item);
            }
            if (Array.isArray(_data["pdcCutterTypes"])) {
                this.pdcCutterTypes = [] as any;
                for (let item of _data["pdcCutterTypes"])
                    this.pdcCutterTypes!.push(PDCCutterType.fromJS(item));
            }
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.rowCont = _data["rowCont"];
            this.isFirstPadCutter = _data["isFirstPadCutter"];
            this.isFirstConeCutter = _data["isFirstConeCutter"];
            this.isFirstNoseCutter = _data["isFirstNoseCutter"];
            this.isFirstShoulderCutter = _data["isFirstShoulderCutter"];
            this.isFirstGageCutter = _data["isFirstGageCutter"];
            this.sapnumber = _data["sapnumber"];
            this.size = _data["size"];
            this.isSelected = _data["isSelected"];
            this.price = _data["price"];
            this.autoMapper = _data["autoMapper"];
            this.impactGeometry = _data["impactGeometry"];
            this.commitChange = _data["commitChange"];
            this.allowChange = _data["allowChange"];
            this.isJuggernaut = _data["isJuggernaut"];
            this.image = _data["image"];
            this.geometryText = _data["geometryText"];
            this.bucketType = _data["bucketType"];
            this.armNumber = _data["armNumber"];
        }
    }

    static fromJS(data: any): Cutter {
        data = typeof data === 'object' ? data : {};
        let result = new Cutter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cutterNumber"] = this.cutterNumber;
        data["redundantTo"] = this.redundantTo;
        data["facePosition"] = this.facePosition;
        data["bladeNumber"] = this.bladeNumber;
        data["rowNumber"] = this.rowNumber;
        data["zone"] = this.zone;
        data["numberOnRow"] = this.numberOnRow;
        data["pdcType"] = this.pdcType;
        data["pdcCutterName"] = this.pdcCutterName;
        data["pdcCutterId"] = this.pdcCutterId;
        data["cutterId"] = this.cutterId;
        data["groupNumber"] = this.groupNumber;
        data["groupColor"] = this.groupColor;
        data["scribe"] = this.scribe;
        data["bullet"] = this.bullet;
        data["diameter"] = this.diameter;
        data["length"] = this.length;
        data["bulletLength"] = this.bulletLength;
        data["chamfer"] = this.chamfer;
        data["isBackupElement"] = this.isBackupElement;
        data["isBackup"] = this.isBackup;
        data["isOnGauge"] = this.isOnGauge;
        data["pdcPartFileName"] = this.pdcPartFileName;
        data["pdcType_regex"] = this.pdcType_regex;
        if (Array.isArray(this.allowedChamfer)) {
            data["allowedChamfer"] = [];
            for (let item of this.allowedChamfer)
                data["allowedChamfer"].push(item);
        }
        if (Array.isArray(this.allowedSize)) {
            data["allowedSize"] = [];
            for (let item of this.allowedSize)
                data["allowedSize"].push(item);
        }
        if (Array.isArray(this.allowedPDCTypes)) {
            data["allowedPDCTypes"] = [];
            for (let item of this.allowedPDCTypes)
                data["allowedPDCTypes"].push(item);
        }
        if (Array.isArray(this.pdcCutterTypes)) {
            data["pdcCutterTypes"] = [];
            for (let item of this.pdcCutterTypes)
                data["pdcCutterTypes"].push(item.toJSON());
        }
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["rowCont"] = this.rowCont;
        data["isFirstPadCutter"] = this.isFirstPadCutter;
        data["isFirstConeCutter"] = this.isFirstConeCutter;
        data["isFirstNoseCutter"] = this.isFirstNoseCutter;
        data["isFirstShoulderCutter"] = this.isFirstShoulderCutter;
        data["isFirstGageCutter"] = this.isFirstGageCutter;
        data["sapnumber"] = this.sapnumber;
        data["size"] = this.size;
        data["isSelected"] = this.isSelected;
        data["price"] = this.price;
        data["autoMapper"] = this.autoMapper;
        data["impactGeometry"] = this.impactGeometry;
        data["commitChange"] = this.commitChange;
        data["allowChange"] = this.allowChange;
        data["isJuggernaut"] = this.isJuggernaut;
        data["image"] = this.image;
        data["geometryText"] = this.geometryText;
        data["bucketType"] = this.bucketType;
        data["armNumber"] = this.armNumber;
        return data;
    }
}

export interface ICutter {
    id?: number;
    cutterNumber?: number;
    redundantTo?: number;
    facePosition?: string | undefined;
    bladeNumber?: number;
    rowNumber?: number;
    zone?: string | undefined;
    numberOnRow?: number;
    pdcType?: string | undefined;
    pdcCutterName?: string | undefined;
    pdcCutterId?: number;
    cutterId?: number;
    groupNumber?: number;
    groupColor?: string | undefined;
    scribe?: boolean;
    bullet?: boolean;
    diameter?: number;
    length?: number;
    bulletLength?: string | undefined;
    chamfer?: string | undefined;
    isBackupElement?: boolean;
    isBackup?: boolean;
    isOnGauge?: boolean;
    pdcPartFileName?: string | undefined;
    pdcType_regex?: string | undefined;
    allowedChamfer?: string[] | undefined;
    allowedSize?: string[] | undefined;
    allowedPDCTypes?: string[] | undefined;
    pdcCutterTypes?: PDCCutterType[] | undefined;
    modifiedDate?: Date;
    modifiedBy?: number;
    createdBy?: number;
    createdDate?: Date;
    rowCont?: number;
    isFirstPadCutter?: boolean;
    isFirstConeCutter?: boolean;
    isFirstNoseCutter?: boolean;
    isFirstShoulderCutter?: boolean;
    isFirstGageCutter?: boolean;
    sapnumber?: number;
    size?: string | undefined;
    isSelected?: boolean;
    price?: number;
    autoMapper?: boolean;
    impactGeometry?: string | undefined;
    commitChange?: boolean;
    allowChange?: boolean;
    isJuggernaut?: boolean;
    image?: string | undefined;
    geometryText?: string | undefined;
    bucketType?: string | undefined;
    armNumber?: number;
}

export class CutterGroup implements ICutterGroup {
    isBackupElement?: boolean;
    pdcType?: string | undefined;
    count?: number;
    groupClass?: string | undefined;
    classGeo?: string | undefined;
    groupNumber?: number;
    chamfer?: string | undefined;
    pdcCutterType?: string | undefined;
    sapMaterialNumber?: number;
    aDesc_Count?: number;
    allowChange?: boolean;
    allowedCutters?: PDCCutterType[] | undefined;
    bucketType?: string | undefined;
    pdccUtterID?: number;
    pdcType_regex?: string | undefined;

    constructor(data?: ICutterGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isBackupElement = _data["isBackupElement"];
            this.pdcType = _data["pdcType"];
            this.count = _data["count"];
            this.groupClass = _data["groupClass"];
            this.classGeo = _data["classGeo"];
            this.groupNumber = _data["groupNumber"];
            this.chamfer = _data["chamfer"];
            this.pdcCutterType = _data["pdcCutterType"];
            this.sapMaterialNumber = _data["sapMaterialNumber"];
            this.aDesc_Count = _data["aDesc_Count"];
            this.allowChange = _data["allowChange"];
            if (Array.isArray(_data["allowedCutters"])) {
                this.allowedCutters = [] as any;
                for (let item of _data["allowedCutters"])
                    this.allowedCutters!.push(PDCCutterType.fromJS(item));
            }
            this.bucketType = _data["bucketType"];
            this.pdccUtterID = _data["pdccUtterID"];
            this.pdcType_regex = _data["pdcType_regex"];
        }
    }

    static fromJS(data: any): CutterGroup {
        data = typeof data === 'object' ? data : {};
        let result = new CutterGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isBackupElement"] = this.isBackupElement;
        data["pdcType"] = this.pdcType;
        data["count"] = this.count;
        data["groupClass"] = this.groupClass;
        data["classGeo"] = this.classGeo;
        data["groupNumber"] = this.groupNumber;
        data["chamfer"] = this.chamfer;
        data["pdcCutterType"] = this.pdcCutterType;
        data["sapMaterialNumber"] = this.sapMaterialNumber;
        data["aDesc_Count"] = this.aDesc_Count;
        data["allowChange"] = this.allowChange;
        if (Array.isArray(this.allowedCutters)) {
            data["allowedCutters"] = [];
            for (let item of this.allowedCutters)
                data["allowedCutters"].push(item.toJSON());
        }
        data["bucketType"] = this.bucketType;
        data["pdccUtterID"] = this.pdccUtterID;
        data["pdcType_regex"] = this.pdcType_regex;
        return data;
    }
}

export interface ICutterGroup {
    isBackupElement?: boolean;
    pdcType?: string | undefined;
    count?: number;
    groupClass?: string | undefined;
    classGeo?: string | undefined;
    groupNumber?: number;
    chamfer?: string | undefined;
    pdcCutterType?: string | undefined;
    sapMaterialNumber?: number;
    aDesc_Count?: number;
    allowChange?: boolean;
    allowedCutters?: PDCCutterType[] | undefined;
    bucketType?: string | undefined;
    pdccUtterID?: number;
    pdcType_regex?: string | undefined;
}

export class CutterMap implements ICutterMap {
    valid?: boolean;
    subPsl?: string | undefined;
    availableCutters?: PDCCutterType[] | undefined;
    cutters?: Cutter[] | undefined;
    cutterGroups?: CutterGroup[] | undefined;
    cutterModels?: Blade[] | undefined;
    readonly blades?: Blade[] | undefined;
    readonly primaryPDCType?: string | undefined;
    readonly primaryPDCCutterTypes?: PDCCutterType[] | undefined;
    readonly backupPDCType?: string | undefined;
    readonly backupPDCCutterTypes?: PDCCutterType[] | undefined;
    chamfers?: string[] | undefined;
    zones?: Zone[] | undefined;
    leachDepth?: string | undefined;

    constructor(data?: ICutterMap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valid = _data["valid"];
            this.subPsl = _data["subPsl"];
            if (Array.isArray(_data["availableCutters"])) {
                this.availableCutters = [] as any;
                for (let item of _data["availableCutters"])
                    this.availableCutters!.push(PDCCutterType.fromJS(item));
            }
            if (Array.isArray(_data["cutters"])) {
                this.cutters = [] as any;
                for (let item of _data["cutters"])
                    this.cutters!.push(Cutter.fromJS(item));
            }
            if (Array.isArray(_data["cutterGroups"])) {
                this.cutterGroups = [] as any;
                for (let item of _data["cutterGroups"])
                    this.cutterGroups!.push(CutterGroup.fromJS(item));
            }
            if (Array.isArray(_data["cutterModels"])) {
                this.cutterModels = [] as any;
                for (let item of _data["cutterModels"])
                    this.cutterModels!.push(Blade.fromJS(item));
            }
            if (Array.isArray(_data["blades"])) {
                (<any>this).blades = [] as any;
                for (let item of _data["blades"])
                    (<any>this).blades!.push(Blade.fromJS(item));
            }
            (<any>this).primaryPDCType = _data["primaryPDCType"];
            if (Array.isArray(_data["primaryPDCCutterTypes"])) {
                (<any>this).primaryPDCCutterTypes = [] as any;
                for (let item of _data["primaryPDCCutterTypes"])
                    (<any>this).primaryPDCCutterTypes!.push(PDCCutterType.fromJS(item));
            }
            (<any>this).backupPDCType = _data["backupPDCType"];
            if (Array.isArray(_data["backupPDCCutterTypes"])) {
                (<any>this).backupPDCCutterTypes = [] as any;
                for (let item of _data["backupPDCCutterTypes"])
                    (<any>this).backupPDCCutterTypes!.push(PDCCutterType.fromJS(item));
            }
            if (Array.isArray(_data["chamfers"])) {
                this.chamfers = [] as any;
                for (let item of _data["chamfers"])
                    this.chamfers!.push(item);
            }
            if (Array.isArray(_data["zones"])) {
                this.zones = [] as any;
                for (let item of _data["zones"])
                    this.zones!.push(Zone.fromJS(item));
            }
            this.leachDepth = _data["leachDepth"];
        }
    }

    static fromJS(data: any): CutterMap {
        data = typeof data === 'object' ? data : {};
        let result = new CutterMap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valid"] = this.valid;
        data["subPsl"] = this.subPsl;
        if (Array.isArray(this.availableCutters)) {
            data["availableCutters"] = [];
            for (let item of this.availableCutters)
                data["availableCutters"].push(item.toJSON());
        }
        if (Array.isArray(this.cutters)) {
            data["cutters"] = [];
            for (let item of this.cutters)
                data["cutters"].push(item.toJSON());
        }
        if (Array.isArray(this.cutterGroups)) {
            data["cutterGroups"] = [];
            for (let item of this.cutterGroups)
                data["cutterGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.cutterModels)) {
            data["cutterModels"] = [];
            for (let item of this.cutterModels)
                data["cutterModels"].push(item.toJSON());
        }
        if (Array.isArray(this.blades)) {
            data["blades"] = [];
            for (let item of this.blades)
                data["blades"].push(item.toJSON());
        }
        data["primaryPDCType"] = this.primaryPDCType;
        if (Array.isArray(this.primaryPDCCutterTypes)) {
            data["primaryPDCCutterTypes"] = [];
            for (let item of this.primaryPDCCutterTypes)
                data["primaryPDCCutterTypes"].push(item.toJSON());
        }
        data["backupPDCType"] = this.backupPDCType;
        if (Array.isArray(this.backupPDCCutterTypes)) {
            data["backupPDCCutterTypes"] = [];
            for (let item of this.backupPDCCutterTypes)
                data["backupPDCCutterTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.chamfers)) {
            data["chamfers"] = [];
            for (let item of this.chamfers)
                data["chamfers"].push(item);
        }
        if (Array.isArray(this.zones)) {
            data["zones"] = [];
            for (let item of this.zones)
                data["zones"].push(item.toJSON());
        }
        data["leachDepth"] = this.leachDepth;
        return data;
    }
}

export interface ICutterMap {
    valid?: boolean;
    subPsl?: string | undefined;
    availableCutters?: PDCCutterType[] | undefined;
    cutters?: Cutter[] | undefined;
    cutterGroups?: CutterGroup[] | undefined;
    cutterModels?: Blade[] | undefined;
    blades?: Blade[] | undefined;
    primaryPDCType?: string | undefined;
    primaryPDCCutterTypes?: PDCCutterType[] | undefined;
    backupPDCType?: string | undefined;
    backupPDCCutterTypes?: PDCCutterType[] | undefined;
    chamfers?: string[] | undefined;
    zones?: Zone[] | undefined;
    leachDepth?: string | undefined;
}

export class DecimalLimits implements IDecimalLimits {
    upper?: number;
    lower?: number;

    constructor(data?: IDecimalLimits) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.upper = _data["upper"];
            this.lower = _data["lower"];
        }
    }

    static fromJS(data: any): DecimalLimits {
        data = typeof data === 'object' ? data : {};
        let result = new DecimalLimits();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["upper"] = this.upper;
        data["lower"] = this.lower;
        return data;
    }
}

export interface IDecimalLimits {
    upper?: number;
    lower?: number;
}

export class DrawingLog implements IDrawingLog {
    id?: number;
    drawingType?: string | undefined;
    size?: number | undefined;
    type?: string | undefined;
    description?: string | undefined;
    createdBy?: number;
    createDate?: Date;
    rtaNum?: number | undefined;
    pnaPartId?: number | undefined;
    user?: User;
    standardJunkSlotMolds?: StandardJunkSlotMold[] | undefined;
    restrictors?: Restrictor[] | undefined;
    drawingLogOrderAssociations?: Bom_DrawingLogOrderAssociation[] | undefined;
    pnA_Part?: PNA_Part;

    constructor(data?: IDrawingLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.drawingType = _data["drawingType"];
            this.size = _data["size"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.createdBy = _data["createdBy"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.rtaNum = _data["rtaNum"];
            this.pnaPartId = _data["pnaPartId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["standardJunkSlotMolds"])) {
                this.standardJunkSlotMolds = [] as any;
                for (let item of _data["standardJunkSlotMolds"])
                    this.standardJunkSlotMolds!.push(StandardJunkSlotMold.fromJS(item));
            }
            if (Array.isArray(_data["restrictors"])) {
                this.restrictors = [] as any;
                for (let item of _data["restrictors"])
                    this.restrictors!.push(Restrictor.fromJS(item));
            }
            if (Array.isArray(_data["drawingLogOrderAssociations"])) {
                this.drawingLogOrderAssociations = [] as any;
                for (let item of _data["drawingLogOrderAssociations"])
                    this.drawingLogOrderAssociations!.push(Bom_DrawingLogOrderAssociation.fromJS(item));
            }
            this.pnA_Part = _data["pnA_Part"] ? PNA_Part.fromJS(_data["pnA_Part"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DrawingLog {
        data = typeof data === 'object' ? data : {};
        let result = new DrawingLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["drawingType"] = this.drawingType;
        data["size"] = this.size;
        data["type"] = this.type;
        data["description"] = this.description;
        data["createdBy"] = this.createdBy;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["rtaNum"] = this.rtaNum;
        data["pnaPartId"] = this.pnaPartId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.standardJunkSlotMolds)) {
            data["standardJunkSlotMolds"] = [];
            for (let item of this.standardJunkSlotMolds)
                data["standardJunkSlotMolds"].push(item.toJSON());
        }
        if (Array.isArray(this.restrictors)) {
            data["restrictors"] = [];
            for (let item of this.restrictors)
                data["restrictors"].push(item.toJSON());
        }
        if (Array.isArray(this.drawingLogOrderAssociations)) {
            data["drawingLogOrderAssociations"] = [];
            for (let item of this.drawingLogOrderAssociations)
                data["drawingLogOrderAssociations"].push(item.toJSON());
        }
        data["pnA_Part"] = this.pnA_Part ? this.pnA_Part.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDrawingLog {
    id?: number;
    drawingType?: string | undefined;
    size?: number | undefined;
    type?: string | undefined;
    description?: string | undefined;
    createdBy?: number;
    createDate?: Date;
    rtaNum?: number | undefined;
    pnaPartId?: number | undefined;
    user?: User;
    standardJunkSlotMolds?: StandardJunkSlotMold[] | undefined;
    restrictors?: Restrictor[] | undefined;
    drawingLogOrderAssociations?: Bom_DrawingLogOrderAssociation[] | undefined;
    pnA_Part?: PNA_Part;
}

export class ECN implements IECN {
    rtaNum?: number;
    drawingNumber?: string | undefined;
    revisionLevel?: string | undefined;
    revisionDescription?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    beforeRTA?: boolean | undefined;
    fileId?: number | undefined;
    id?: number;
    requestSAPUpdate?: boolean | undefined;
    requestDate?: Date | undefined;
    file?: FileVault_File;

    constructor(data?: IECN) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rtaNum = _data["rtaNum"];
            this.drawingNumber = _data["drawingNumber"];
            this.revisionLevel = _data["revisionLevel"];
            this.revisionDescription = _data["revisionDescription"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.beforeRTA = _data["beforeRTA"];
            this.fileId = _data["fileId"];
            this.id = _data["id"];
            this.requestSAPUpdate = _data["requestSAPUpdate"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.file = _data["file"] ? FileVault_File.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ECN {
        data = typeof data === 'object' ? data : {};
        let result = new ECN();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rtaNum"] = this.rtaNum;
        data["drawingNumber"] = this.drawingNumber;
        data["revisionLevel"] = this.revisionLevel;
        data["revisionDescription"] = this.revisionDescription;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["beforeRTA"] = this.beforeRTA;
        data["fileId"] = this.fileId;
        data["id"] = this.id;
        data["requestSAPUpdate"] = this.requestSAPUpdate;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }
}

export interface IECN {
    rtaNum?: number;
    drawingNumber?: string | undefined;
    revisionLevel?: string | undefined;
    revisionDescription?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    beforeRTA?: boolean | undefined;
    fileId?: number | undefined;
    id?: number;
    requestSAPUpdate?: boolean | undefined;
    requestDate?: Date | undefined;
    file?: FileVault_File;
}

export class Electronic implements IElectronic {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    permissionLock?: boolean;
    isObsolete?: boolean;
    orD_Uppersection?: ORD_Uppersection[] | undefined;
    upperSections?: Uppersection[] | undefined;

    constructor(data?: IElectronic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.permissionLock = _data["permissionLock"];
            this.isObsolete = _data["isObsolete"];
            if (Array.isArray(_data["orD_Uppersection"])) {
                this.orD_Uppersection = [] as any;
                for (let item of _data["orD_Uppersection"])
                    this.orD_Uppersection!.push(ORD_Uppersection.fromJS(item));
            }
            if (Array.isArray(_data["upperSections"])) {
                this.upperSections = [] as any;
                for (let item of _data["upperSections"])
                    this.upperSections!.push(Uppersection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Electronic {
        data = typeof data === 'object' ? data : {};
        let result = new Electronic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["permissionLock"] = this.permissionLock;
        data["isObsolete"] = this.isObsolete;
        if (Array.isArray(this.orD_Uppersection)) {
            data["orD_Uppersection"] = [];
            for (let item of this.orD_Uppersection)
                data["orD_Uppersection"].push(item.toJSON());
        }
        if (Array.isArray(this.upperSections)) {
            data["upperSections"] = [];
            for (let item of this.upperSections)
                data["upperSections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IElectronic {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    permissionLock?: boolean;
    isObsolete?: boolean;
    orD_Uppersection?: ORD_Uppersection[] | undefined;
    upperSections?: Uppersection[] | undefined;
}

export class EquipmentTemplateRequest implements IEquipmentTemplateRequest {
    target_Id?: number;
    userId?: number;

    constructor(data?: IEquipmentTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.target_Id = _data["target_Id"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): EquipmentTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["target_Id"] = this.target_Id;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IEquipmentTemplateRequest {
    target_Id?: number;
    userId?: number;
}

export class EstimatedCostSavings implements IEstimatedCostSavings {
    orderId?: number;
    reference?: Cost;
    rta?: Cost;
    technicalJustification?: string | undefined;
    totalSavings?: number;

    constructor(data?: IEstimatedCostSavings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.reference = _data["reference"] ? Cost.fromJS(_data["reference"]) : <any>undefined;
            this.rta = _data["rta"] ? Cost.fromJS(_data["rta"]) : <any>undefined;
            this.technicalJustification = _data["technicalJustification"];
            this.totalSavings = _data["totalSavings"];
        }
    }

    static fromJS(data: any): EstimatedCostSavings {
        data = typeof data === 'object' ? data : {};
        let result = new EstimatedCostSavings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["reference"] = this.reference ? this.reference.toJSON() : <any>undefined;
        data["rta"] = this.rta ? this.rta.toJSON() : <any>undefined;
        data["technicalJustification"] = this.technicalJustification;
        data["totalSavings"] = this.totalSavings;
        return data;
    }
}

export interface IEstimatedCostSavings {
    orderId?: number;
    reference?: Cost;
    rta?: Cost;
    technicalJustification?: string | undefined;
    totalSavings?: number;
}

export class Features implements IFeatures {
    id?: number;
    code?: string | undefined;
    letter?: string | undefined;
    english?: string | undefined;
    spanish?: string | undefined;
    russian?: string | undefined;
    portuguese?: string | undefined;
    subPSL?: string | undefined;
    subHeader?: string | undefined;
    subLevel?: string | undefined;
    bitSeries?: string | undefined;
    isSelectedInRTA?: boolean | undefined;
    isDisplayedInMarketingSheet?: boolean | undefined;
    isCalculatedByDefault?: boolean | undefined;
    isCostSavingFeature?: boolean | undefined;
    isObsolete?: boolean;
    orderFeatureAssociations?: OrderFeatureAssociation[] | undefined;
    fileFeatures?: FileVault_FileFeature[] | undefined;
    specialInstructions?: SpecialInstruction[] | undefined;
    bitOption?: BitOption;

    constructor(data?: IFeatures) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.letter = _data["letter"];
            this.english = _data["english"];
            this.spanish = _data["spanish"];
            this.russian = _data["russian"];
            this.portuguese = _data["portuguese"];
            this.subPSL = _data["subPSL"];
            this.subHeader = _data["subHeader"];
            this.subLevel = _data["subLevel"];
            this.bitSeries = _data["bitSeries"];
            this.isSelectedInRTA = _data["isSelectedInRTA"];
            this.isDisplayedInMarketingSheet = _data["isDisplayedInMarketingSheet"];
            this.isCalculatedByDefault = _data["isCalculatedByDefault"];
            this.isCostSavingFeature = _data["isCostSavingFeature"];
            this.isObsolete = _data["isObsolete"];
            if (Array.isArray(_data["orderFeatureAssociations"])) {
                this.orderFeatureAssociations = [] as any;
                for (let item of _data["orderFeatureAssociations"])
                    this.orderFeatureAssociations!.push(OrderFeatureAssociation.fromJS(item));
            }
            if (Array.isArray(_data["fileFeatures"])) {
                this.fileFeatures = [] as any;
                for (let item of _data["fileFeatures"])
                    this.fileFeatures!.push(FileVault_FileFeature.fromJS(item));
            }
            if (Array.isArray(_data["specialInstructions"])) {
                this.specialInstructions = [] as any;
                for (let item of _data["specialInstructions"])
                    this.specialInstructions!.push(SpecialInstruction.fromJS(item));
            }
            this.bitOption = _data["bitOption"] ? BitOption.fromJS(_data["bitOption"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Features {
        data = typeof data === 'object' ? data : {};
        let result = new Features();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["letter"] = this.letter;
        data["english"] = this.english;
        data["spanish"] = this.spanish;
        data["russian"] = this.russian;
        data["portuguese"] = this.portuguese;
        data["subPSL"] = this.subPSL;
        data["subHeader"] = this.subHeader;
        data["subLevel"] = this.subLevel;
        data["bitSeries"] = this.bitSeries;
        data["isSelectedInRTA"] = this.isSelectedInRTA;
        data["isDisplayedInMarketingSheet"] = this.isDisplayedInMarketingSheet;
        data["isCalculatedByDefault"] = this.isCalculatedByDefault;
        data["isCostSavingFeature"] = this.isCostSavingFeature;
        data["isObsolete"] = this.isObsolete;
        if (Array.isArray(this.orderFeatureAssociations)) {
            data["orderFeatureAssociations"] = [];
            for (let item of this.orderFeatureAssociations)
                data["orderFeatureAssociations"].push(item.toJSON());
        }
        if (Array.isArray(this.fileFeatures)) {
            data["fileFeatures"] = [];
            for (let item of this.fileFeatures)
                data["fileFeatures"].push(item.toJSON());
        }
        if (Array.isArray(this.specialInstructions)) {
            data["specialInstructions"] = [];
            for (let item of this.specialInstructions)
                data["specialInstructions"].push(item.toJSON());
        }
        data["bitOption"] = this.bitOption ? this.bitOption.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeatures {
    id?: number;
    code?: string | undefined;
    letter?: string | undefined;
    english?: string | undefined;
    spanish?: string | undefined;
    russian?: string | undefined;
    portuguese?: string | undefined;
    subPSL?: string | undefined;
    subHeader?: string | undefined;
    subLevel?: string | undefined;
    bitSeries?: string | undefined;
    isSelectedInRTA?: boolean | undefined;
    isDisplayedInMarketingSheet?: boolean | undefined;
    isCalculatedByDefault?: boolean | undefined;
    isCostSavingFeature?: boolean | undefined;
    isObsolete?: boolean;
    orderFeatureAssociations?: OrderFeatureAssociation[] | undefined;
    fileFeatures?: FileVault_FileFeature[] | undefined;
    specialInstructions?: SpecialInstruction[] | undefined;
    bitOption?: BitOption;
}

export class Field_MudType implements IField_MudType {
    id?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    applications?: Application[] | undefined;
    orders?: ORD_Order[] | undefined;

    constructor(data?: IField_MudType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(Application.fromJS(item));
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(ORD_Order.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Field_MudType {
        data = typeof data === 'object' ? data : {};
        let result = new Field_MudType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IField_MudType {
    id?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    applications?: Application[] | undefined;
    orders?: ORD_Order[] | undefined;
}

export class FileThumbnail implements IFileThumbnail {
    id?: number;
    fileId?: number;
    thumbnail_Base64?: string | undefined;
    file?: FileVault_File;

    constructor(data?: IFileThumbnail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.thumbnail_Base64 = _data["thumbnail_Base64"];
            this.file = _data["file"] ? FileVault_File.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileThumbnail {
        data = typeof data === 'object' ? data : {};
        let result = new FileThumbnail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["thumbnail_Base64"] = this.thumbnail_Base64;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileThumbnail {
    id?: number;
    fileId?: number;
    thumbnail_Base64?: string | undefined;
    file?: FileVault_File;
}

export class FileVaultListItem implements IFileVaultListItem {
    id?: number;
    fileName?: string | undefined;
    revision?: string | undefined;
    status?: string | undefined;
    action?: string | undefined;
    description?: string | undefined;
    delete?: string | undefined;
    download?: string | undefined;
    globalView?: string | undefined;
    dateUploaded?: string | undefined;
    beingRevised?: boolean;
    linked?: boolean;
    link?: string | undefined;
    destinationID?: number;
    canEdit?: boolean;
    preview?: string | undefined;
    features?: number[] | undefined;
    featureTags?: string | undefined;
    missingLinkage?: boolean;
    thumbnail?: string | undefined;
    fullPath?: string | undefined;
    isBlob?: boolean;

    constructor(data?: IFileVaultListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.revision = _data["revision"];
            this.status = _data["status"];
            this.action = _data["action"];
            this.description = _data["description"];
            this.delete = _data["delete"];
            this.download = _data["download"];
            this.globalView = _data["globalView"];
            this.dateUploaded = _data["dateUploaded"];
            this.beingRevised = _data["beingRevised"];
            this.linked = _data["linked"];
            this.link = _data["link"];
            this.destinationID = _data["destinationID"];
            this.canEdit = _data["canEdit"];
            this.preview = _data["preview"];
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(item);
            }
            this.featureTags = _data["featureTags"];
            this.missingLinkage = _data["missingLinkage"];
            this.thumbnail = _data["thumbnail"];
            this.fullPath = _data["fullPath"];
            this.isBlob = _data["isBlob"];
        }
    }

    static fromJS(data: any): FileVaultListItem {
        data = typeof data === 'object' ? data : {};
        let result = new FileVaultListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["revision"] = this.revision;
        data["status"] = this.status;
        data["action"] = this.action;
        data["description"] = this.description;
        data["delete"] = this.delete;
        data["download"] = this.download;
        data["globalView"] = this.globalView;
        data["dateUploaded"] = this.dateUploaded;
        data["beingRevised"] = this.beingRevised;
        data["linked"] = this.linked;
        data["link"] = this.link;
        data["destinationID"] = this.destinationID;
        data["canEdit"] = this.canEdit;
        data["preview"] = this.preview;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item);
        }
        data["featureTags"] = this.featureTags;
        data["missingLinkage"] = this.missingLinkage;
        data["thumbnail"] = this.thumbnail;
        data["fullPath"] = this.fullPath;
        data["isBlob"] = this.isBlob;
        return data;
    }
}

export interface IFileVaultListItem {
    id?: number;
    fileName?: string | undefined;
    revision?: string | undefined;
    status?: string | undefined;
    action?: string | undefined;
    description?: string | undefined;
    delete?: string | undefined;
    download?: string | undefined;
    globalView?: string | undefined;
    dateUploaded?: string | undefined;
    beingRevised?: boolean;
    linked?: boolean;
    link?: string | undefined;
    destinationID?: number;
    canEdit?: boolean;
    preview?: string | undefined;
    features?: number[] | undefined;
    featureTags?: string | undefined;
    missingLinkage?: boolean;
    thumbnail?: string | undefined;
    fullPath?: string | undefined;
    isBlob?: boolean;
}

export class FileVault_AllowedFileExtension implements IFileVault_AllowedFileExtension {
    id?: number;
    fileTypeDirectoryID?: number;
    extensionTypeID?: number;
    extensionType?: FileVault_ExtensionType;
    fileTypeDirectory?: FileVault_FileTypeDirectory;

    constructor(data?: IFileVault_AllowedFileExtension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileTypeDirectoryID = _data["fileTypeDirectoryID"];
            this.extensionTypeID = _data["extensionTypeID"];
            this.extensionType = _data["extensionType"] ? FileVault_ExtensionType.fromJS(_data["extensionType"]) : <any>undefined;
            this.fileTypeDirectory = _data["fileTypeDirectory"] ? FileVault_FileTypeDirectory.fromJS(_data["fileTypeDirectory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileVault_AllowedFileExtension {
        data = typeof data === 'object' ? data : {};
        let result = new FileVault_AllowedFileExtension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileTypeDirectoryID"] = this.fileTypeDirectoryID;
        data["extensionTypeID"] = this.extensionTypeID;
        data["extensionType"] = this.extensionType ? this.extensionType.toJSON() : <any>undefined;
        data["fileTypeDirectory"] = this.fileTypeDirectory ? this.fileTypeDirectory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileVault_AllowedFileExtension {
    id?: number;
    fileTypeDirectoryID?: number;
    extensionTypeID?: number;
    extensionType?: FileVault_ExtensionType;
    fileTypeDirectory?: FileVault_FileTypeDirectory;
}

export class FileVault_ApplicationFile implements IFileVault_ApplicationFile {
    id?: number;
    applicationTypeId?: number;
    targetId?: number;
    fileId?: number;
    deletionFlag?: boolean;
    modifiedDate?: Date | undefined;
    modifiedUserId?: number | undefined;
    isGlobalView?: boolean | undefined;
    fileTypeDir_Id?: number | undefined;
    user?: User;
    applicationType?: FileVault_ApplicationType;
    file?: FileVault_File;
    fileTypeDirectory?: FileVault_FileTypeDirectory;

    constructor(data?: IFileVault_ApplicationFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationTypeId = _data["applicationTypeId"];
            this.targetId = _data["targetId"];
            this.fileId = _data["fileId"];
            this.deletionFlag = _data["deletionFlag"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.modifiedUserId = _data["modifiedUserId"];
            this.isGlobalView = _data["isGlobalView"];
            this.fileTypeDir_Id = _data["fileTypeDir_Id"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.applicationType = _data["applicationType"] ? FileVault_ApplicationType.fromJS(_data["applicationType"]) : <any>undefined;
            this.file = _data["file"] ? FileVault_File.fromJS(_data["file"]) : <any>undefined;
            this.fileTypeDirectory = _data["fileTypeDirectory"] ? FileVault_FileTypeDirectory.fromJS(_data["fileTypeDirectory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileVault_ApplicationFile {
        data = typeof data === 'object' ? data : {};
        let result = new FileVault_ApplicationFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationTypeId"] = this.applicationTypeId;
        data["targetId"] = this.targetId;
        data["fileId"] = this.fileId;
        data["deletionFlag"] = this.deletionFlag;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["modifiedUserId"] = this.modifiedUserId;
        data["isGlobalView"] = this.isGlobalView;
        data["fileTypeDir_Id"] = this.fileTypeDir_Id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["applicationType"] = this.applicationType ? this.applicationType.toJSON() : <any>undefined;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["fileTypeDirectory"] = this.fileTypeDirectory ? this.fileTypeDirectory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileVault_ApplicationFile {
    id?: number;
    applicationTypeId?: number;
    targetId?: number;
    fileId?: number;
    deletionFlag?: boolean;
    modifiedDate?: Date | undefined;
    modifiedUserId?: number | undefined;
    isGlobalView?: boolean | undefined;
    fileTypeDir_Id?: number | undefined;
    user?: User;
    applicationType?: FileVault_ApplicationType;
    file?: FileVault_File;
    fileTypeDirectory?: FileVault_FileTypeDirectory;
}

export class FileVault_ApplicationType implements IFileVault_ApplicationType {
    id?: number;
    name?: string | undefined;
    fileTypeDirectoryId?: number;
    fileTypeDirectory?: FileVault_FileTypeDirectory;
    applicationFiles?: FileVault_ApplicationFile[] | undefined;

    constructor(data?: IFileVault_ApplicationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fileTypeDirectoryId = _data["fileTypeDirectoryId"];
            this.fileTypeDirectory = _data["fileTypeDirectory"] ? FileVault_FileTypeDirectory.fromJS(_data["fileTypeDirectory"]) : <any>undefined;
            if (Array.isArray(_data["applicationFiles"])) {
                this.applicationFiles = [] as any;
                for (let item of _data["applicationFiles"])
                    this.applicationFiles!.push(FileVault_ApplicationFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileVault_ApplicationType {
        data = typeof data === 'object' ? data : {};
        let result = new FileVault_ApplicationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fileTypeDirectoryId"] = this.fileTypeDirectoryId;
        data["fileTypeDirectory"] = this.fileTypeDirectory ? this.fileTypeDirectory.toJSON() : <any>undefined;
        if (Array.isArray(this.applicationFiles)) {
            data["applicationFiles"] = [];
            for (let item of this.applicationFiles)
                data["applicationFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileVault_ApplicationType {
    id?: number;
    name?: string | undefined;
    fileTypeDirectoryId?: number;
    fileTypeDirectory?: FileVault_FileTypeDirectory;
    applicationFiles?: FileVault_ApplicationFile[] | undefined;
}

export class FileVault_DirectoryPermission implements IFileVault_DirectoryPermission {
    id?: number;
    userId?: number;
    fileTypeDirectoryId?: number | undefined;
    active?: boolean;
    c_Read?: boolean;
    c_Write?: boolean;
    c_Delete?: boolean;
    c_WriteFile?: boolean;
    c_DeleteFile?: boolean;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    c_WriteFileWoApproval?: boolean;
    subServerPathId?: number | undefined;
    serverPathId?: number | undefined;
    fullPath?: string | undefined;
    createdBy_User?: User;
    modifiedBy_User?: User;
    user?: User;
    fileTypeDirectory?: FileVault_FileTypeDirectory;
    serverPath?: FileVault_ServerPath;
    serverSubPath?: FileVault_ServerSubPath;

    constructor(data?: IFileVault_DirectoryPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.fileTypeDirectoryId = _data["fileTypeDirectoryId"];
            this.active = _data["active"];
            this.c_Read = _data["c_Read"];
            this.c_Write = _data["c_Write"];
            this.c_Delete = _data["c_Delete"];
            this.c_WriteFile = _data["c_WriteFile"];
            this.c_DeleteFile = _data["c_DeleteFile"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.c_WriteFileWoApproval = _data["c_WriteFileWoApproval"];
            this.subServerPathId = _data["subServerPathId"];
            this.serverPathId = _data["serverPathId"];
            this.fullPath = _data["fullPath"];
            this.createdBy_User = _data["createdBy_User"] ? User.fromJS(_data["createdBy_User"]) : <any>undefined;
            this.modifiedBy_User = _data["modifiedBy_User"] ? User.fromJS(_data["modifiedBy_User"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.fileTypeDirectory = _data["fileTypeDirectory"] ? FileVault_FileTypeDirectory.fromJS(_data["fileTypeDirectory"]) : <any>undefined;
            this.serverPath = _data["serverPath"] ? FileVault_ServerPath.fromJS(_data["serverPath"]) : <any>undefined;
            this.serverSubPath = _data["serverSubPath"] ? FileVault_ServerSubPath.fromJS(_data["serverSubPath"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileVault_DirectoryPermission {
        data = typeof data === 'object' ? data : {};
        let result = new FileVault_DirectoryPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["fileTypeDirectoryId"] = this.fileTypeDirectoryId;
        data["active"] = this.active;
        data["c_Read"] = this.c_Read;
        data["c_Write"] = this.c_Write;
        data["c_Delete"] = this.c_Delete;
        data["c_WriteFile"] = this.c_WriteFile;
        data["c_DeleteFile"] = this.c_DeleteFile;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["c_WriteFileWoApproval"] = this.c_WriteFileWoApproval;
        data["subServerPathId"] = this.subServerPathId;
        data["serverPathId"] = this.serverPathId;
        data["fullPath"] = this.fullPath;
        data["createdBy_User"] = this.createdBy_User ? this.createdBy_User.toJSON() : <any>undefined;
        data["modifiedBy_User"] = this.modifiedBy_User ? this.modifiedBy_User.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["fileTypeDirectory"] = this.fileTypeDirectory ? this.fileTypeDirectory.toJSON() : <any>undefined;
        data["serverPath"] = this.serverPath ? this.serverPath.toJSON() : <any>undefined;
        data["serverSubPath"] = this.serverSubPath ? this.serverSubPath.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileVault_DirectoryPermission {
    id?: number;
    userId?: number;
    fileTypeDirectoryId?: number | undefined;
    active?: boolean;
    c_Read?: boolean;
    c_Write?: boolean;
    c_Delete?: boolean;
    c_WriteFile?: boolean;
    c_DeleteFile?: boolean;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    c_WriteFileWoApproval?: boolean;
    subServerPathId?: number | undefined;
    serverPathId?: number | undefined;
    fullPath?: string | undefined;
    createdBy_User?: User;
    modifiedBy_User?: User;
    user?: User;
    fileTypeDirectory?: FileVault_FileTypeDirectory;
    serverPath?: FileVault_ServerPath;
    serverSubPath?: FileVault_ServerSubPath;
}

export class FileVault_ExtensionType implements IFileVault_ExtensionType {
    id?: number;
    name?: string | undefined;
    allowedFileExtensions?: FileVault_AllowedFileExtension[] | undefined;

    constructor(data?: IFileVault_ExtensionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["allowedFileExtensions"])) {
                this.allowedFileExtensions = [] as any;
                for (let item of _data["allowedFileExtensions"])
                    this.allowedFileExtensions!.push(FileVault_AllowedFileExtension.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileVault_ExtensionType {
        data = typeof data === 'object' ? data : {};
        let result = new FileVault_ExtensionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.allowedFileExtensions)) {
            data["allowedFileExtensions"] = [];
            for (let item of this.allowedFileExtensions)
                data["allowedFileExtensions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileVault_ExtensionType {
    id?: number;
    name?: string | undefined;
    allowedFileExtensions?: FileVault_AllowedFileExtension[] | undefined;
}

export class FileVault_File implements IFileVault_File {
    id?: number;
    fileTypeID?: number;
    drawingLogID?: number;
    fileDirectory?: string | undefined;
    fileName?: string | undefined;
    revision?: string | undefined;
    partNumber?: number | undefined;
    locked?: boolean;
    fileDescription?: string | undefined;
    compressed?: boolean | undefined;
    guid?: string | undefined;
    obsolete?: boolean;
    fileHistories?: FileVault_FileHistory[] | undefined;
    fileTypeDirectory?: FileVault_FileTypeDirectory;
    fileTags?: FileVault_FileTag[] | undefined;
    orderFile?: ORD_OrderFile[] | undefined;
    applicationFiles?: FileVault_ApplicationFile[] | undefined;
    ecNs?: ECN[] | undefined;
    fileFeatures?: FileVault_FileFeature[] | undefined;
    fileThumbnails?: FileThumbnail[] | undefined;

    constructor(data?: IFileVault_File) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileTypeID = _data["fileTypeID"];
            this.drawingLogID = _data["drawingLogID"];
            this.fileDirectory = _data["fileDirectory"];
            this.fileName = _data["fileName"];
            this.revision = _data["revision"];
            this.partNumber = _data["partNumber"];
            this.locked = _data["locked"];
            this.fileDescription = _data["fileDescription"];
            this.compressed = _data["compressed"];
            this.guid = _data["guid"];
            this.obsolete = _data["obsolete"];
            if (Array.isArray(_data["fileHistories"])) {
                this.fileHistories = [] as any;
                for (let item of _data["fileHistories"])
                    this.fileHistories!.push(FileVault_FileHistory.fromJS(item));
            }
            this.fileTypeDirectory = _data["fileTypeDirectory"] ? FileVault_FileTypeDirectory.fromJS(_data["fileTypeDirectory"]) : <any>undefined;
            if (Array.isArray(_data["fileTags"])) {
                this.fileTags = [] as any;
                for (let item of _data["fileTags"])
                    this.fileTags!.push(FileVault_FileTag.fromJS(item));
            }
            if (Array.isArray(_data["orderFile"])) {
                this.orderFile = [] as any;
                for (let item of _data["orderFile"])
                    this.orderFile!.push(ORD_OrderFile.fromJS(item));
            }
            if (Array.isArray(_data["applicationFiles"])) {
                this.applicationFiles = [] as any;
                for (let item of _data["applicationFiles"])
                    this.applicationFiles!.push(FileVault_ApplicationFile.fromJS(item));
            }
            if (Array.isArray(_data["ecNs"])) {
                this.ecNs = [] as any;
                for (let item of _data["ecNs"])
                    this.ecNs!.push(ECN.fromJS(item));
            }
            if (Array.isArray(_data["fileFeatures"])) {
                this.fileFeatures = [] as any;
                for (let item of _data["fileFeatures"])
                    this.fileFeatures!.push(FileVault_FileFeature.fromJS(item));
            }
            if (Array.isArray(_data["fileThumbnails"])) {
                this.fileThumbnails = [] as any;
                for (let item of _data["fileThumbnails"])
                    this.fileThumbnails!.push(FileThumbnail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileVault_File {
        data = typeof data === 'object' ? data : {};
        let result = new FileVault_File();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileTypeID"] = this.fileTypeID;
        data["drawingLogID"] = this.drawingLogID;
        data["fileDirectory"] = this.fileDirectory;
        data["fileName"] = this.fileName;
        data["revision"] = this.revision;
        data["partNumber"] = this.partNumber;
        data["locked"] = this.locked;
        data["fileDescription"] = this.fileDescription;
        data["compressed"] = this.compressed;
        data["guid"] = this.guid;
        data["obsolete"] = this.obsolete;
        if (Array.isArray(this.fileHistories)) {
            data["fileHistories"] = [];
            for (let item of this.fileHistories)
                data["fileHistories"].push(item.toJSON());
        }
        data["fileTypeDirectory"] = this.fileTypeDirectory ? this.fileTypeDirectory.toJSON() : <any>undefined;
        if (Array.isArray(this.fileTags)) {
            data["fileTags"] = [];
            for (let item of this.fileTags)
                data["fileTags"].push(item.toJSON());
        }
        if (Array.isArray(this.orderFile)) {
            data["orderFile"] = [];
            for (let item of this.orderFile)
                data["orderFile"].push(item.toJSON());
        }
        if (Array.isArray(this.applicationFiles)) {
            data["applicationFiles"] = [];
            for (let item of this.applicationFiles)
                data["applicationFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.ecNs)) {
            data["ecNs"] = [];
            for (let item of this.ecNs)
                data["ecNs"].push(item.toJSON());
        }
        if (Array.isArray(this.fileFeatures)) {
            data["fileFeatures"] = [];
            for (let item of this.fileFeatures)
                data["fileFeatures"].push(item.toJSON());
        }
        if (Array.isArray(this.fileThumbnails)) {
            data["fileThumbnails"] = [];
            for (let item of this.fileThumbnails)
                data["fileThumbnails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileVault_File {
    id?: number;
    fileTypeID?: number;
    drawingLogID?: number;
    fileDirectory?: string | undefined;
    fileName?: string | undefined;
    revision?: string | undefined;
    partNumber?: number | undefined;
    locked?: boolean;
    fileDescription?: string | undefined;
    compressed?: boolean | undefined;
    guid?: string | undefined;
    obsolete?: boolean;
    fileHistories?: FileVault_FileHistory[] | undefined;
    fileTypeDirectory?: FileVault_FileTypeDirectory;
    fileTags?: FileVault_FileTag[] | undefined;
    orderFile?: ORD_OrderFile[] | undefined;
    applicationFiles?: FileVault_ApplicationFile[] | undefined;
    ecNs?: ECN[] | undefined;
    fileFeatures?: FileVault_FileFeature[] | undefined;
    fileThumbnails?: FileThumbnail[] | undefined;
}

export class FileVault_FileActionType implements IFileVault_FileActionType {
    id?: number;
    actionType?: string | undefined;
    fileHistories?: FileVault_FileHistory[] | undefined;

    constructor(data?: IFileVault_FileActionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actionType = _data["actionType"];
            if (Array.isArray(_data["fileHistories"])) {
                this.fileHistories = [] as any;
                for (let item of _data["fileHistories"])
                    this.fileHistories!.push(FileVault_FileHistory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileVault_FileActionType {
        data = typeof data === 'object' ? data : {};
        let result = new FileVault_FileActionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actionType"] = this.actionType;
        if (Array.isArray(this.fileHistories)) {
            data["fileHistories"] = [];
            for (let item of this.fileHistories)
                data["fileHistories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileVault_FileActionType {
    id?: number;
    actionType?: string | undefined;
    fileHistories?: FileVault_FileHistory[] | undefined;
}

export class FileVault_FileFeature implements IFileVault_FileFeature {
    id?: number;
    name?: string | undefined;
    bitFeature_Id?: number | undefined;
    files?: FileVault_File[] | undefined;
    bitFeature?: Features;

    constructor(data?: IFileVault_FileFeature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.bitFeature_Id = _data["bitFeature_Id"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileVault_File.fromJS(item));
            }
            this.bitFeature = _data["bitFeature"] ? Features.fromJS(_data["bitFeature"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileVault_FileFeature {
        data = typeof data === 'object' ? data : {};
        let result = new FileVault_FileFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["bitFeature_Id"] = this.bitFeature_Id;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["bitFeature"] = this.bitFeature ? this.bitFeature.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileVault_FileFeature {
    id?: number;
    name?: string | undefined;
    bitFeature_Id?: number | undefined;
    files?: FileVault_File[] | undefined;
    bitFeature?: Features;
}

export class FileVault_FileHistory implements IFileVault_FileHistory {
    id?: number;
    fileId?: number;
    revisionLevel?: string | undefined;
    comment?: string | undefined;
    userID?: number;
    modifiedDate?: Date;
    actionTypeID?: number;
    fileActionType?: FileVault_FileActionType;
    file?: FileVault_File;
    user?: User;

    constructor(data?: IFileVault_FileHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.revisionLevel = _data["revisionLevel"];
            this.comment = _data["comment"];
            this.userID = _data["userID"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.actionTypeID = _data["actionTypeID"];
            this.fileActionType = _data["fileActionType"] ? FileVault_FileActionType.fromJS(_data["fileActionType"]) : <any>undefined;
            this.file = _data["file"] ? FileVault_File.fromJS(_data["file"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileVault_FileHistory {
        data = typeof data === 'object' ? data : {};
        let result = new FileVault_FileHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["revisionLevel"] = this.revisionLevel;
        data["comment"] = this.comment;
        data["userID"] = this.userID;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["actionTypeID"] = this.actionTypeID;
        data["fileActionType"] = this.fileActionType ? this.fileActionType.toJSON() : <any>undefined;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileVault_FileHistory {
    id?: number;
    fileId?: number;
    revisionLevel?: string | undefined;
    comment?: string | undefined;
    userID?: number;
    modifiedDate?: Date;
    actionTypeID?: number;
    fileActionType?: FileVault_FileActionType;
    file?: FileVault_File;
    user?: User;
}

export class FileVault_FileTag implements IFileVault_FileTag {
    id?: number;
    fileID?: number;
    tag?: string | undefined;
    file?: FileVault_File;

    constructor(data?: IFileVault_FileTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileID = _data["fileID"];
            this.tag = _data["tag"];
            this.file = _data["file"] ? FileVault_File.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileVault_FileTag {
        data = typeof data === 'object' ? data : {};
        let result = new FileVault_FileTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileID"] = this.fileID;
        data["tag"] = this.tag;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileVault_FileTag {
    id?: number;
    fileID?: number;
    tag?: string | undefined;
    file?: FileVault_File;
}

export class FileVault_FileTypeDirectory implements IFileVault_FileTypeDirectory {
    id?: number;
    fileType?: string | undefined;
    directory?: string | undefined;
    encrypted?: boolean;
    serverSubPathId?: number;
    indexed?: boolean;
    allowedFileExtensions?: FileVault_AllowedFileExtension[] | undefined;
    files?: FileVault_File[] | undefined;
    serverSubPath?: FileVault_ServerSubPath;
    fileValidations?: FileVault_FileValidation[] | undefined;
    applicationTypes?: FileVault_ApplicationType[] | undefined;
    directoryPermissions?: FileVault_DirectoryPermission[] | undefined;
    orD_OrderFile?: ORD_OrderFile[] | undefined;
    applicationFiles?: FileVault_ApplicationFile[] | undefined;

    constructor(data?: IFileVault_FileTypeDirectory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileType = _data["fileType"];
            this.directory = _data["directory"];
            this.encrypted = _data["encrypted"];
            this.serverSubPathId = _data["serverSubPathId"];
            this.indexed = _data["indexed"];
            if (Array.isArray(_data["allowedFileExtensions"])) {
                this.allowedFileExtensions = [] as any;
                for (let item of _data["allowedFileExtensions"])
                    this.allowedFileExtensions!.push(FileVault_AllowedFileExtension.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileVault_File.fromJS(item));
            }
            this.serverSubPath = _data["serverSubPath"] ? FileVault_ServerSubPath.fromJS(_data["serverSubPath"]) : <any>undefined;
            if (Array.isArray(_data["fileValidations"])) {
                this.fileValidations = [] as any;
                for (let item of _data["fileValidations"])
                    this.fileValidations!.push(FileVault_FileValidation.fromJS(item));
            }
            if (Array.isArray(_data["applicationTypes"])) {
                this.applicationTypes = [] as any;
                for (let item of _data["applicationTypes"])
                    this.applicationTypes!.push(FileVault_ApplicationType.fromJS(item));
            }
            if (Array.isArray(_data["directoryPermissions"])) {
                this.directoryPermissions = [] as any;
                for (let item of _data["directoryPermissions"])
                    this.directoryPermissions!.push(FileVault_DirectoryPermission.fromJS(item));
            }
            if (Array.isArray(_data["orD_OrderFile"])) {
                this.orD_OrderFile = [] as any;
                for (let item of _data["orD_OrderFile"])
                    this.orD_OrderFile!.push(ORD_OrderFile.fromJS(item));
            }
            if (Array.isArray(_data["applicationFiles"])) {
                this.applicationFiles = [] as any;
                for (let item of _data["applicationFiles"])
                    this.applicationFiles!.push(FileVault_ApplicationFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileVault_FileTypeDirectory {
        data = typeof data === 'object' ? data : {};
        let result = new FileVault_FileTypeDirectory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileType"] = this.fileType;
        data["directory"] = this.directory;
        data["encrypted"] = this.encrypted;
        data["serverSubPathId"] = this.serverSubPathId;
        data["indexed"] = this.indexed;
        if (Array.isArray(this.allowedFileExtensions)) {
            data["allowedFileExtensions"] = [];
            for (let item of this.allowedFileExtensions)
                data["allowedFileExtensions"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["serverSubPath"] = this.serverSubPath ? this.serverSubPath.toJSON() : <any>undefined;
        if (Array.isArray(this.fileValidations)) {
            data["fileValidations"] = [];
            for (let item of this.fileValidations)
                data["fileValidations"].push(item.toJSON());
        }
        if (Array.isArray(this.applicationTypes)) {
            data["applicationTypes"] = [];
            for (let item of this.applicationTypes)
                data["applicationTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.directoryPermissions)) {
            data["directoryPermissions"] = [];
            for (let item of this.directoryPermissions)
                data["directoryPermissions"].push(item.toJSON());
        }
        if (Array.isArray(this.orD_OrderFile)) {
            data["orD_OrderFile"] = [];
            for (let item of this.orD_OrderFile)
                data["orD_OrderFile"].push(item.toJSON());
        }
        if (Array.isArray(this.applicationFiles)) {
            data["applicationFiles"] = [];
            for (let item of this.applicationFiles)
                data["applicationFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileVault_FileTypeDirectory {
    id?: number;
    fileType?: string | undefined;
    directory?: string | undefined;
    encrypted?: boolean;
    serverSubPathId?: number;
    indexed?: boolean;
    allowedFileExtensions?: FileVault_AllowedFileExtension[] | undefined;
    files?: FileVault_File[] | undefined;
    serverSubPath?: FileVault_ServerSubPath;
    fileValidations?: FileVault_FileValidation[] | undefined;
    applicationTypes?: FileVault_ApplicationType[] | undefined;
    directoryPermissions?: FileVault_DirectoryPermission[] | undefined;
    orD_OrderFile?: ORD_OrderFile[] | undefined;
    applicationFiles?: FileVault_ApplicationFile[] | undefined;
}

export class FileVault_FileValidation implements IFileVault_FileValidation {
    id?: number;
    fileTypeId?: number;
    validationTypeId?: number;
    fileTypeDirectory?: FileVault_FileTypeDirectory;
    validationType?: ValidationType;

    constructor(data?: IFileVault_FileValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileTypeId = _data["fileTypeId"];
            this.validationTypeId = _data["validationTypeId"];
            this.fileTypeDirectory = _data["fileTypeDirectory"] ? FileVault_FileTypeDirectory.fromJS(_data["fileTypeDirectory"]) : <any>undefined;
            this.validationType = _data["validationType"] ? ValidationType.fromJS(_data["validationType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileVault_FileValidation {
        data = typeof data === 'object' ? data : {};
        let result = new FileVault_FileValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileTypeId"] = this.fileTypeId;
        data["validationTypeId"] = this.validationTypeId;
        data["fileTypeDirectory"] = this.fileTypeDirectory ? this.fileTypeDirectory.toJSON() : <any>undefined;
        data["validationType"] = this.validationType ? this.validationType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileVault_FileValidation {
    id?: number;
    fileTypeId?: number;
    validationTypeId?: number;
    fileTypeDirectory?: FileVault_FileTypeDirectory;
    validationType?: ValidationType;
}

export class FileVault_ServerPath implements IFileVault_ServerPath {
    id?: number;
    path?: string | undefined;
    name?: string | undefined;
    serverSubPaths?: FileVault_ServerSubPath[] | undefined;
    directoryPermissions?: FileVault_DirectoryPermission[] | undefined;

    constructor(data?: IFileVault_ServerPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.path = _data["path"];
            this.name = _data["name"];
            if (Array.isArray(_data["serverSubPaths"])) {
                this.serverSubPaths = [] as any;
                for (let item of _data["serverSubPaths"])
                    this.serverSubPaths!.push(FileVault_ServerSubPath.fromJS(item));
            }
            if (Array.isArray(_data["directoryPermissions"])) {
                this.directoryPermissions = [] as any;
                for (let item of _data["directoryPermissions"])
                    this.directoryPermissions!.push(FileVault_DirectoryPermission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileVault_ServerPath {
        data = typeof data === 'object' ? data : {};
        let result = new FileVault_ServerPath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["path"] = this.path;
        data["name"] = this.name;
        if (Array.isArray(this.serverSubPaths)) {
            data["serverSubPaths"] = [];
            for (let item of this.serverSubPaths)
                data["serverSubPaths"].push(item.toJSON());
        }
        if (Array.isArray(this.directoryPermissions)) {
            data["directoryPermissions"] = [];
            for (let item of this.directoryPermissions)
                data["directoryPermissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileVault_ServerPath {
    id?: number;
    path?: string | undefined;
    name?: string | undefined;
    serverSubPaths?: FileVault_ServerSubPath[] | undefined;
    directoryPermissions?: FileVault_DirectoryPermission[] | undefined;
}

export class FileVault_ServerSubPath implements IFileVault_ServerSubPath {
    id?: number;
    subPath?: string | undefined;
    serverPathId?: number;
    fileTypeDirectories?: FileVault_FileTypeDirectory[] | undefined;
    serverPath?: FileVault_ServerPath;
    directoryPermissions?: FileVault_DirectoryPermission[] | undefined;

    constructor(data?: IFileVault_ServerSubPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subPath = _data["subPath"];
            this.serverPathId = _data["serverPathId"];
            if (Array.isArray(_data["fileTypeDirectories"])) {
                this.fileTypeDirectories = [] as any;
                for (let item of _data["fileTypeDirectories"])
                    this.fileTypeDirectories!.push(FileVault_FileTypeDirectory.fromJS(item));
            }
            this.serverPath = _data["serverPath"] ? FileVault_ServerPath.fromJS(_data["serverPath"]) : <any>undefined;
            if (Array.isArray(_data["directoryPermissions"])) {
                this.directoryPermissions = [] as any;
                for (let item of _data["directoryPermissions"])
                    this.directoryPermissions!.push(FileVault_DirectoryPermission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileVault_ServerSubPath {
        data = typeof data === 'object' ? data : {};
        let result = new FileVault_ServerSubPath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subPath"] = this.subPath;
        data["serverPathId"] = this.serverPathId;
        if (Array.isArray(this.fileTypeDirectories)) {
            data["fileTypeDirectories"] = [];
            for (let item of this.fileTypeDirectories)
                data["fileTypeDirectories"].push(item.toJSON());
        }
        data["serverPath"] = this.serverPath ? this.serverPath.toJSON() : <any>undefined;
        if (Array.isArray(this.directoryPermissions)) {
            data["directoryPermissions"] = [];
            for (let item of this.directoryPermissions)
                data["directoryPermissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileVault_ServerSubPath {
    id?: number;
    subPath?: string | undefined;
    serverPathId?: number;
    fileTypeDirectories?: FileVault_FileTypeDirectory[] | undefined;
    serverPath?: FileVault_ServerPath;
    directoryPermissions?: FileVault_DirectoryPermission[] | undefined;
}

export class FilterSet implements IFilterSet {
    id?: number;
    filtered_ProcessId?: number;
    processid?: number;
    subPslId?: number;
    process?: Process;
    filtered_Processes?: Process;
    subPsl?: SubPSL;

    constructor(data?: IFilterSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.filtered_ProcessId = _data["filtered_ProcessId"];
            this.processid = _data["processid"];
            this.subPslId = _data["subPslId"];
            this.process = _data["process"] ? Process.fromJS(_data["process"]) : <any>undefined;
            this.filtered_Processes = _data["filtered_Processes"] ? Process.fromJS(_data["filtered_Processes"]) : <any>undefined;
            this.subPsl = _data["subPsl"] ? SubPSL.fromJS(_data["subPsl"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FilterSet {
        data = typeof data === 'object' ? data : {};
        let result = new FilterSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filtered_ProcessId"] = this.filtered_ProcessId;
        data["processid"] = this.processid;
        data["subPslId"] = this.subPslId;
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        data["filtered_Processes"] = this.filtered_Processes ? this.filtered_Processes.toJSON() : <any>undefined;
        data["subPsl"] = this.subPsl ? this.subPsl.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFilterSet {
    id?: number;
    filtered_ProcessId?: number;
    processid?: number;
    subPslId?: number;
    process?: Process;
    filtered_Processes?: Process;
    subPsl?: SubPSL;
}

export class FixedCutterBrazedIn implements IFixedCutterBrazedIn {
    id?: number;
    preBOMID?: number;
    nozzleType?: string | undefined;
    sapMaterialNumber?: number;
    quantity?: number;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    size?: string | undefined;
    fixedCutterPreBOM?: FixedCutterInput;
    createdBy_User?: User;
    modifiedBy_User?: User;

    constructor(data?: IFixedCutterBrazedIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.preBOMID = _data["preBOMID"];
            this.nozzleType = _data["nozzleType"];
            this.sapMaterialNumber = _data["sapMaterialNumber"];
            this.quantity = _data["quantity"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.size = _data["size"];
            this.fixedCutterPreBOM = _data["fixedCutterPreBOM"] ? FixedCutterInput.fromJS(_data["fixedCutterPreBOM"]) : <any>undefined;
            this.createdBy_User = _data["createdBy_User"] ? User.fromJS(_data["createdBy_User"]) : <any>undefined;
            this.modifiedBy_User = _data["modifiedBy_User"] ? User.fromJS(_data["modifiedBy_User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FixedCutterBrazedIn {
        data = typeof data === 'object' ? data : {};
        let result = new FixedCutterBrazedIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["preBOMID"] = this.preBOMID;
        data["nozzleType"] = this.nozzleType;
        data["sapMaterialNumber"] = this.sapMaterialNumber;
        data["quantity"] = this.quantity;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["size"] = this.size;
        data["fixedCutterPreBOM"] = this.fixedCutterPreBOM ? this.fixedCutterPreBOM.toJSON() : <any>undefined;
        data["createdBy_User"] = this.createdBy_User ? this.createdBy_User.toJSON() : <any>undefined;
        data["modifiedBy_User"] = this.modifiedBy_User ? this.modifiedBy_User.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFixedCutterBrazedIn {
    id?: number;
    preBOMID?: number;
    nozzleType?: string | undefined;
    sapMaterialNumber?: number;
    quantity?: number;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    size?: string | undefined;
    fixedCutterPreBOM?: FixedCutterInput;
    createdBy_User?: User;
    modifiedBy_User?: User;
}

export class FixedCutterCastIn implements IFixedCutterCastIn {
    id?: number;
    preBOMID?: number;
    nozzleType?: string | undefined;
    sapMaterialNumber?: number;
    quantity?: number;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    size?: string | undefined;
    fixedCutterPreBOM?: FixedCutterInput;
    createdBy_User?: User;
    modifiedBy_User?: User;

    constructor(data?: IFixedCutterCastIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.preBOMID = _data["preBOMID"];
            this.nozzleType = _data["nozzleType"];
            this.sapMaterialNumber = _data["sapMaterialNumber"];
            this.quantity = _data["quantity"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.size = _data["size"];
            this.fixedCutterPreBOM = _data["fixedCutterPreBOM"] ? FixedCutterInput.fromJS(_data["fixedCutterPreBOM"]) : <any>undefined;
            this.createdBy_User = _data["createdBy_User"] ? User.fromJS(_data["createdBy_User"]) : <any>undefined;
            this.modifiedBy_User = _data["modifiedBy_User"] ? User.fromJS(_data["modifiedBy_User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FixedCutterCastIn {
        data = typeof data === 'object' ? data : {};
        let result = new FixedCutterCastIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["preBOMID"] = this.preBOMID;
        data["nozzleType"] = this.nozzleType;
        data["sapMaterialNumber"] = this.sapMaterialNumber;
        data["quantity"] = this.quantity;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["size"] = this.size;
        data["fixedCutterPreBOM"] = this.fixedCutterPreBOM ? this.fixedCutterPreBOM.toJSON() : <any>undefined;
        data["createdBy_User"] = this.createdBy_User ? this.createdBy_User.toJSON() : <any>undefined;
        data["modifiedBy_User"] = this.modifiedBy_User ? this.modifiedBy_User.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFixedCutterCastIn {
    id?: number;
    preBOMID?: number;
    nozzleType?: string | undefined;
    sapMaterialNumber?: number;
    quantity?: number;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    size?: string | undefined;
    fixedCutterPreBOM?: FixedCutterInput;
    createdBy_User?: User;
    modifiedBy_User?: User;
}

export class FixedCutterGaugePadElement implements IFixedCutterGaugePadElement {
    id?: number;
    preBOMID?: number;
    type?: string | undefined;
    sapMaterialNumber?: number;
    size?: string | undefined;
    quantity?: number;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    fixedCutterPreBOM?: FixedCutterInput;
    createdBy_User?: User;
    modifiedBy_User?: User;

    constructor(data?: IFixedCutterGaugePadElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.preBOMID = _data["preBOMID"];
            this.type = _data["type"];
            this.sapMaterialNumber = _data["sapMaterialNumber"];
            this.size = _data["size"];
            this.quantity = _data["quantity"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.fixedCutterPreBOM = _data["fixedCutterPreBOM"] ? FixedCutterInput.fromJS(_data["fixedCutterPreBOM"]) : <any>undefined;
            this.createdBy_User = _data["createdBy_User"] ? User.fromJS(_data["createdBy_User"]) : <any>undefined;
            this.modifiedBy_User = _data["modifiedBy_User"] ? User.fromJS(_data["modifiedBy_User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FixedCutterGaugePadElement {
        data = typeof data === 'object' ? data : {};
        let result = new FixedCutterGaugePadElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["preBOMID"] = this.preBOMID;
        data["type"] = this.type;
        data["sapMaterialNumber"] = this.sapMaterialNumber;
        data["size"] = this.size;
        data["quantity"] = this.quantity;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["fixedCutterPreBOM"] = this.fixedCutterPreBOM ? this.fixedCutterPreBOM.toJSON() : <any>undefined;
        data["createdBy_User"] = this.createdBy_User ? this.createdBy_User.toJSON() : <any>undefined;
        data["modifiedBy_User"] = this.modifiedBy_User ? this.modifiedBy_User.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFixedCutterGaugePadElement {
    id?: number;
    preBOMID?: number;
    type?: string | undefined;
    sapMaterialNumber?: number;
    size?: string | undefined;
    quantity?: number;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    fixedCutterPreBOM?: FixedCutterInput;
    createdBy_User?: User;
    modifiedBy_User?: User;
}

export class FixedCutterInput implements IFixedCutterInput {
    id?: number;
    orderId?: number;
    materialNumber?: number;
    serviceNumber?: number | undefined;
    topMoldLength?: number | undefined;
    topMold2Length?: number | undefined;
    bottomMoldLength?: number | undefined;
    bitMakeUpLength?: number | undefined;
    bitOverAllLength?: number | undefined;
    blankLength?: number | undefined;
    shankDiameter?: number | undefined;
    pressRing?: boolean | undefined;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    gaugeExposure?: string | undefined;
    normalizedFaceVolume?: number | undefined;
    impactArrestor_Location?: string | undefined;
    impactArrestor_Geometry?: string | undefined;
    impreg_DiskDensity?: string | undefined;
    bitHead_HardFacingDetail?: string | undefined;
    bitHead_MaskingDetail?: string | undefined;
    bitHead_SacrificalBoxName?: string | undefined;
    sleeve_HardFacingDetail?: string | undefined;
    sleeve_MaskingDetail?: string | undefined;
    sleeve_SacrificalBox?: string | undefined;
    upperSection?: string | undefined;
    universalBlank?: boolean | undefined;
    abCoating?: boolean | undefined;
    postWeldHeatTreatment?: boolean | undefined;
    casting?: boolean | undefined;
    preMachine?: boolean | undefined;
    sapUpdatedDate?: Date | undefined;
    marketingSheetUpdatedDate?: Date | undefined;
    sleeveRouter?: string | undefined;
    bitHeadRouter?: string | undefined;
    steelType?: string | undefined;
    twoPieceToOnePiece?: boolean | undefined;
    upperSectionRouter?: string | undefined;
    junkSlotArea?: number | undefined;
    cutterDensity?: number | undefined;
    heightToWidthRatio?: number | undefined;
    steelRelief?: boolean | undefined;
    includeDR10000?: boolean | undefined;
    sapUpdateStatus?: string | undefined;
    sapbomProgressUpdatedDate?: Date | undefined;
    addMiledBlankRouter?: boolean | undefined;
    apiSize?: string | undefined;
    restrictor?: boolean | undefined;
    shortShank?: boolean | undefined;
    bitBreaker?: string | undefined;
    bitBreakerSapNumber?: number;
    marketingSheetBitData?: string | undefined;
    bodyType?: string | undefined;
    retroFit?: boolean;
    loginId?: string | undefined;
    faceSpecSheet?: string | undefined;
    guageSpecSheet?: string | undefined;
    addedToMarketingSheetDb?: boolean;
    savedToMarketingSheetDb?: boolean;
    specSheetValChanged?: boolean;
    order?: ORD_Order;
    createdBy_User?: User;
    modifiedBy_User?: User;
    fixedCutterBrazedIns?: FixedCutterBrazedIn[] | undefined;
    fixedCutterCastIns?: FixedCutterCastIn[] | undefined;
    fixedCutterGaugePadElements?: FixedCutterGaugePadElement[] | undefined;
    fixedCutterNozzleDummies?: FixedCutterNozzleDummy[] | undefined;
    fixedCutterNozzleLiners?: FixedCutterNozzleLiner[] | undefined;
    fixedCutterPowders?: FixedCutterPowder[] | undefined;
    fixedCutterSleeves?: FixedCutterSleeve[] | undefined;
    fixedCutterRingGauges?: FixedCutterRingGauge[] | undefined;

    constructor(data?: IFixedCutterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.materialNumber = _data["materialNumber"];
            this.serviceNumber = _data["serviceNumber"];
            this.topMoldLength = _data["topMoldLength"];
            this.topMold2Length = _data["topMold2Length"];
            this.bottomMoldLength = _data["bottomMoldLength"];
            this.bitMakeUpLength = _data["bitMakeUpLength"];
            this.bitOverAllLength = _data["bitOverAllLength"];
            this.blankLength = _data["blankLength"];
            this.shankDiameter = _data["shankDiameter"];
            this.pressRing = _data["pressRing"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.gaugeExposure = _data["gaugeExposure"];
            this.normalizedFaceVolume = _data["normalizedFaceVolume"];
            this.impactArrestor_Location = _data["impactArrestor_Location"];
            this.impactArrestor_Geometry = _data["impactArrestor_Geometry"];
            this.impreg_DiskDensity = _data["impreg_DiskDensity"];
            this.bitHead_HardFacingDetail = _data["bitHead_HardFacingDetail"];
            this.bitHead_MaskingDetail = _data["bitHead_MaskingDetail"];
            this.bitHead_SacrificalBoxName = _data["bitHead_SacrificalBoxName"];
            this.sleeve_HardFacingDetail = _data["sleeve_HardFacingDetail"];
            this.sleeve_MaskingDetail = _data["sleeve_MaskingDetail"];
            this.sleeve_SacrificalBox = _data["sleeve_SacrificalBox"];
            this.upperSection = _data["upperSection"];
            this.universalBlank = _data["universalBlank"];
            this.abCoating = _data["abCoating"];
            this.postWeldHeatTreatment = _data["postWeldHeatTreatment"];
            this.casting = _data["casting"];
            this.preMachine = _data["preMachine"];
            this.sapUpdatedDate = _data["sapUpdatedDate"] ? new Date(_data["sapUpdatedDate"].toString()) : <any>undefined;
            this.marketingSheetUpdatedDate = _data["marketingSheetUpdatedDate"] ? new Date(_data["marketingSheetUpdatedDate"].toString()) : <any>undefined;
            this.sleeveRouter = _data["sleeveRouter"];
            this.bitHeadRouter = _data["bitHeadRouter"];
            this.steelType = _data["steelType"];
            this.twoPieceToOnePiece = _data["twoPieceToOnePiece"];
            this.upperSectionRouter = _data["upperSectionRouter"];
            this.junkSlotArea = _data["junkSlotArea"];
            this.cutterDensity = _data["cutterDensity"];
            this.heightToWidthRatio = _data["heightToWidthRatio"];
            this.steelRelief = _data["steelRelief"];
            this.includeDR10000 = _data["includeDR10000"];
            this.sapUpdateStatus = _data["sapUpdateStatus"];
            this.sapbomProgressUpdatedDate = _data["sapbomProgressUpdatedDate"] ? new Date(_data["sapbomProgressUpdatedDate"].toString()) : <any>undefined;
            this.addMiledBlankRouter = _data["addMiledBlankRouter"];
            this.apiSize = _data["apiSize"];
            this.restrictor = _data["restrictor"];
            this.shortShank = _data["shortShank"];
            this.bitBreaker = _data["bitBreaker"];
            this.bitBreakerSapNumber = _data["bitBreakerSapNumber"];
            this.marketingSheetBitData = _data["marketingSheetBitData"];
            this.bodyType = _data["bodyType"];
            this.retroFit = _data["retroFit"];
            this.loginId = _data["loginId"];
            this.faceSpecSheet = _data["faceSpecSheet"];
            this.guageSpecSheet = _data["guageSpecSheet"];
            this.addedToMarketingSheetDb = _data["addedToMarketingSheetDb"];
            this.savedToMarketingSheetDb = _data["savedToMarketingSheetDb"];
            this.specSheetValChanged = _data["specSheetValChanged"];
            this.order = _data["order"] ? ORD_Order.fromJS(_data["order"]) : <any>undefined;
            this.createdBy_User = _data["createdBy_User"] ? User.fromJS(_data["createdBy_User"]) : <any>undefined;
            this.modifiedBy_User = _data["modifiedBy_User"] ? User.fromJS(_data["modifiedBy_User"]) : <any>undefined;
            if (Array.isArray(_data["fixedCutterBrazedIns"])) {
                this.fixedCutterBrazedIns = [] as any;
                for (let item of _data["fixedCutterBrazedIns"])
                    this.fixedCutterBrazedIns!.push(FixedCutterBrazedIn.fromJS(item));
            }
            if (Array.isArray(_data["fixedCutterCastIns"])) {
                this.fixedCutterCastIns = [] as any;
                for (let item of _data["fixedCutterCastIns"])
                    this.fixedCutterCastIns!.push(FixedCutterCastIn.fromJS(item));
            }
            if (Array.isArray(_data["fixedCutterGaugePadElements"])) {
                this.fixedCutterGaugePadElements = [] as any;
                for (let item of _data["fixedCutterGaugePadElements"])
                    this.fixedCutterGaugePadElements!.push(FixedCutterGaugePadElement.fromJS(item));
            }
            if (Array.isArray(_data["fixedCutterNozzleDummies"])) {
                this.fixedCutterNozzleDummies = [] as any;
                for (let item of _data["fixedCutterNozzleDummies"])
                    this.fixedCutterNozzleDummies!.push(FixedCutterNozzleDummy.fromJS(item));
            }
            if (Array.isArray(_data["fixedCutterNozzleLiners"])) {
                this.fixedCutterNozzleLiners = [] as any;
                for (let item of _data["fixedCutterNozzleLiners"])
                    this.fixedCutterNozzleLiners!.push(FixedCutterNozzleLiner.fromJS(item));
            }
            if (Array.isArray(_data["fixedCutterPowders"])) {
                this.fixedCutterPowders = [] as any;
                for (let item of _data["fixedCutterPowders"])
                    this.fixedCutterPowders!.push(FixedCutterPowder.fromJS(item));
            }
            if (Array.isArray(_data["fixedCutterSleeves"])) {
                this.fixedCutterSleeves = [] as any;
                for (let item of _data["fixedCutterSleeves"])
                    this.fixedCutterSleeves!.push(FixedCutterSleeve.fromJS(item));
            }
            if (Array.isArray(_data["fixedCutterRingGauges"])) {
                this.fixedCutterRingGauges = [] as any;
                for (let item of _data["fixedCutterRingGauges"])
                    this.fixedCutterRingGauges!.push(FixedCutterRingGauge.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FixedCutterInput {
        data = typeof data === 'object' ? data : {};
        let result = new FixedCutterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["materialNumber"] = this.materialNumber;
        data["serviceNumber"] = this.serviceNumber;
        data["topMoldLength"] = this.topMoldLength;
        data["topMold2Length"] = this.topMold2Length;
        data["bottomMoldLength"] = this.bottomMoldLength;
        data["bitMakeUpLength"] = this.bitMakeUpLength;
        data["bitOverAllLength"] = this.bitOverAllLength;
        data["blankLength"] = this.blankLength;
        data["shankDiameter"] = this.shankDiameter;
        data["pressRing"] = this.pressRing;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["gaugeExposure"] = this.gaugeExposure;
        data["normalizedFaceVolume"] = this.normalizedFaceVolume;
        data["impactArrestor_Location"] = this.impactArrestor_Location;
        data["impactArrestor_Geometry"] = this.impactArrestor_Geometry;
        data["impreg_DiskDensity"] = this.impreg_DiskDensity;
        data["bitHead_HardFacingDetail"] = this.bitHead_HardFacingDetail;
        data["bitHead_MaskingDetail"] = this.bitHead_MaskingDetail;
        data["bitHead_SacrificalBoxName"] = this.bitHead_SacrificalBoxName;
        data["sleeve_HardFacingDetail"] = this.sleeve_HardFacingDetail;
        data["sleeve_MaskingDetail"] = this.sleeve_MaskingDetail;
        data["sleeve_SacrificalBox"] = this.sleeve_SacrificalBox;
        data["upperSection"] = this.upperSection;
        data["universalBlank"] = this.universalBlank;
        data["abCoating"] = this.abCoating;
        data["postWeldHeatTreatment"] = this.postWeldHeatTreatment;
        data["casting"] = this.casting;
        data["preMachine"] = this.preMachine;
        data["sapUpdatedDate"] = this.sapUpdatedDate ? this.sapUpdatedDate.toISOString() : <any>undefined;
        data["marketingSheetUpdatedDate"] = this.marketingSheetUpdatedDate ? this.marketingSheetUpdatedDate.toISOString() : <any>undefined;
        data["sleeveRouter"] = this.sleeveRouter;
        data["bitHeadRouter"] = this.bitHeadRouter;
        data["steelType"] = this.steelType;
        data["twoPieceToOnePiece"] = this.twoPieceToOnePiece;
        data["upperSectionRouter"] = this.upperSectionRouter;
        data["junkSlotArea"] = this.junkSlotArea;
        data["cutterDensity"] = this.cutterDensity;
        data["heightToWidthRatio"] = this.heightToWidthRatio;
        data["steelRelief"] = this.steelRelief;
        data["includeDR10000"] = this.includeDR10000;
        data["sapUpdateStatus"] = this.sapUpdateStatus;
        data["sapbomProgressUpdatedDate"] = this.sapbomProgressUpdatedDate ? this.sapbomProgressUpdatedDate.toISOString() : <any>undefined;
        data["addMiledBlankRouter"] = this.addMiledBlankRouter;
        data["apiSize"] = this.apiSize;
        data["restrictor"] = this.restrictor;
        data["shortShank"] = this.shortShank;
        data["bitBreaker"] = this.bitBreaker;
        data["bitBreakerSapNumber"] = this.bitBreakerSapNumber;
        data["marketingSheetBitData"] = this.marketingSheetBitData;
        data["bodyType"] = this.bodyType;
        data["retroFit"] = this.retroFit;
        data["loginId"] = this.loginId;
        data["faceSpecSheet"] = this.faceSpecSheet;
        data["guageSpecSheet"] = this.guageSpecSheet;
        data["addedToMarketingSheetDb"] = this.addedToMarketingSheetDb;
        data["savedToMarketingSheetDb"] = this.savedToMarketingSheetDb;
        data["specSheetValChanged"] = this.specSheetValChanged;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["createdBy_User"] = this.createdBy_User ? this.createdBy_User.toJSON() : <any>undefined;
        data["modifiedBy_User"] = this.modifiedBy_User ? this.modifiedBy_User.toJSON() : <any>undefined;
        if (Array.isArray(this.fixedCutterBrazedIns)) {
            data["fixedCutterBrazedIns"] = [];
            for (let item of this.fixedCutterBrazedIns)
                data["fixedCutterBrazedIns"].push(item.toJSON());
        }
        if (Array.isArray(this.fixedCutterCastIns)) {
            data["fixedCutterCastIns"] = [];
            for (let item of this.fixedCutterCastIns)
                data["fixedCutterCastIns"].push(item.toJSON());
        }
        if (Array.isArray(this.fixedCutterGaugePadElements)) {
            data["fixedCutterGaugePadElements"] = [];
            for (let item of this.fixedCutterGaugePadElements)
                data["fixedCutterGaugePadElements"].push(item.toJSON());
        }
        if (Array.isArray(this.fixedCutterNozzleDummies)) {
            data["fixedCutterNozzleDummies"] = [];
            for (let item of this.fixedCutterNozzleDummies)
                data["fixedCutterNozzleDummies"].push(item.toJSON());
        }
        if (Array.isArray(this.fixedCutterNozzleLiners)) {
            data["fixedCutterNozzleLiners"] = [];
            for (let item of this.fixedCutterNozzleLiners)
                data["fixedCutterNozzleLiners"].push(item.toJSON());
        }
        if (Array.isArray(this.fixedCutterPowders)) {
            data["fixedCutterPowders"] = [];
            for (let item of this.fixedCutterPowders)
                data["fixedCutterPowders"].push(item.toJSON());
        }
        if (Array.isArray(this.fixedCutterSleeves)) {
            data["fixedCutterSleeves"] = [];
            for (let item of this.fixedCutterSleeves)
                data["fixedCutterSleeves"].push(item.toJSON());
        }
        if (Array.isArray(this.fixedCutterRingGauges)) {
            data["fixedCutterRingGauges"] = [];
            for (let item of this.fixedCutterRingGauges)
                data["fixedCutterRingGauges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFixedCutterInput {
    id?: number;
    orderId?: number;
    materialNumber?: number;
    serviceNumber?: number | undefined;
    topMoldLength?: number | undefined;
    topMold2Length?: number | undefined;
    bottomMoldLength?: number | undefined;
    bitMakeUpLength?: number | undefined;
    bitOverAllLength?: number | undefined;
    blankLength?: number | undefined;
    shankDiameter?: number | undefined;
    pressRing?: boolean | undefined;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    gaugeExposure?: string | undefined;
    normalizedFaceVolume?: number | undefined;
    impactArrestor_Location?: string | undefined;
    impactArrestor_Geometry?: string | undefined;
    impreg_DiskDensity?: string | undefined;
    bitHead_HardFacingDetail?: string | undefined;
    bitHead_MaskingDetail?: string | undefined;
    bitHead_SacrificalBoxName?: string | undefined;
    sleeve_HardFacingDetail?: string | undefined;
    sleeve_MaskingDetail?: string | undefined;
    sleeve_SacrificalBox?: string | undefined;
    upperSection?: string | undefined;
    universalBlank?: boolean | undefined;
    abCoating?: boolean | undefined;
    postWeldHeatTreatment?: boolean | undefined;
    casting?: boolean | undefined;
    preMachine?: boolean | undefined;
    sapUpdatedDate?: Date | undefined;
    marketingSheetUpdatedDate?: Date | undefined;
    sleeveRouter?: string | undefined;
    bitHeadRouter?: string | undefined;
    steelType?: string | undefined;
    twoPieceToOnePiece?: boolean | undefined;
    upperSectionRouter?: string | undefined;
    junkSlotArea?: number | undefined;
    cutterDensity?: number | undefined;
    heightToWidthRatio?: number | undefined;
    steelRelief?: boolean | undefined;
    includeDR10000?: boolean | undefined;
    sapUpdateStatus?: string | undefined;
    sapbomProgressUpdatedDate?: Date | undefined;
    addMiledBlankRouter?: boolean | undefined;
    apiSize?: string | undefined;
    restrictor?: boolean | undefined;
    shortShank?: boolean | undefined;
    bitBreaker?: string | undefined;
    bitBreakerSapNumber?: number;
    marketingSheetBitData?: string | undefined;
    bodyType?: string | undefined;
    retroFit?: boolean;
    loginId?: string | undefined;
    faceSpecSheet?: string | undefined;
    guageSpecSheet?: string | undefined;
    addedToMarketingSheetDb?: boolean;
    savedToMarketingSheetDb?: boolean;
    specSheetValChanged?: boolean;
    order?: ORD_Order;
    createdBy_User?: User;
    modifiedBy_User?: User;
    fixedCutterBrazedIns?: FixedCutterBrazedIn[] | undefined;
    fixedCutterCastIns?: FixedCutterCastIn[] | undefined;
    fixedCutterGaugePadElements?: FixedCutterGaugePadElement[] | undefined;
    fixedCutterNozzleDummies?: FixedCutterNozzleDummy[] | undefined;
    fixedCutterNozzleLiners?: FixedCutterNozzleLiner[] | undefined;
    fixedCutterPowders?: FixedCutterPowder[] | undefined;
    fixedCutterSleeves?: FixedCutterSleeve[] | undefined;
    fixedCutterRingGauges?: FixedCutterRingGauge[] | undefined;
}

export class FixedCutterNozzleDummy implements IFixedCutterNozzleDummy {
    id?: number;
    preBOMID?: number;
    nozzleType?: string | undefined;
    sapMaterialNumber?: number;
    quantity?: number;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    fixedCutterPreBOM?: FixedCutterInput;
    createdBy_User?: User;
    modifiedBy_User?: User;

    constructor(data?: IFixedCutterNozzleDummy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.preBOMID = _data["preBOMID"];
            this.nozzleType = _data["nozzleType"];
            this.sapMaterialNumber = _data["sapMaterialNumber"];
            this.quantity = _data["quantity"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.fixedCutterPreBOM = _data["fixedCutterPreBOM"] ? FixedCutterInput.fromJS(_data["fixedCutterPreBOM"]) : <any>undefined;
            this.createdBy_User = _data["createdBy_User"] ? User.fromJS(_data["createdBy_User"]) : <any>undefined;
            this.modifiedBy_User = _data["modifiedBy_User"] ? User.fromJS(_data["modifiedBy_User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FixedCutterNozzleDummy {
        data = typeof data === 'object' ? data : {};
        let result = new FixedCutterNozzleDummy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["preBOMID"] = this.preBOMID;
        data["nozzleType"] = this.nozzleType;
        data["sapMaterialNumber"] = this.sapMaterialNumber;
        data["quantity"] = this.quantity;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["fixedCutterPreBOM"] = this.fixedCutterPreBOM ? this.fixedCutterPreBOM.toJSON() : <any>undefined;
        data["createdBy_User"] = this.createdBy_User ? this.createdBy_User.toJSON() : <any>undefined;
        data["modifiedBy_User"] = this.modifiedBy_User ? this.modifiedBy_User.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFixedCutterNozzleDummy {
    id?: number;
    preBOMID?: number;
    nozzleType?: string | undefined;
    sapMaterialNumber?: number;
    quantity?: number;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    fixedCutterPreBOM?: FixedCutterInput;
    createdBy_User?: User;
    modifiedBy_User?: User;
}

export class FixedCutterNozzleLiner implements IFixedCutterNozzleLiner {
    id?: number;
    preBOMID?: number;
    nozzleType?: string | undefined;
    sapMaterialNumber?: number;
    quantity?: number;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    fixedCutterPreBOM?: FixedCutterInput;
    createdBy_User?: User;
    modifiedBy_User?: User;

    constructor(data?: IFixedCutterNozzleLiner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.preBOMID = _data["preBOMID"];
            this.nozzleType = _data["nozzleType"];
            this.sapMaterialNumber = _data["sapMaterialNumber"];
            this.quantity = _data["quantity"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.fixedCutterPreBOM = _data["fixedCutterPreBOM"] ? FixedCutterInput.fromJS(_data["fixedCutterPreBOM"]) : <any>undefined;
            this.createdBy_User = _data["createdBy_User"] ? User.fromJS(_data["createdBy_User"]) : <any>undefined;
            this.modifiedBy_User = _data["modifiedBy_User"] ? User.fromJS(_data["modifiedBy_User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FixedCutterNozzleLiner {
        data = typeof data === 'object' ? data : {};
        let result = new FixedCutterNozzleLiner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["preBOMID"] = this.preBOMID;
        data["nozzleType"] = this.nozzleType;
        data["sapMaterialNumber"] = this.sapMaterialNumber;
        data["quantity"] = this.quantity;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["fixedCutterPreBOM"] = this.fixedCutterPreBOM ? this.fixedCutterPreBOM.toJSON() : <any>undefined;
        data["createdBy_User"] = this.createdBy_User ? this.createdBy_User.toJSON() : <any>undefined;
        data["modifiedBy_User"] = this.modifiedBy_User ? this.modifiedBy_User.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFixedCutterNozzleLiner {
    id?: number;
    preBOMID?: number;
    nozzleType?: string | undefined;
    sapMaterialNumber?: number;
    quantity?: number;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    fixedCutterPreBOM?: FixedCutterInput;
    createdBy_User?: User;
    modifiedBy_User?: User;
}

export class FixedCutterPowder implements IFixedCutterPowder {
    id?: number;
    preBOMID?: number;
    powderType?: string | undefined;
    sapMaterialNumber?: number;
    powderWeight?: number;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    fixedCutterPreBOM?: FixedCutterInput;
    createdBy_User?: User;
    modifiedBy_User?: User;

    constructor(data?: IFixedCutterPowder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.preBOMID = _data["preBOMID"];
            this.powderType = _data["powderType"];
            this.sapMaterialNumber = _data["sapMaterialNumber"];
            this.powderWeight = _data["powderWeight"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.fixedCutterPreBOM = _data["fixedCutterPreBOM"] ? FixedCutterInput.fromJS(_data["fixedCutterPreBOM"]) : <any>undefined;
            this.createdBy_User = _data["createdBy_User"] ? User.fromJS(_data["createdBy_User"]) : <any>undefined;
            this.modifiedBy_User = _data["modifiedBy_User"] ? User.fromJS(_data["modifiedBy_User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FixedCutterPowder {
        data = typeof data === 'object' ? data : {};
        let result = new FixedCutterPowder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["preBOMID"] = this.preBOMID;
        data["powderType"] = this.powderType;
        data["sapMaterialNumber"] = this.sapMaterialNumber;
        data["powderWeight"] = this.powderWeight;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["fixedCutterPreBOM"] = this.fixedCutterPreBOM ? this.fixedCutterPreBOM.toJSON() : <any>undefined;
        data["createdBy_User"] = this.createdBy_User ? this.createdBy_User.toJSON() : <any>undefined;
        data["modifiedBy_User"] = this.modifiedBy_User ? this.modifiedBy_User.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFixedCutterPowder {
    id?: number;
    preBOMID?: number;
    powderType?: string | undefined;
    sapMaterialNumber?: number;
    powderWeight?: number;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    fixedCutterPreBOM?: FixedCutterInput;
    createdBy_User?: User;
    modifiedBy_User?: User;
}

export class FixedCutterRingGauge implements IFixedCutterRingGauge {
    id?: number;
    preBOMID?: number;
    ringGaugesId?: number;
    fixedCutterPreBOM?: FixedCutterInput;
    ringGauge?: RingGauge;

    constructor(data?: IFixedCutterRingGauge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.preBOMID = _data["preBOMID"];
            this.ringGaugesId = _data["ringGaugesId"];
            this.fixedCutterPreBOM = _data["fixedCutterPreBOM"] ? FixedCutterInput.fromJS(_data["fixedCutterPreBOM"]) : <any>undefined;
            this.ringGauge = _data["ringGauge"] ? RingGauge.fromJS(_data["ringGauge"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FixedCutterRingGauge {
        data = typeof data === 'object' ? data : {};
        let result = new FixedCutterRingGauge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["preBOMID"] = this.preBOMID;
        data["ringGaugesId"] = this.ringGaugesId;
        data["fixedCutterPreBOM"] = this.fixedCutterPreBOM ? this.fixedCutterPreBOM.toJSON() : <any>undefined;
        data["ringGauge"] = this.ringGauge ? this.ringGauge.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFixedCutterRingGauge {
    id?: number;
    preBOMID?: number;
    ringGaugesId?: number;
    fixedCutterPreBOM?: FixedCutterInput;
    ringGauge?: RingGauge;
}

export class FixedCutterSleeve implements IFixedCutterSleeve {
    id?: number;
    preBOMID?: number;
    sleeveLength?: number | undefined;
    roughLength?: number | undefined;
    sleeveGaugeDrawingNumber?: string | undefined;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    sleeveExposure?: string | undefined;
    sleeveGauge?: string | undefined;
    sleeveType?: string | undefined;
    cuttersOnSleeve?: boolean | undefined;
    fixedCutterPreBOM?: FixedCutterInput;
    createdBy_User?: User;
    modifiedBy_User?: User;

    constructor(data?: IFixedCutterSleeve) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.preBOMID = _data["preBOMID"];
            this.sleeveLength = _data["sleeveLength"];
            this.roughLength = _data["roughLength"];
            this.sleeveGaugeDrawingNumber = _data["sleeveGaugeDrawingNumber"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.sleeveExposure = _data["sleeveExposure"];
            this.sleeveGauge = _data["sleeveGauge"];
            this.sleeveType = _data["sleeveType"];
            this.cuttersOnSleeve = _data["cuttersOnSleeve"];
            this.fixedCutterPreBOM = _data["fixedCutterPreBOM"] ? FixedCutterInput.fromJS(_data["fixedCutterPreBOM"]) : <any>undefined;
            this.createdBy_User = _data["createdBy_User"] ? User.fromJS(_data["createdBy_User"]) : <any>undefined;
            this.modifiedBy_User = _data["modifiedBy_User"] ? User.fromJS(_data["modifiedBy_User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FixedCutterSleeve {
        data = typeof data === 'object' ? data : {};
        let result = new FixedCutterSleeve();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["preBOMID"] = this.preBOMID;
        data["sleeveLength"] = this.sleeveLength;
        data["roughLength"] = this.roughLength;
        data["sleeveGaugeDrawingNumber"] = this.sleeveGaugeDrawingNumber;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["sleeveExposure"] = this.sleeveExposure;
        data["sleeveGauge"] = this.sleeveGauge;
        data["sleeveType"] = this.sleeveType;
        data["cuttersOnSleeve"] = this.cuttersOnSleeve;
        data["fixedCutterPreBOM"] = this.fixedCutterPreBOM ? this.fixedCutterPreBOM.toJSON() : <any>undefined;
        data["createdBy_User"] = this.createdBy_User ? this.createdBy_User.toJSON() : <any>undefined;
        data["modifiedBy_User"] = this.modifiedBy_User ? this.modifiedBy_User.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFixedCutterSleeve {
    id?: number;
    preBOMID?: number;
    sleeveLength?: number | undefined;
    roughLength?: number | undefined;
    sleeveGaugeDrawingNumber?: string | undefined;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    sleeveExposure?: string | undefined;
    sleeveGauge?: string | undefined;
    sleeveType?: string | undefined;
    cuttersOnSleeve?: boolean | undefined;
    fixedCutterPreBOM?: FixedCutterInput;
    createdBy_User?: User;
    modifiedBy_User?: User;
}

export class Int32Limits implements IInt32Limits {
    upper?: number;
    lower?: number;

    constructor(data?: IInt32Limits) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.upper = _data["upper"];
            this.lower = _data["lower"];
        }
    }

    static fromJS(data: any): Int32Limits {
        data = typeof data === 'object' ? data : {};
        let result = new Int32Limits();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["upper"] = this.upper;
        data["lower"] = this.lower;
        return data;
    }
}

export interface IInt32Limits {
    upper?: number;
    lower?: number;
}

export class LiftingApparatus implements ILiftingApparatus {
    id?: number;
    liftingType?: string | undefined;
    sapNumber?: number | undefined;
    modifiedBy?: string | undefined;
    modifiedDate?: string | undefined;
    createdDate?: Date;
    createdBy?: string | undefined;
    bitBreakers?: BitBreaker[] | undefined;

    constructor(data?: ILiftingApparatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.liftingType = _data["liftingType"];
            this.sapNumber = _data["sapNumber"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            if (Array.isArray(_data["bitBreakers"])) {
                this.bitBreakers = [] as any;
                for (let item of _data["bitBreakers"])
                    this.bitBreakers!.push(BitBreaker.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiftingApparatus {
        data = typeof data === 'object' ? data : {};
        let result = new LiftingApparatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["liftingType"] = this.liftingType;
        data["sapNumber"] = this.sapNumber;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        if (Array.isArray(this.bitBreakers)) {
            data["bitBreakers"] = [];
            for (let item of this.bitBreakers)
                data["bitBreakers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiftingApparatus {
    id?: number;
    liftingType?: string | undefined;
    sapNumber?: number | undefined;
    modifiedBy?: string | undefined;
    modifiedDate?: string | undefined;
    createdDate?: Date;
    createdBy?: string | undefined;
    bitBreakers?: BitBreaker[] | undefined;
}

export class MaterialMasterPurchasePartRequest implements IMaterialMasterPurchasePartRequest {
    materialWeight?: string | undefined;
    mrp?: string | undefined;
    componentDescription?: string | undefined;
    userId?: number;
    requestTargetId?: number;
    oldMaterial?: string | undefined;
    purchasePart?: number;
    procurementType?: number;
    unitofMeasure?: string | undefined;
    productHierarchy?: string | undefined;
    materialType?: number;

    constructor(data?: IMaterialMasterPurchasePartRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialWeight = _data["materialWeight"];
            this.mrp = _data["mrp"];
            this.componentDescription = _data["componentDescription"];
            this.userId = _data["userId"];
            this.requestTargetId = _data["requestTargetId"];
            this.oldMaterial = _data["oldMaterial"];
            this.purchasePart = _data["purchasePart"];
            this.procurementType = _data["procurementType"];
            this.unitofMeasure = _data["unitofMeasure"];
            this.productHierarchy = _data["productHierarchy"];
            this.materialType = _data["materialType"];
        }
    }

    static fromJS(data: any): MaterialMasterPurchasePartRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialMasterPurchasePartRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialWeight"] = this.materialWeight;
        data["mrp"] = this.mrp;
        data["componentDescription"] = this.componentDescription;
        data["userId"] = this.userId;
        data["requestTargetId"] = this.requestTargetId;
        data["oldMaterial"] = this.oldMaterial;
        data["purchasePart"] = this.purchasePart;
        data["procurementType"] = this.procurementType;
        data["unitofMeasure"] = this.unitofMeasure;
        data["productHierarchy"] = this.productHierarchy;
        data["materialType"] = this.materialType;
        return data;
    }
}

export interface IMaterialMasterPurchasePartRequest {
    materialWeight?: string | undefined;
    mrp?: string | undefined;
    componentDescription?: string | undefined;
    userId?: number;
    requestTargetId?: number;
    oldMaterial?: string | undefined;
    purchasePart?: number;
    procurementType?: number;
    unitofMeasure?: string | undefined;
    productHierarchy?: string | undefined;
    materialType?: number;
}

export class MaterialMasterRequest implements IMaterialMasterRequest {
    materialWeight?: string | undefined;
    bitLevel?: number;
    bit_Productline?: number;
    bit_SubPsl?: number;
    size?: number;
    coreSize?: number;
    bitType?: string | undefined;
    hasSleeve?: boolean;
    mfgPlant?: string | undefined;
    isJV?: boolean;
    userId?: number;
    requestTargetId?: number;

    constructor(data?: IMaterialMasterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialWeight = _data["materialWeight"];
            this.bitLevel = _data["bitLevel"];
            this.bit_Productline = _data["bit_Productline"];
            this.bit_SubPsl = _data["bit_SubPsl"];
            this.size = _data["size"];
            this.coreSize = _data["coreSize"];
            this.bitType = _data["bitType"];
            this.hasSleeve = _data["hasSleeve"];
            this.mfgPlant = _data["mfgPlant"];
            this.isJV = _data["isJV"];
            this.userId = _data["userId"];
            this.requestTargetId = _data["requestTargetId"];
        }
    }

    static fromJS(data: any): MaterialMasterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialMasterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialWeight"] = this.materialWeight;
        data["bitLevel"] = this.bitLevel;
        data["bit_Productline"] = this.bit_Productline;
        data["bit_SubPsl"] = this.bit_SubPsl;
        data["size"] = this.size;
        data["coreSize"] = this.coreSize;
        data["bitType"] = this.bitType;
        data["hasSleeve"] = this.hasSleeve;
        data["mfgPlant"] = this.mfgPlant;
        data["isJV"] = this.isJV;
        data["userId"] = this.userId;
        data["requestTargetId"] = this.requestTargetId;
        return data;
    }
}

export interface IMaterialMasterRequest {
    materialWeight?: string | undefined;
    bitLevel?: number;
    bit_Productline?: number;
    bit_SubPsl?: number;
    size?: number;
    coreSize?: number;
    bitType?: string | undefined;
    hasSleeve?: boolean;
    mfgPlant?: string | undefined;
    isJV?: boolean;
    userId?: number;
    requestTargetId?: number;
}

export class MaterialMasterUpdateRequest implements IMaterialMasterUpdateRequest {
    materialWeight?: string | undefined;
    mrp?: string | undefined;
    componentDescription?: string | undefined;
    userId?: number;
    requestTargetId?: number;
    oldMaterial?: string | undefined;
    material!: string | undefined;
    purchasePart?: number | undefined;
    procurementType?: number | undefined;
    unitofMeasure?: string | undefined;
    productHierarchy?: string | undefined;
    materialType?: number | undefined;

    constructor(data?: IMaterialMasterUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialWeight = _data["materialWeight"];
            this.mrp = _data["mrp"];
            this.componentDescription = _data["componentDescription"];
            this.userId = _data["userId"];
            this.requestTargetId = _data["requestTargetId"];
            this.oldMaterial = _data["oldMaterial"];
            this.material = _data["material"];
            this.purchasePart = _data["purchasePart"];
            this.procurementType = _data["procurementType"];
            this.unitofMeasure = _data["unitofMeasure"];
            this.productHierarchy = _data["productHierarchy"];
            this.materialType = _data["materialType"];
        }
    }

    static fromJS(data: any): MaterialMasterUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialMasterUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialWeight"] = this.materialWeight;
        data["mrp"] = this.mrp;
        data["componentDescription"] = this.componentDescription;
        data["userId"] = this.userId;
        data["requestTargetId"] = this.requestTargetId;
        data["oldMaterial"] = this.oldMaterial;
        data["material"] = this.material;
        data["purchasePart"] = this.purchasePart;
        data["procurementType"] = this.procurementType;
        data["unitofMeasure"] = this.unitofMeasure;
        data["productHierarchy"] = this.productHierarchy;
        data["materialType"] = this.materialType;
        return data;
    }
}

export interface IMaterialMasterUpdateRequest {
    materialWeight?: string | undefined;
    mrp?: string | undefined;
    componentDescription?: string | undefined;
    userId?: number;
    requestTargetId?: number;
    oldMaterial?: string | undefined;
    material: string | undefined;
    purchasePart?: number | undefined;
    procurementType?: number | undefined;
    unitofMeasure?: string | undefined;
    productHierarchy?: string | undefined;
    materialType?: number | undefined;
}

export class ORD_Bit implements IORD_Bit {
    id?: number;
    orderId?: number;
    size?: number | undefined;
    type?: string | undefined;
    level?: number | undefined;
    sleeve?: boolean;
    retroFit?: boolean;
    gaugeLength?: number | undefined;
    hardfacing?: string | undefined;
    onePiece?: boolean | undefined;
    isBHSModified?: boolean | undefined;
    iadc?: string | undefined;
    coreSize?: number | undefined;
    bitFeatures?: string | undefined;
    uppersection_Id?: number | undefined;
    breaker_Id?: number | undefined;
    uppersection_Electronic_Id?: number | undefined;
    order?: ORD_Order;

    constructor(data?: IORD_Bit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.size = _data["size"];
            this.type = _data["type"];
            this.level = _data["level"];
            this.sleeve = _data["sleeve"];
            this.retroFit = _data["retroFit"];
            this.gaugeLength = _data["gaugeLength"];
            this.hardfacing = _data["hardfacing"];
            this.onePiece = _data["onePiece"];
            this.isBHSModified = _data["isBHSModified"];
            this.iadc = _data["iadc"];
            this.coreSize = _data["coreSize"];
            this.bitFeatures = _data["bitFeatures"];
            this.uppersection_Id = _data["uppersection_Id"];
            this.breaker_Id = _data["breaker_Id"];
            this.uppersection_Electronic_Id = _data["uppersection_Electronic_Id"];  
            this.order = _data["order"] ? ORD_Order.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ORD_Bit {
        data = typeof data === 'object' ? data : {};
        let result = new ORD_Bit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["size"] = this.size;
        data["type"] = this.type;
        data["level"] = this.level;
        data["sleeve"] = this.sleeve;
        data["retroFit"] = this.retroFit;
        data["gaugeLength"] = this.gaugeLength;
        data["hardfacing"] = this.hardfacing;
        data["onePiece"] = this.onePiece;
        data["isBHSModified"] = this.isBHSModified;
        data["iadc"] = this.iadc;
        data["coreSize"] = this.coreSize;
        data["bitFeatures"] = this.bitFeatures;
        data["uppersection_Id"] = this.uppersection_Id;
        data["breaker_Id"] = this.breaker_Id;
        data["uppersection_Electronic_Id"] = this.uppersection_Electronic_Id;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data;
    }
}

export interface IORD_Bit {
    id?: number;
    orderId?: number;
    size?: number | undefined;
    type?: string | undefined;
    level?: number | undefined;
    sleeve?: boolean;
    retroFit?: boolean;
    gaugeLength?: number | undefined;
    hardfacing?: string | undefined;
    onePiece?: boolean | undefined;
    isBHSModified?: boolean | undefined;
    iadc?: string | undefined;
    coreSize?: number | undefined;
    bitFeatures?: string | undefined;
    uppersection_Id?: number | undefined;
    order?: ORD_Order;
}

export class ORD_CerebroInfluence implements IORD_CerebroInfluence {
    id?: number;
    orderId?: number;
    type?: number;
    cerebroInfluenceType?: CerebroInfluenceType;
    orD_Order?: ORD_Order;

    constructor(data?: IORD_CerebroInfluence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.type = _data["type"];
            this.cerebroInfluenceType = _data["cerebroInfluenceType"] ? CerebroInfluenceType.fromJS(_data["cerebroInfluenceType"]) : <any>undefined;
            this.orD_Order = _data["orD_Order"] ? ORD_Order.fromJS(_data["orD_Order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ORD_CerebroInfluence {
        data = typeof data === 'object' ? data : {};
        let result = new ORD_CerebroInfluence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["type"] = this.type;
        data["cerebroInfluenceType"] = this.cerebroInfluenceType ? this.cerebroInfluenceType.toJSON() : <any>undefined;
        data["orD_Order"] = this.orD_Order ? this.orD_Order.toJSON() : <any>undefined;
        return data;
    }
}

export interface IORD_CerebroInfluence {
    id?: number;
    orderId?: number;
    type?: number;
    cerebroInfluenceType?: CerebroInfluenceType;
    orD_Order?: ORD_Order;
}

export class ORD_Communication implements IORD_Communication {
    id?: number;
    orderId?: number;
    userId?: number;
    message?: string | undefined;
    timestamp?: Date;
    order?: ORD_Order;
    user?: User;
    userDisplayName?: string | undefined;

    constructor(data?: IORD_Communication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.userId = _data["userId"];
            this.message = _data["message"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.order = _data["order"] ? ORD_Order.fromJS(_data["order"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userDisplayName = _data["userDisplayName"];
        }
    }

    static fromJS(data: any): ORD_Communication {
        data = typeof data === 'object' ? data : {};
        let result = new ORD_Communication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["userId"] = this.userId;
        data["message"] = this.message;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userDisplayName"] = this.userDisplayName;
        return data;
    }
}

export interface IORD_Communication {
    id?: number;
    orderId?: number;
    userId?: number;
    message?: string | undefined;
    timestamp?: Date;
    order?: ORD_Order;
    user?: User;
    userDisplayName?: string | undefined;
}

export class ORD_CostSaving implements IORD_CostSaving {
    orderId?: number;
    refBitCost?: number | undefined;
    rtaBitCost?: number | undefined;
    justification?: string | undefined;
    totalSavings?: number | undefined;
    json?: string | undefined;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    orD_Order?: ORD_Order;

    constructor(data?: IORD_CostSaving) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.refBitCost = _data["refBitCost"];
            this.rtaBitCost = _data["rtaBitCost"];
            this.justification = _data["justification"];
            this.totalSavings = _data["totalSavings"];
            this.json = _data["json"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.orD_Order = _data["orD_Order"] ? ORD_Order.fromJS(_data["orD_Order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ORD_CostSaving {
        data = typeof data === 'object' ? data : {};
        let result = new ORD_CostSaving();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["refBitCost"] = this.refBitCost;
        data["rtaBitCost"] = this.rtaBitCost;
        data["justification"] = this.justification;
        data["totalSavings"] = this.totalSavings;
        data["json"] = this.json;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["orD_Order"] = this.orD_Order ? this.orD_Order.toJSON() : <any>undefined;
        return data;
    }
}

export interface IORD_CostSaving {
    orderId?: number;
    refBitCost?: number | undefined;
    rtaBitCost?: number | undefined;
    justification?: string | undefined;
    totalSavings?: number | undefined;
    json?: string | undefined;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    orD_Order?: ORD_Order;
}

export class ORD_CutterMap implements IORD_CutterMap {
    id?: number;
    order_Id?: number;
    bladeNumber?: number;
    rowNumber?: number;
    numberOnRow?: number;
    facePosition?: string | undefined;
    pdcCutter_Id?: number | undefined;
    createdDate?: Date;
    shape_Id?: number;
    shape_Type?: string | undefined;
    zone?: string | undefined;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    order?: ORD_Order;
    pdcCutter?: PDCCutter;

    constructor(data?: IORD_CutterMap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order_Id = _data["order_Id"];
            this.bladeNumber = _data["bladeNumber"];
            this.rowNumber = _data["rowNumber"];
            this.numberOnRow = _data["numberOnRow"];
            this.facePosition = _data["facePosition"];
            this.pdcCutter_Id = _data["pdcCutter_Id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.shape_Id = _data["shape_Id"];
            this.shape_Type = _data["shape_Type"];
            this.zone = _data["zone"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.order = _data["order"] ? ORD_Order.fromJS(_data["order"]) : <any>undefined;
            this.pdcCutter = _data["pdcCutter"] ? PDCCutter.fromJS(_data["pdcCutter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ORD_CutterMap {
        data = typeof data === 'object' ? data : {};
        let result = new ORD_CutterMap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order_Id"] = this.order_Id;
        data["bladeNumber"] = this.bladeNumber;
        data["rowNumber"] = this.rowNumber;
        data["numberOnRow"] = this.numberOnRow;
        data["facePosition"] = this.facePosition;
        data["pdcCutter_Id"] = this.pdcCutter_Id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["shape_Id"] = this.shape_Id;
        data["shape_Type"] = this.shape_Type;
        data["zone"] = this.zone;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["pdcCutter"] = this.pdcCutter ? this.pdcCutter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IORD_CutterMap {
    id?: number;
    order_Id?: number;
    bladeNumber?: number;
    rowNumber?: number;
    numberOnRow?: number;
    facePosition?: string | undefined;
    pdcCutter_Id?: number | undefined;
    createdDate?: Date;
    shape_Id?: number;
    shape_Type?: string | undefined;
    zone?: string | undefined;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    order?: ORD_Order;
    pdcCutter?: PDCCutter;
}

export class ORD_Gauge implements IORD_Gauge {
    id?: number;
    orderId?: number;
    leftRadii?: number | undefined;
    rightRadii?: number | undefined;
    bladeNumber?: number | undefined;
    order?: ORD_Order;

    constructor(data?: IORD_Gauge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.leftRadii = _data["leftRadii"];
            this.rightRadii = _data["rightRadii"];
            this.bladeNumber = _data["bladeNumber"];
            this.order = _data["order"] ? ORD_Order.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ORD_Gauge {
        data = typeof data === 'object' ? data : {};
        let result = new ORD_Gauge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["leftRadii"] = this.leftRadii;
        data["rightRadii"] = this.rightRadii;
        data["bladeNumber"] = this.bladeNumber;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data;
    }
}

export interface IORD_Gauge {
    id?: number;
    orderId?: number;
    leftRadii?: number | undefined;
    rightRadii?: number | undefined;
    bladeNumber?: number | undefined;
    order?: ORD_Order;
}

export class ORD_GaugeProtection implements IORD_GaugeProtection {
    id?: number;
    orderId?: number;
    protection?: string | undefined;

    constructor(data?: IORD_GaugeProtection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.protection = _data["protection"];
        }
    }

    static fromJS(data: any): ORD_GaugeProtection {
        data = typeof data === 'object' ? data : {};
        let result = new ORD_GaugeProtection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["protection"] = this.protection;
        return data;
    }
}

export interface IORD_GaugeProtection {
    id?: number;
    orderId?: number;
    protection?: string | undefined;
}

export class ORD_History implements IORD_History {
  id?: number;
  orderId?: number;
  characteristic?: string | undefined;
  oldVal?: string | undefined;
  newVal?: string | undefined;
  userId?: number;
  modifiedDate?: Date;

  // new flat fields from Common.User
  userDisplayName?: string;
  loginID?: string;
  email?: string;

  // existing refs
  user?: User;
  order?: ORD_Order;

  constructor(data?: IORD_History) {
    if (data) {
      for (const property in data) {
        if (Object.prototype.hasOwnProperty.call(data, property)) {
          (this as any)[property] = (data as any)[property];
        }
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.orderId = _data["orderId"];
      this.characteristic = _data["characteristic"];
      this.oldVal = _data["oldVal"];
      this.newVal = _data["newVal"];
      this.userId = _data["userId"];
      this.modifiedDate = _data["modifiedDate"]
        ? new Date(_data["modifiedDate"].toString())
        : (undefined as any);

      // new fields (camelCase first; fallback to PascalCase just in case)
      this.userDisplayName = _data["userDisplayName"] ?? _data["UserDisplayName"];
      this.loginID = _data["loginID"] ?? _data["LoginID"];
      this.email = _data["email"] ?? _data["Email"];

      this.user = _data["user"] ? User.fromJS(_data["user"]) : (undefined as any);
      this.order = _data["order"] ? ORD_Order.fromJS(_data["order"]) : (undefined as any);
    }
  }

  static fromJS(data: any): ORD_History {
    data = typeof data === "object" ? data : {};
    const result = new ORD_History();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["orderId"] = this.orderId;
    data["characteristic"] = this.characteristic;
    data["oldVal"] = this.oldVal;
    data["newVal"] = this.newVal;
    data["userId"] = this.userId;
    data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : (undefined as any);

    data["user"] = this.user ? this.user.toJSON() : (undefined as any);
    data["order"] = this.order ? this.order.toJSON() : (undefined as any);
    return data;
  }

  // Optional convenience getter
  get modifiedBy(): string | undefined {
    if (this.userDisplayName && this.loginID) return `${this.userDisplayName} (${this.loginID})`;
    return this.userDisplayName ?? this.loginID ?? this.email;
  }
}

export interface IORD_History {
  id?: number;
  orderId?: number;
  characteristic?: string | undefined;
  oldVal?: string | undefined;
  newVal?: string | undefined;
  userId?: number;
  modifiedDate?: Date;

  // new flat fields
  userDisplayName?: string;
  loginID?: string;
  email?: string;

  user?: User;
  order?: ORD_Order;
}

export class ORD_Nozzle implements IORD_Nozzle {
    id?: number;
    orderId?: number;
    number?: number;
    type?: string | undefined;
    size?: number | undefined;

    constructor(data?: IORD_Nozzle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.number = _data["number"];
            this.type = _data["type"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): ORD_Nozzle {
        data = typeof data === 'object' ? data : {};
        let result = new ORD_Nozzle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["number"] = this.number;
        data["type"] = this.type;
        data["size"] = this.size;
        return data;
    }
}

export interface IORD_Nozzle {
    id?: number;
    orderId?: number;
    number?: number;
    type?: string | undefined;
    size?: number | undefined;
}

export class ORD_Order implements IORD_Order {
    id?: number;
    seriesId?: number;
    submittedBy?: number;
    requiredDate?: Date | undefined;
    typeId?: number;
    priority?: number;
    statusId?: number;
    description?: string | undefined;
    applicationId?: number | undefined;
    subPsl?: number;
    productLine?: number;
    parent_ORD_OrderId?: number | undefined;
    partId?: number | undefined;
    nwA_ApplicationId?: number | undefined;
    onHold?: boolean | undefined;
    cancelled?: boolean | undefined;
    targetCustomer?: string | undefined;
    difference?: string | undefined;
    centralDesignRequested?: boolean;
    designedBy?: number | undefined;
    notesToDesignSupport?: string | undefined;
    requestExclusion?: boolean;
    isJuggernaut?: boolean;
    isOculusInfluenced?: boolean;
    fieldRequest_Id?: number | undefined;
    series?: Series;
    orderFiles?: ORD_OrderFile[] | undefined;
    rollerCone?: RollerCone | undefined;
    steps?: ORD_Step[] | undefined;
    submittedByUser?: User;
    designedByUser?: User;
    gauge?: ORD_Gauge[] | undefined;
    nozzles?: ORD_Nozzle[] | undefined;
    powders?: ORD_Powder[] | undefined;
    gaugeProtections?: ORD_GaugeProtection[] | undefined;
    bit?: ORD_Bit;
    uppersection?: ORD_Uppersection;
    application?: Application;
    communication?: ORD_Communication[] | undefined;
    history?: ORD_History[] | undefined;
    opportunity?: Opportunity;
    orD_Priority?: ORD_Priority;
    priorities?: Priority;
    productLines?: ProductLine;
    subPsls?: SubPSL;
    activeProblems?: ActiveProblem[] | undefined;
    orderFeatureAssociations?: OrderFeatureAssociation[] | undefined;
    sapNumbers?: SapNumber[] | undefined;
    orD_CostSaving?: ORD_CostSaving;
    type?: RtaType;
    part?: Part;
    nwA_Application?: Application;
    process?: Process;
    mudTypes?: Field_MudType[] | undefined;
    fixedCutterPreBOM?: FixedCutterInput | undefined;
    checkSheets?: CheckSheet[] | undefined;
    orD_Cerebro?: Ord_Cerebro;
    programTrackers?: ProgramTracker[] | undefined;
    specialInstruction_RTAAssociation?: SpecialInstruction_RTAAssociation[] | undefined;
    drawingLogOrderAssociations?: Bom_DrawingLogOrderAssociation[] | undefined;
    customerRequirements?: CustomerRequirement[] | undefined;
    orD_CerebroInfluence?: ORD_CerebroInfluence[] | undefined;
    order_DataAnalysis_DataSource?: Order_DataAnalysis_DataSource[] | undefined;
    orderTasks?: OrderTask[] | undefined;
    orD_CutterMap?: ORD_CutterMap[] | undefined;
    arm?: ORD_Arm | undefined;
    bitWeight?: number;
    isComplete?: boolean;

    constructor(data?: IORD_Order) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.seriesId = _data["seriesId"];
            this.submittedBy = _data["submittedBy"];
            this.requiredDate = _data["requiredDate"] ? new Date(_data["requiredDate"].toString()) : <any>undefined;
            this.typeId = _data["typeId"];
            this.priority = _data["priority"];
            this.statusId = _data["statusId"];
            this.description = _data["description"];
            this.applicationId = _data["applicationId"];
            this.subPsl = _data["subPsl"];
            this.productLine = _data["productLine"];
            this.parent_ORD_OrderId = _data["parent_ORD_OrderId"];
            this.partId = _data["partId"];
            this.nwA_ApplicationId = _data["nwA_ApplicationId"];
            this.onHold = _data["onHold"];
            this.cancelled = _data["cancelled"];
            this.targetCustomer = _data["targetCustomer"];
            this.difference = _data["difference"];
            this.centralDesignRequested = _data["centralDesignRequested"];
            this.designedBy = _data["designedBy"];
            this.notesToDesignSupport = _data["notesToDesignSupport"];
            this.requestExclusion = _data["requestExclusion"];
            this.isJuggernaut = _data["isJuggernaut"];
            this.isOculusInfluenced = _data["isOculusInfluenced"];
            this.fieldRequest_Id = _data["fieldRequest_Id"];
            this.series = _data["series"] ? Series.fromJS(_data["series"]) : <any>undefined;
            if (Array.isArray(_data["orderFiles"])) {
                this.orderFiles = [] as any;
                for (let item of _data["orderFiles"])
                    this.orderFiles!.push(ORD_OrderFile.fromJS(item));
            }
            this.rollerCone = _data["rollerCone"] ? RollerCone.fromJS(_data["rollerCone"]) : <any>undefined;
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(ORD_Step.fromJS(item));
            }
            this.submittedByUser = _data["submittedByUser"] ? User.fromJS(_data["submittedByUser"]) : <any>undefined;
            this.designedByUser = _data["designedByUser"] ? User.fromJS(_data["designedByUser"]) : <any>undefined;
            if (Array.isArray(_data["gauge"])) {
                this.gauge = [] as any;
                for (let item of _data["gauge"])
                    this.gauge!.push(ORD_Gauge.fromJS(item));
            }
            if (Array.isArray(_data["nozzles"])) {
                this.nozzles = [] as any;
                for (let item of _data["nozzles"])
                    this.nozzles!.push(ORD_Nozzle.fromJS(item));
            }
            if (Array.isArray(_data["powders"])) {
                this.powders = [] as any;
                for (let item of _data["powders"])
                    this.powders!.push(ORD_Powder.fromJS(item));
            }
            if (Array.isArray(_data["gaugeProtections"])) {
                this.gaugeProtections = [] as any;
                for (let item of _data["gaugeProtections"])
                    this.gaugeProtections!.push(ORD_GaugeProtection.fromJS(item));
            }
            this.bit = _data["bit"] ? ORD_Bit.fromJS(_data["bit"]) : <any>undefined;
            this.uppersection = _data["uppersection"] ? ORD_Uppersection.fromJS(_data["uppersection"]) : <any>undefined;
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            if (Array.isArray(_data["communication"])) {
                this.communication = [] as any;
                for (let item of _data["communication"])
                    this.communication!.push(ORD_Communication.fromJS(item));
            }
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(ORD_History.fromJS(item));
            }
            this.opportunity = _data["opportunity"] ? Opportunity.fromJS(_data["opportunity"]) : <any>undefined;
            this.orD_Priority = _data["orD_Priority"] ? ORD_Priority.fromJS(_data["orD_Priority"]) : <any>undefined;
            this.priorities = _data["priorities"] ? Priority.fromJS(_data["priorities"]) : <any>undefined;
            this.productLines = _data["productLines"] ? ProductLine.fromJS(_data["productLines"]) : <any>undefined;
            this.subPsls = _data["subPsls"] ? SubPSL.fromJS(_data["subPsls"]) : <any>undefined;
            if (Array.isArray(_data["activeProblems"])) {
                this.activeProblems = [] as any;
                for (let item of _data["activeProblems"])
                    this.activeProblems!.push(ActiveProblem.fromJS(item));
            }
            if (Array.isArray(_data["orderFeatureAssociations"])) {
                this.orderFeatureAssociations = [] as any;
                for (let item of _data["orderFeatureAssociations"])
                    this.orderFeatureAssociations!.push(OrderFeatureAssociation.fromJS(item));
            }
            if (Array.isArray(_data["sapNumbers"])) {
                this.sapNumbers = [] as any;
                for (let item of _data["sapNumbers"])
                    this.sapNumbers!.push(SapNumber.fromJS(item));
            }
            this.orD_CostSaving = _data["orD_CostSaving"] ? ORD_CostSaving.fromJS(_data["orD_CostSaving"]) : <any>undefined;
            this.type = _data["type"] ? RtaType.fromJS(_data["type"]) : <any>undefined;
            this.part = _data["part"] ? Part.fromJS(_data["part"]) : <any>undefined;
            this.nwA_Application = _data["nwA_Application"] ? Application.fromJS(_data["nwA_Application"]) : <any>undefined;
            this.process = _data["process"] ? Process.fromJS(_data["process"]) : <any>undefined;
            if (Array.isArray(_data["mudTypes"])) {
                this.mudTypes = [] as any;
                for (let item of _data["mudTypes"])
                    this.mudTypes!.push(Field_MudType.fromJS(item));
            }
            this.fixedCutterPreBOM = _data["fixedCutterPreBOM"] ? FixedCutterInput.fromJS(_data["fixedCutterPreBOM"]) : <any>undefined;

            if (Array.isArray(_data["checkSheets"])) {
                this.checkSheets = [] as any;
                for (let item of _data["checkSheets"])
                    this.checkSheets!.push(CheckSheet.fromJS(item));
            }
            this.orD_Cerebro = _data["orD_Cerebro"] ? Ord_Cerebro.fromJS(_data["orD_Cerebro"]) : <any>undefined;
            if (Array.isArray(_data["programTrackers"])) {
                this.programTrackers = [] as any;
                for (let item of _data["programTrackers"])
                    this.programTrackers!.push(ProgramTracker.fromJS(item));
            }
            if (Array.isArray(_data["specialInstruction_RTAAssociation"])) {
                this.specialInstruction_RTAAssociation = [] as any;
                for (let item of _data["specialInstruction_RTAAssociation"])
                    this.specialInstruction_RTAAssociation!.push(SpecialInstruction_RTAAssociation.fromJS(item));
            }
            if (Array.isArray(_data["drawingLogOrderAssociations"])) {
                this.drawingLogOrderAssociations = [] as any;
                for (let item of _data["drawingLogOrderAssociations"])
                    this.drawingLogOrderAssociations!.push(Bom_DrawingLogOrderAssociation.fromJS(item));
            }
            if (Array.isArray(_data["customerRequirements"])) {
                this.customerRequirements = [] as any;
                for (let item of _data["customerRequirements"])
                    this.customerRequirements!.push(CustomerRequirement.fromJS(item));
            }
            if (Array.isArray(_data["orD_CerebroInfluence"])) {
                this.orD_CerebroInfluence = [] as any;
                for (let item of _data["orD_CerebroInfluence"])
                    this.orD_CerebroInfluence!.push(ORD_CerebroInfluence.fromJS(item));
            }
            if (Array.isArray(_data["order_DataAnalysis_DataSource"])) {
                this.order_DataAnalysis_DataSource = [] as any;
                for (let item of _data["order_DataAnalysis_DataSource"])
                    this.order_DataAnalysis_DataSource!.push(Order_DataAnalysis_DataSource.fromJS(item));
            }
            if (Array.isArray(_data["orderTasks"])) {
                this.orderTasks = [] as any;
                for (let item of _data["orderTasks"])
                    this.orderTasks!.push(OrderTask.fromJS(item));
            }
            if (Array.isArray(_data["orD_CutterMap"])) {
                this.orD_CutterMap = [] as any;
                for (let item of _data["orD_CutterMap"])
                    this.orD_CutterMap!.push(ORD_CutterMap.fromJS(item));
            }
            this.bitWeight = _data["bitWeight"];
            this.isComplete = _data["isComplete"];
        }
    }

    static fromJS(data: any): ORD_Order {
        data = typeof data === 'object' ? data : {};
        let result = new ORD_Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["seriesId"] = this.seriesId;
        data["submittedBy"] = this.submittedBy;
        data["requiredDate"] = this.requiredDate ? this.requiredDate.toISOString() : <any>undefined;
        data["typeId"] = this.typeId;
        data["priority"] = this.priority;
        data["statusId"] = this.statusId;
        data["description"] = this.description;
        data["applicationId"] = this.applicationId;
        data["subPsl"] = this.subPsl;
        data["productLine"] = this.productLine;
        data["parent_ORD_OrderId"] = this.parent_ORD_OrderId;
        data["partId"] = this.partId;
        data["nwA_ApplicationId"] = this.nwA_ApplicationId;
        data["onHold"] = this.onHold;
        data["cancelled"] = this.cancelled;
        data["targetCustomer"] = this.targetCustomer;
        data["difference"] = this.difference;
        data["centralDesignRequested"] = this.centralDesignRequested;
        data["designedBy"] = this.designedBy;
        data["notesToDesignSupport"] = this.notesToDesignSupport;
        data["requestExclusion"] = this.requestExclusion;
        data["isJuggernaut"] = this.isJuggernaut;
        data["isOculusInfluenced"] = this.isOculusInfluenced;
        data["fieldRequest_Id"] = this.fieldRequest_Id;
        data["series"] = this.series ? this.series.toJSON() : <any>undefined;
        if (Array.isArray(this.orderFiles)) {
            data["orderFiles"] = [];
            for (let item of this.orderFiles)
                data["orderFiles"].push(item.toJSON());
        }
        data["rollerCone"] = this.rollerCone ? this.rollerCone.toJSON() : <any>undefined;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        data["submittedByUser"] = this.submittedByUser ? this.submittedByUser.toJSON() : <any>undefined;
        data["designedByUser"] = this.designedByUser ? this.designedByUser.toJSON() : <any>undefined;
        if (Array.isArray(this.gauge)) {
            data["gauge"] = [];
            for (let item of this.gauge)
                data["gauge"].push(item.toJSON());
        }
        if (Array.isArray(this.nozzles)) {
            data["nozzles"] = [];
            for (let item of this.nozzles)
                data["nozzles"].push(item.toJSON());
        }
        if (Array.isArray(this.powders)) {
            data["powders"] = [];
            for (let item of this.powders)
                data["powders"].push(item.toJSON());
        }
        if (Array.isArray(this.gaugeProtections)) {
            data["gaugeProtections"] = [];
            for (let item of this.gaugeProtections)
                data["gaugeProtections"].push(item.toJSON());
        }
        data["bit"] = this.bit ? this.bit.toJSON() : <any>undefined;
        data["uppersection"] = this.uppersection ? this.uppersection.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        if (Array.isArray(this.communication)) {
            data["communication"] = [];
            for (let item of this.communication)
                data["communication"].push(item.toJSON());
        }
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        data["opportunity"] = this.opportunity ? this.opportunity.toJSON() : <any>undefined;
        data["orD_Priority"] = this.orD_Priority ? this.orD_Priority.toJSON() : <any>undefined;
        data["priorities"] = this.priorities ? this.priorities.toJSON() : <any>undefined;
        data["productLines"] = this.productLines ? this.productLines.toJSON() : <any>undefined;
        data["subPsls"] = this.subPsls ? this.subPsls.toJSON() : <any>undefined;
        if (Array.isArray(this.activeProblems)) {
            data["activeProblems"] = [];
            for (let item of this.activeProblems)
                data["activeProblems"].push(item.toJSON());
        }
        if (Array.isArray(this.orderFeatureAssociations)) {
            data["orderFeatureAssociations"] = [];
            for (let item of this.orderFeatureAssociations)
                data["orderFeatureAssociations"].push(item.toJSON());
        }
        if (Array.isArray(this.sapNumbers)) {
            data["sapNumbers"] = [];
            for (let item of this.sapNumbers)
                data["sapNumbers"].push(item.toJSON());
        }
        data["orD_CostSaving"] = this.orD_CostSaving ? this.orD_CostSaving.toJSON() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["part"] = this.part ? this.part.toJSON() : <any>undefined;
        data["nwA_Application"] = this.nwA_Application ? this.nwA_Application.toJSON() : <any>undefined;
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        if (Array.isArray(this.mudTypes)) {
            data["mudTypes"] = [];
            for (let item of this.mudTypes)
                data["mudTypes"].push(item.toJSON());
        }
        data["fixedCutterPreBOM"] = this.fixedCutterPreBOM ? this.fixedCutterPreBOM.toJSON() : <any>undefined;
        if (Array.isArray(this.checkSheets)) {
            data["checkSheets"] = [];
            for (let item of this.checkSheets)
                data["checkSheets"].push(item.toJSON());
        }
        data["orD_Cerebro"] = this.orD_Cerebro ? this.orD_Cerebro.toJSON() : <any>undefined;
        if (Array.isArray(this.programTrackers)) {
            data["programTrackers"] = [];
            for (let item of this.programTrackers)
                data["programTrackers"].push(item.toJSON());
        }
        if (Array.isArray(this.specialInstruction_RTAAssociation)) {
            data["specialInstruction_RTAAssociation"] = [];
            for (let item of this.specialInstruction_RTAAssociation)
                data["specialInstruction_RTAAssociation"].push(item.toJSON());
        }
        if (Array.isArray(this.drawingLogOrderAssociations)) {
            data["drawingLogOrderAssociations"] = [];
            for (let item of this.drawingLogOrderAssociations)
                data["drawingLogOrderAssociations"].push(item.toJSON());
        }
        if (Array.isArray(this.customerRequirements)) {
            data["customerRequirements"] = [];
            for (let item of this.customerRequirements)
                data["customerRequirements"].push(item.toJSON());
        }
        if (Array.isArray(this.orD_CerebroInfluence)) {
            data["orD_CerebroInfluence"] = [];
            for (let item of this.orD_CerebroInfluence)
                data["orD_CerebroInfluence"].push(item.toJSON());
        }
        if (Array.isArray(this.order_DataAnalysis_DataSource)) {
            data["order_DataAnalysis_DataSource"] = [];
            for (let item of this.order_DataAnalysis_DataSource)
                data["order_DataAnalysis_DataSource"].push(item.toJSON());
        }
        if (Array.isArray(this.orderTasks)) {
            data["orderTasks"] = [];
            for (let item of this.orderTasks)
                data["orderTasks"].push(item.toJSON());
        }
        if (Array.isArray(this.orD_CutterMap)) {
            data["orD_CutterMap"] = [];
            for (let item of this.orD_CutterMap)
                data["orD_CutterMap"].push(item.toJSON());
        }
        data["bitWeight"] = this.bitWeight;
        data["isComplete"] = this.isComplete;
        return data;
    }
}

export interface IORD_Order {
    id?: number;
    seriesId?: number;
    submittedBy?: number;
    requiredDate?: Date | undefined;
    typeId?: number;
    priority?: number;
    statusId?: number;
    description?: string | undefined;
    applicationId?: number | undefined;
    subPsl?: number;
    productLine?: number;
    parent_ORD_OrderId?: number | undefined;
    partId?: number | undefined;
    nwA_ApplicationId?: number | undefined;
    onHold?: boolean | undefined;
    cancelled?: boolean | undefined;
    targetCustomer?: string | undefined;
    difference?: string | undefined;
    centralDesignRequested?: boolean;
    designedBy?: number | undefined;
    notesToDesignSupport?: string | undefined;
    requestExclusion?: boolean;
    isJuggernaut?: boolean;
    isOculusInfluenced?: boolean;
    fieldRequest_Id?: number | undefined;
    series?: Series;
    orderFiles?: ORD_OrderFile[] | undefined;
    rollerCone?: RollerCone | undefined;
    steps?: ORD_Step[] | undefined;
    submittedByUser?: User;
    designedByUser?: User;
    gauge?: ORD_Gauge[] | undefined;
    nozzles?: ORD_Nozzle[] | undefined;
    powders?: ORD_Powder[] | undefined;
    gaugeProtections?: ORD_GaugeProtection[] | undefined;
    bit?: ORD_Bit;
    uppersection?: ORD_Uppersection;
    application?: Application;
    communication?: ORD_Communication[] | undefined;
    history?: ORD_History[] | undefined;
    opportunity?: Opportunity;
    orD_Priority?: ORD_Priority;
    priorities?: Priority;
    productLines?: ProductLine;
    subPsls?: SubPSL;
    activeProblems?: ActiveProblem[] | undefined;
    orderFeatureAssociations?: OrderFeatureAssociation[] | undefined;
    sapNumbers?: SapNumber[] | undefined;
    orD_CostSaving?: ORD_CostSaving;
    type?: RtaType;
    part?: Part;
    nwA_Application?: Application;
    process?: Process;
    mudTypes?: Field_MudType[] | undefined;
    fixedCutterPreBOM?: FixedCutterInput | undefined;
    checkSheets?: CheckSheet[] | undefined;
    orD_Cerebro?: Ord_Cerebro;
    programTrackers?: ProgramTracker[] | undefined;
    specialInstruction_RTAAssociation?: SpecialInstruction_RTAAssociation[] | undefined;
    drawingLogOrderAssociations?: Bom_DrawingLogOrderAssociation[] | undefined;
    customerRequirements?: CustomerRequirement[] | undefined;
    orD_CerebroInfluence?: ORD_CerebroInfluence[] | undefined;
    order_DataAnalysis_DataSource?: Order_DataAnalysis_DataSource[] | undefined;
    orderTasks?: OrderTask[] | undefined;
    orD_CutterMap?: ORD_CutterMap[] | undefined;
    arm?: ORD_Arm | undefined;
    bitWeight?: number;
    isComplete?: boolean;
}

export class ORD_OrderFile implements IORD_OrderFile {
    id?: number;
    orderId?: number;
    fileId?: number;
    fileTypeDirectory_Id?: number | undefined;
    order?: ORD_Order;
    file?: FileVault_File;
    fileTypeDirectory?: FileVault_FileTypeDirectory;

    constructor(data?: IORD_OrderFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.fileId = _data["fileId"];
            this.fileTypeDirectory_Id = _data["fileTypeDirectory_Id"];
            this.order = _data["order"] ? ORD_Order.fromJS(_data["order"]) : <any>undefined;
            this.file = _data["file"] ? FileVault_File.fromJS(_data["file"]) : <any>undefined;
            this.fileTypeDirectory = _data["fileTypeDirectory"] ? FileVault_FileTypeDirectory.fromJS(_data["fileTypeDirectory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ORD_OrderFile {
        data = typeof data === 'object' ? data : {};
        let result = new ORD_OrderFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["fileId"] = this.fileId;
        data["fileTypeDirectory_Id"] = this.fileTypeDirectory_Id;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["fileTypeDirectory"] = this.fileTypeDirectory ? this.fileTypeDirectory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IORD_OrderFile {
    id?: number;
    orderId?: number;
    fileId?: number;
    fileTypeDirectory_Id?: number | undefined;
    order?: ORD_Order;
    file?: FileVault_File;
    fileTypeDirectory?: FileVault_FileTypeDirectory;
}

export class ORD_Powder implements IORD_Powder {
    id?: number;
    type?: string | undefined;
    location?: string | undefined;
    orderId?: number;
    order?: ORD_Order;

    constructor(data?: IORD_Powder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.location = _data["location"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? ORD_Order.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ORD_Powder {
        data = typeof data === 'object' ? data : {};
        let result = new ORD_Powder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["location"] = this.location;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data;
    }
}

export interface IORD_Powder {
    id?: number;
    type?: string | undefined;
    location?: string | undefined;
    orderId?: number;
    order?: ORD_Order;
}

export class ORD_Priority implements IORD_Priority {
    id?: number;
    orderId?: number;
    emailSent?: boolean;
    lastSentNotification?: Date;
    sequence?: number;
    priorityId?: number;
    order?: ORD_Order;
    priority?: Priority;

    constructor(data?: IORD_Priority) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.emailSent = _data["emailSent"];
            this.lastSentNotification = _data["lastSentNotification"] ? new Date(_data["lastSentNotification"].toString()) : <any>undefined;
            this.sequence = _data["sequence"];
            this.priorityId = _data["priorityId"];
            this.order = _data["order"] ? ORD_Order.fromJS(_data["order"]) : <any>undefined;
            this.priority = _data["priority"] ? Priority.fromJS(_data["priority"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ORD_Priority {
        data = typeof data === 'object' ? data : {};
        let result = new ORD_Priority();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["emailSent"] = this.emailSent;
        data["lastSentNotification"] = this.lastSentNotification ? this.lastSentNotification.toISOString() : <any>undefined;
        data["sequence"] = this.sequence;
        data["priorityId"] = this.priorityId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["priority"] = this.priority ? this.priority.toJSON() : <any>undefined;
        return data;
    }
}

export interface IORD_Priority {
    id?: number;
    orderId?: number;
    emailSent?: boolean;
    lastSentNotification?: Date;
    sequence?: number;
    priorityId?: number;
    order?: ORD_Order;
    priority?: Priority;
}

export class ORD_Step implements IORD_Step {
    id?: number;
    orderId?: number;
    number?: number;
    length?: number;
    exposure?: number;

    constructor(data?: IORD_Step) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.number = _data["number"];
            this.length = _data["length"];
            this.exposure = _data["exposure"];
        }
    }

    static fromJS(data: any): ORD_Step {
        data = typeof data === 'object' ? data : {};
        let result = new ORD_Step();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["number"] = this.number;
        data["length"] = this.length;
        data["exposure"] = this.exposure;
        return data;
    }
}

export interface IORD_Step {
    id?: number;
    orderId?: number;
    number?: number;
    length?: number;
    exposure?: number;
}

export class ORD_Uppersection implements IORD_Uppersection {
    apiSize?: string | undefined;
    length?: string | undefined;
    orderId?: number;
    shortShank?: boolean;
    restrictor?: boolean;
    descriptor?: string | undefined;
    electronics_Id?: number | undefined;
    bitBreaker_Id?: number | undefined;
    order?: ORD_Order;

    constructor(data?: IORD_Uppersection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiSize = _data["apiSize"];
            this.length = _data["length"];
            this.orderId = _data["orderId"];
            this.shortShank = _data["shortShank"];
            this.restrictor = _data["restrictor"];
            this.descriptor = _data["descriptor"];
            this.electronics_Id = _data["electronics_Id"];
            this.bitBreaker_Id = _data["bitBreaker_Id"];
            this.order = _data["order"] ? ORD_Order.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ORD_Uppersection {
        data = typeof data === 'object' ? data : {};
        let result = new ORD_Uppersection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiSize"] = this.apiSize;
        data["length"] = this.length;
        data["orderId"] = this.orderId;
        data["shortShank"] = this.shortShank;
        data["restrictor"] = this.restrictor;
        data["descriptor"] = this.descriptor;
        data["electronics_Id"] = this.electronics_Id;
        data["bitBreaker_Id"] = this.bitBreaker_Id;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data;
    }
}

export interface IORD_Uppersection {
    apiSize?: string | undefined;
    length?: string | undefined;
    orderId?: number;
    shortShank?: boolean;
    restrictor?: boolean;
    descriptor?: string | undefined;
    electronics_Id?: number | undefined;
    bitBreaker_Id?: number | undefined;
    order?: ORD_Order;
}

export class ORing implements IORing {
    id?: number;
    demension?: string | undefined;
    sapMaterialNumber?: number;
    part?: string | undefined;
    restrictors?: Restrictor[] | undefined;
    upperSections?: Uppersection[] | undefined;

    constructor(data?: IORing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.demension = _data["demension"];
            this.sapMaterialNumber = _data["sapMaterialNumber"];
            this.part = _data["part"];
            if (Array.isArray(_data["restrictors"])) {
                this.restrictors = [] as any;
                for (let item of _data["restrictors"])
                    this.restrictors!.push(Restrictor.fromJS(item));
            }
            if (Array.isArray(_data["upperSections"])) {
                this.upperSections = [] as any;
                for (let item of _data["upperSections"])
                    this.upperSections!.push(Uppersection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ORing {
        data = typeof data === 'object' ? data : {};
        let result = new ORing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["demension"] = this.demension;
        data["sapMaterialNumber"] = this.sapMaterialNumber;
        data["part"] = this.part;
        if (Array.isArray(this.restrictors)) {
            data["restrictors"] = [];
            for (let item of this.restrictors)
                data["restrictors"].push(item.toJSON());
        }
        if (Array.isArray(this.upperSections)) {
            data["upperSections"] = [];
            for (let item of this.upperSections)
                data["upperSections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IORing {
    id?: number;
    demension?: string | undefined;
    sapMaterialNumber?: number;
    part?: string | undefined;
    restrictors?: Restrictor[] | undefined;
    upperSections?: Uppersection[] | undefined;
}

export class Opportunity implements IOpportunity {
    id?: number;
    orderId?: number;
    wob?: string | undefined;
    rop?: string | undefined;
    rpmMoter?: string | undefined;
    rpmRotary?: string | undefined;
    formation?: string | undefined;
    targetClient?: string | undefined;
    totalUnits?: number | undefined;
    dbsUnits?: number | undefined;
    totalRev?: number | undefined;
    dbsRev?: number | undefined;
    totalMargin?: number | undefined;
    dbsMargin?: number | undefined;
    ropUpper?: number | undefined;
    ropLower?: number | undefined;
    wobUpper?: number | undefined;
    wobLower?: number | undefined;
    tobUpper?: number | undefined;
    tobLower?: number | undefined;
    rpmUpper?: number | undefined;
    rpmLower?: number | undefined;
    flowRateUpper?: number | undefined;
    flowRateLower?: number | undefined;
    orD_Order?: ORD_Order;

    constructor(data?: IOpportunity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.wob = _data["wob"];
            this.rop = _data["rop"];
            this.rpmMoter = _data["rpmMoter"];
            this.rpmRotary = _data["rpmRotary"];
            this.formation = _data["formation"];
            this.targetClient = _data["targetClient"];
            this.totalUnits = _data["totalUnits"];
            this.dbsUnits = _data["dbsUnits"];
            this.totalRev = _data["totalRev"];
            this.dbsRev = _data["dbsRev"];
            this.totalMargin = _data["totalMargin"];
            this.dbsMargin = _data["dbsMargin"];
            this.ropUpper = _data["ropUpper"];
            this.ropLower = _data["ropLower"];
            this.wobUpper = _data["wobUpper"];
            this.wobLower = _data["wobLower"];
            this.tobUpper = _data["tobUpper"];
            this.tobLower = _data["tobLower"];
            this.rpmUpper = _data["rpmUpper"];
            this.rpmLower = _data["rpmLower"];
            this.flowRateUpper = _data["flowRateUpper"];
            this.flowRateLower = _data["flowRateLower"];
            this.orD_Order = _data["orD_Order"] ? ORD_Order.fromJS(_data["orD_Order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Opportunity {
        data = typeof data === 'object' ? data : {};
        let result = new Opportunity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["wob"] = this.wob;
        data["rop"] = this.rop;
        data["rpmMoter"] = this.rpmMoter;
        data["rpmRotary"] = this.rpmRotary;
        data["formation"] = this.formation;
        data["targetClient"] = this.targetClient;
        data["totalUnits"] = this.totalUnits;
        data["dbsUnits"] = this.dbsUnits;
        data["totalRev"] = this.totalRev;
        data["dbsRev"] = this.dbsRev;
        data["totalMargin"] = this.totalMargin;
        data["dbsMargin"] = this.dbsMargin;
        data["ropUpper"] = this.ropUpper;
        data["ropLower"] = this.ropLower;
        data["wobUpper"] = this.wobUpper;
        data["wobLower"] = this.wobLower;
        data["tobUpper"] = this.tobUpper;
        data["tobLower"] = this.tobLower;
        data["rpmUpper"] = this.rpmUpper;
        data["rpmLower"] = this.rpmLower;
        data["flowRateUpper"] = this.flowRateUpper;
        data["flowRateLower"] = this.flowRateLower;
        data["orD_Order"] = this.orD_Order ? this.orD_Order.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOpportunity {
    id?: number;
    orderId?: number;
    wob?: string | undefined;
    rop?: string | undefined;
    rpmMoter?: string | undefined;
    rpmRotary?: string | undefined;
    formation?: string | undefined;
    targetClient?: string | undefined;
    totalUnits?: number | undefined;
    dbsUnits?: number | undefined;
    totalRev?: number | undefined;
    dbsRev?: number | undefined;
    totalMargin?: number | undefined;
    dbsMargin?: number | undefined;
    ropUpper?: number | undefined;
    ropLower?: number | undefined;
    wobUpper?: number | undefined;
    wobLower?: number | undefined;
    tobUpper?: number | undefined;
    tobLower?: number | undefined;
    rpmUpper?: number | undefined;
    rpmLower?: number | undefined;
    flowRateUpper?: number | undefined;
    flowRateLower?: number | undefined;
    orD_Order?: ORD_Order;
}

export class Ord_Cerebro implements IOrd_Cerebro {
    id?: number;
    orderId?: number;
    usedCerebroData?: boolean | undefined;
    cerebro_InfluenceDescription?: string | undefined;
    cerebro_ClosureComments?: string | undefined;
    automaticallyInherited?: boolean;
    order?: ORD_Order;

    constructor(data?: IOrd_Cerebro) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.usedCerebroData = _data["usedCerebroData"];
            this.cerebro_InfluenceDescription = _data["cerebro_InfluenceDescription"];
            this.cerebro_ClosureComments = _data["cerebro_ClosureComments"];
            this.automaticallyInherited = _data["automaticallyInherited"];
            this.order = _data["order"] ? ORD_Order.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Ord_Cerebro {
        data = typeof data === 'object' ? data : {};
        let result = new Ord_Cerebro();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["usedCerebroData"] = this.usedCerebroData;
        data["cerebro_InfluenceDescription"] = this.cerebro_InfluenceDescription;
        data["cerebro_ClosureComments"] = this.cerebro_ClosureComments;
        data["automaticallyInherited"] = this.automaticallyInherited;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrd_Cerebro {
    id?: number;
    orderId?: number;
    usedCerebroData?: boolean | undefined;
    cerebro_InfluenceDescription?: string | undefined;
    cerebro_ClosureComments?: string | undefined;
    automaticallyInherited?: boolean;
    order?: ORD_Order;
}

export class OrderFeatureAssociation implements IOrderFeatureAssociation {
    id?: number;
    bitFeatureID?: number;
    orderID?: number;
    createdBy?: string | undefined;
    createdDate?: Date;
    bitFeature?: Features;

    constructor(data?: IOrderFeatureAssociation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bitFeatureID = _data["bitFeatureID"];
            this.orderID = _data["orderID"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.bitFeature = _data["bitFeature"] ? Features.fromJS(_data["bitFeature"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderFeatureAssociation {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFeatureAssociation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bitFeatureID"] = this.bitFeatureID;
        data["orderID"] = this.orderID;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["bitFeature"] = this.bitFeature ? this.bitFeature.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrderFeatureAssociation {
    id?: number;
    bitFeatureID?: number;
    orderID?: number;
    createdBy?: string | undefined;
    createdDate?: Date;
    bitFeature?: Features;
}

export class OrderTask implements IOrderTask {
    id?: number;
    order_Id?: number;
    process_Id?: number;
    user_Id?: number | undefined;
    queue_Start?: Date | undefined;
    startDate?: Date | undefined;
    completeDate?: Date | undefined;
    sequence?: number;
    kickedBack_Task_Id?: number | undefined;
    notes?: string | undefined;
    ParentTaskId?: number | undefined;
    isParallel?: boolean;
    isRequired?: boolean;
    isRework?: boolean;
    subSequence?: number | undefined;
    user?: User;
    order?: ORD_Order;
    process?: Process;

    constructor(data?: IOrderTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order_Id = _data["order_Id"];
            this.process_Id = _data["process_Id"];
            this.user_Id = _data["user_Id"];
            this.queue_Start = _data["queue_Start"] ? new Date(_data["queue_Start"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.completeDate = _data["completeDate"] ? new Date(_data["completeDate"].toString()) : <any>undefined;
            this.sequence = _data["sequence"];
            this.kickedBack_Task_Id = _data["kickedBack_Task_Id"];
            this.notes = _data["notes"];
            this.ParentTaskId = _data["ParentTaskId"];
            this.isParallel = _data["isParallel"];
            this.isRequired = _data["isRequired"];
            this.isRework = _data["isRework"];
            this.subSequence = _data["subSequence"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.order = _data["order"] ? ORD_Order.fromJS(_data["order"]) : <any>undefined;
            this.process = _data["process"] ? Process.fromJS(_data["process"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderTask {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order_Id"] = this.order_Id;
        data["process_Id"] = this.process_Id;
        data["user_Id"] = this.user_Id;
        data["queue_Start"] = this.queue_Start ? this.queue_Start.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["completeDate"] = this.completeDate ? this.completeDate.toISOString() : <any>undefined;
        data["sequence"] = this.sequence;
        data["kickedBack_Task_Id"] = this.kickedBack_Task_Id;
        data["notes"] = this.notes;
        data["ParentTaskId"] = this.ParentTaskId;
        data["isParallel"] = this.isParallel;
        data["isRequired"] = this.isRequired;
        data["isRework"] = this.isRework;
        data["subSequence"] = this.subSequence;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrderTask {
    id?: number;
    order_Id?: number;
    process_Id?: number;
    user_Id?: number | undefined;
    queue_Start?: Date | undefined;
    startDate?: Date | undefined;
    completeDate?: Date | undefined;
    sequence?: number;
    kickedBack_Task_Id?: number | undefined;
    notes?: string | undefined;
    ParentTaskId?: number | undefined;
    isParallel?: boolean;
    isRequired?: boolean;
    isRework?: boolean;
    subSequence?: number | undefined;
    user?: User;
    order?: ORD_Order;
    process?: Process;
}

export class Order_DataAnalysis_DataSource implements IOrder_DataAnalysis_DataSource {
    id?: number;
    dataAnalysis_DataSource_Id?: number;
    orderId?: number;
    qty?: number;

    constructor(data?: IOrder_DataAnalysis_DataSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dataAnalysis_DataSource_Id = _data["dataAnalysis_DataSource_Id"];
            this.orderId = _data["orderId"];
            this.qty = _data["qty"];
        }
    }

    static fromJS(data: any): Order_DataAnalysis_DataSource {
        data = typeof data === 'object' ? data : {};
        let result = new Order_DataAnalysis_DataSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataAnalysis_DataSource_Id"] = this.dataAnalysis_DataSource_Id;
        data["orderId"] = this.orderId;
        data["qty"] = this.qty;
        return data;
    }
}

export interface IOrder_DataAnalysis_DataSource {
    id?: number;
    dataAnalysis_DataSource_Id?: number;
    orderId?: number;
    qty?: number;
}

export class PDCCutter implements IPDCCutter {
    id?: number;
    sapMaterialNumber?: number;
    cutterDescription?: string | undefined;
    cutterSize?: string | undefined;
    cutterChamfer?: string | undefined;
    cutterGeometry?: string | undefined;
    price?: number;
    reclaim?: boolean;
    dgnFCCutterTypesID?: number;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    productLine?: string | undefined;
    isObsolete?: boolean;
    displayName?: string | undefined;
    geometryTextId?: number | undefined;
    arrestorGeometryId?: number | undefined;
    r1GeometryId?: number | undefined;
    permissionLock?: boolean | undefined;
    profileImage?: number | undefined;
    rollingElementGeometryId?: number | undefined;
    cutterShapeID?: number | undefined;
    insertedElementShapeID?: number | undefined;
    rollingElementShapeID?: number | undefined;
    cutterPhase_Id?: number;
    pdcType?: PDCFamilyType;
    cutterMaps?: ORD_CutterMap[] | undefined;

    constructor(data?: IPDCCutter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sapMaterialNumber = _data["sapMaterialNumber"];
            this.cutterDescription = _data["cutterDescription"];
            this.cutterSize = _data["cutterSize"];
            this.cutterChamfer = _data["cutterChamfer"];
            this.cutterGeometry = _data["cutterGeometry"];
            this.price = _data["price"];
            this.reclaim = _data["reclaim"];
            this.dgnFCCutterTypesID = _data["dgnFCCutterTypesID"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.productLine = _data["productLine"];
            this.isObsolete = _data["isObsolete"];
            this.displayName = _data["displayName"];
            this.geometryTextId = _data["geometryTextId"];
            this.arrestorGeometryId = _data["arrestorGeometryId"];
            this.r1GeometryId = _data["r1GeometryId"];
            this.permissionLock = _data["permissionLock"];
            this.profileImage = _data["profileImage"];
            this.rollingElementGeometryId = _data["rollingElementGeometryId"];
            this.cutterShapeID = _data["cutterShapeID"];
            this.insertedElementShapeID = _data["insertedElementShapeID"];
            this.rollingElementShapeID = _data["rollingElementShapeID"];
            this.cutterPhase_Id = _data["cutterPhase_Id"];
            this.pdcType = _data["pdcType"] ? PDCFamilyType.fromJS(_data["pdcType"]) : <any>undefined;
            if (Array.isArray(_data["cutterMaps"])) {
                this.cutterMaps = [] as any;
                for (let item of _data["cutterMaps"])
                    this.cutterMaps!.push(ORD_CutterMap.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PDCCutter {
        data = typeof data === 'object' ? data : {};
        let result = new PDCCutter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sapMaterialNumber"] = this.sapMaterialNumber;
        data["cutterDescription"] = this.cutterDescription;
        data["cutterSize"] = this.cutterSize;
        data["cutterChamfer"] = this.cutterChamfer;
        data["cutterGeometry"] = this.cutterGeometry;
        data["price"] = this.price;
        data["reclaim"] = this.reclaim;
        data["dgnFCCutterTypesID"] = this.dgnFCCutterTypesID;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["productLine"] = this.productLine;
        data["isObsolete"] = this.isObsolete;
        data["displayName"] = this.displayName;
        data["geometryTextId"] = this.geometryTextId;
        data["arrestorGeometryId"] = this.arrestorGeometryId;
        data["r1GeometryId"] = this.r1GeometryId;
        data["permissionLock"] = this.permissionLock;
        data["profileImage"] = this.profileImage;
        data["rollingElementGeometryId"] = this.rollingElementGeometryId;
        data["cutterShapeID"] = this.cutterShapeID;
        data["insertedElementShapeID"] = this.insertedElementShapeID;
        data["rollingElementShapeID"] = this.rollingElementShapeID;
        data["cutterPhase_Id"] = this.cutterPhase_Id;
        data["pdcType"] = this.pdcType ? this.pdcType.toJSON() : <any>undefined;
        if (Array.isArray(this.cutterMaps)) {
            data["cutterMaps"] = [];
            for (let item of this.cutterMaps)
                data["cutterMaps"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPDCCutter {
    id?: number;
    sapMaterialNumber?: number;
    cutterDescription?: string | undefined;
    cutterSize?: string | undefined;
    cutterChamfer?: string | undefined;
    cutterGeometry?: string | undefined;
    price?: number;
    reclaim?: boolean;
    dgnFCCutterTypesID?: number;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    productLine?: string | undefined;
    isObsolete?: boolean;
    displayName?: string | undefined;
    geometryTextId?: number | undefined;
    arrestorGeometryId?: number | undefined;
    r1GeometryId?: number | undefined;
    permissionLock?: boolean | undefined;
    profileImage?: number | undefined;
    rollingElementGeometryId?: number | undefined;
    cutterShapeID?: number | undefined;
    insertedElementShapeID?: number | undefined;
    rollingElementShapeID?: number | undefined;
    cutterPhase_Id?: number;
    pdcType?: PDCFamilyType;
    cutterMaps?: ORD_CutterMap[] | undefined;
}

export class PDCCutterType implements IPDCCutterType {
    id?: number;
    name?: string | undefined;
    selected?: boolean;
    leachDepth?: string | undefined;
    price?: number;
    chamfer?: string | undefined;
    permissionLock?: boolean;
    size?: string | undefined;
    pdcType?: string | undefined;
    bodyType?: string | undefined;
    isObsolete?: boolean;
    mapIteration?: string | undefined;
    sapNumber?: number;
    group?: number;
    isJuggernaut?: boolean;
    bucketType?: string | undefined;

    constructor(data?: IPDCCutterType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.selected = _data["selected"];
            this.leachDepth = _data["leachDepth"];
            this.price = _data["price"];
            this.chamfer = _data["chamfer"];
            this.permissionLock = _data["permissionLock"];
            this.size = _data["size"];
            this.pdcType = _data["pdcType"];
            this.bodyType = _data["bodyType"];
            this.isObsolete = _data["isObsolete"];
            this.mapIteration = _data["mapIteration"];
            this.sapNumber = _data["sapNumber"];
            this.group = _data["group"];
            this.isJuggernaut = _data["isJuggernaut"];
            this.bucketType = _data["bucketType"];
        }
    }

    static fromJS(data: any): PDCCutterType {
        data = typeof data === 'object' ? data : {};
        let result = new PDCCutterType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["selected"] = this.selected;
        data["leachDepth"] = this.leachDepth;
        data["price"] = this.price;
        data["chamfer"] = this.chamfer;
        data["permissionLock"] = this.permissionLock;
        data["size"] = this.size;
        data["pdcType"] = this.pdcType;
        data["bodyType"] = this.bodyType;
        data["isObsolete"] = this.isObsolete;
        data["mapIteration"] = this.mapIteration;
        data["sapNumber"] = this.sapNumber;
        data["group"] = this.group;
        data["isJuggernaut"] = this.isJuggernaut;
        data["bucketType"] = this.bucketType;
        return data;
    }
}

export interface IPDCCutterType {
    id?: number;
    name?: string | undefined;
    selected?: boolean;
    leachDepth?: string | undefined;
    price?: number;
    chamfer?: string | undefined;
    permissionLock?: boolean;
    size?: string | undefined;
    pdcType?: string | undefined;
    bodyType?: string | undefined;
    isObsolete?: boolean;
    mapIteration?: string | undefined;
    sapNumber?: number;
    group?: number;
    isJuggernaut?: boolean;
    bucketType?: string | undefined;
}

export class PDCFamilyType implements IPDCFamilyType {
    id?: number;
    name?: string | undefined;
    obsolete?: boolean | undefined;
    newBuild?: boolean | undefined;
    manufacturer?: string | undefined;
    longLeadTime?: boolean | undefined;
    leachingRID?: number | undefined;
    productLineRID?: number | undefined;
    abrasionResistance?: number | undefined;
    impactResistance?: number | undefined;
    thermalMechanicalIntegrity?: number | undefined;
    standardCost?: number | undefined;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    class?: string | undefined;
    cutterNomenclature?: number;
    isJuggernaut?: boolean;
    pdcCutters?: PDCCutter[] | undefined;

    constructor(data?: IPDCFamilyType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.obsolete = _data["obsolete"];
            this.newBuild = _data["newBuild"];
            this.manufacturer = _data["manufacturer"];
            this.longLeadTime = _data["longLeadTime"];
            this.leachingRID = _data["leachingRID"];
            this.productLineRID = _data["productLineRID"];
            this.abrasionResistance = _data["abrasionResistance"];
            this.impactResistance = _data["impactResistance"];
            this.thermalMechanicalIntegrity = _data["thermalMechanicalIntegrity"];
            this.standardCost = _data["standardCost"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.class = _data["class"];
            this.cutterNomenclature = _data["cutterNomenclature"];
            this.isJuggernaut = _data["isJuggernaut"];
            if (Array.isArray(_data["pdcCutters"])) {
                this.pdcCutters = [] as any;
                for (let item of _data["pdcCutters"])
                    this.pdcCutters!.push(PDCCutter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PDCFamilyType {
        data = typeof data === 'object' ? data : {};
        let result = new PDCFamilyType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["obsolete"] = this.obsolete;
        data["newBuild"] = this.newBuild;
        data["manufacturer"] = this.manufacturer;
        data["longLeadTime"] = this.longLeadTime;
        data["leachingRID"] = this.leachingRID;
        data["productLineRID"] = this.productLineRID;
        data["abrasionResistance"] = this.abrasionResistance;
        data["impactResistance"] = this.impactResistance;
        data["thermalMechanicalIntegrity"] = this.thermalMechanicalIntegrity;
        data["standardCost"] = this.standardCost;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["class"] = this.class;
        data["cutterNomenclature"] = this.cutterNomenclature;
        data["isJuggernaut"] = this.isJuggernaut;
        if (Array.isArray(this.pdcCutters)) {
            data["pdcCutters"] = [];
            for (let item of this.pdcCutters)
                data["pdcCutters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPDCFamilyType {
    id?: number;
    name?: string | undefined;
    obsolete?: boolean | undefined;
    newBuild?: boolean | undefined;
    manufacturer?: string | undefined;
    longLeadTime?: boolean | undefined;
    leachingRID?: number | undefined;
    productLineRID?: number | undefined;
    abrasionResistance?: number | undefined;
    impactResistance?: number | undefined;
    thermalMechanicalIntegrity?: number | undefined;
    standardCost?: number | undefined;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    class?: string | undefined;
    cutterNomenclature?: number;
    isJuggernaut?: boolean;
    pdcCutters?: PDCCutter[] | undefined;
}

export class PNA_Genre implements IPNA_Genre {
    id?: number;
    name?: string | undefined;
    pnA_Part?: PNA_Part[] | undefined;

    constructor(data?: IPNA_Genre) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["pnA_Part"])) {
                this.pnA_Part = [] as any;
                for (let item of _data["pnA_Part"])
                    this.pnA_Part!.push(PNA_Part.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PNA_Genre {
        data = typeof data === 'object' ? data : {};
        let result = new PNA_Genre();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.pnA_Part)) {
            data["pnA_Part"] = [];
            for (let item of this.pnA_Part)
                data["pnA_Part"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPNA_Genre {
    id?: number;
    name?: string | undefined;
    pnA_Part?: PNA_Part[] | undefined;
}

export class PNA_Part implements IPNA_Part {
    id?: number;
    pnA_GenreID?: number;
    name?: string | undefined;
    subPslID?: number;
    decription?: string | undefined;
    sapNumberID?: number | undefined;
    prefix?: string | undefined;
    sequence?: number | undefined;
    subPsl?: SubPSL;
    drawingLogs?: DrawingLog[] | undefined;
    pnA_Genre?: PNA_Genre;
    sapNumType?: SapNumType;

    constructor(data?: IPNA_Part) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pnA_GenreID = _data["pnA_GenreID"];
            this.name = _data["name"];
            this.subPslID = _data["subPslID"];
            this.decription = _data["decription"];
            this.sapNumberID = _data["sapNumberID"];
            this.prefix = _data["prefix"];
            this.sequence = _data["sequence"];
            this.subPsl = _data["subPsl"] ? SubPSL.fromJS(_data["subPsl"]) : <any>undefined;
            if (Array.isArray(_data["drawingLogs"])) {
                this.drawingLogs = [] as any;
                for (let item of _data["drawingLogs"])
                    this.drawingLogs!.push(DrawingLog.fromJS(item));
            }
            this.pnA_Genre = _data["pnA_Genre"] ? PNA_Genre.fromJS(_data["pnA_Genre"]) : <any>undefined;
            this.sapNumType = _data["sapNumType"] ? SapNumType.fromJS(_data["sapNumType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PNA_Part {
        data = typeof data === 'object' ? data : {};
        let result = new PNA_Part();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pnA_GenreID"] = this.pnA_GenreID;
        data["name"] = this.name;
        data["subPslID"] = this.subPslID;
        data["decription"] = this.decription;
        data["sapNumberID"] = this.sapNumberID;
        data["prefix"] = this.prefix;
        data["sequence"] = this.sequence;
        data["subPsl"] = this.subPsl ? this.subPsl.toJSON() : <any>undefined;
        if (Array.isArray(this.drawingLogs)) {
            data["drawingLogs"] = [];
            for (let item of this.drawingLogs)
                data["drawingLogs"].push(item.toJSON());
        }
        data["pnA_Genre"] = this.pnA_Genre ? this.pnA_Genre.toJSON() : <any>undefined;
        data["sapNumType"] = this.sapNumType ? this.sapNumType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPNA_Part {
    id?: number;
    pnA_GenreID?: number;
    name?: string | undefined;
    subPslID?: number;
    decription?: string | undefined;
    sapNumberID?: number | undefined;
    prefix?: string | undefined;
    sequence?: number | undefined;
    subPsl?: SubPSL;
    drawingLogs?: DrawingLog[] | undefined;
    pnA_Genre?: PNA_Genre;
    sapNumType?: SapNumType;
}

export class Part implements IPart {
    id?: number;
    name?: string | undefined;
    typeId?: number;
    partGroupId?: number;
    productlineId?: number;

    constructor(data?: IPart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.partGroupId = _data["partGroupId"];
            this.productlineId = _data["productlineId"];
        }
    }

    static fromJS(data: any): Part {
        data = typeof data === 'object' ? data : {};
        let result = new Part();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["partGroupId"] = this.partGroupId;
        data["productlineId"] = this.productlineId;
        return data;
    }
}

export interface IPart {
    id?: number;
    name?: string | undefined;
    typeId?: number;
    partGroupId?: number;
    productlineId?: number;
}
export interface IPatchORDCutterMapDto {
    id?: number;
    orderId?: number;
    bladeNumber?: number;
    rowNumber?: number;
    numberOnRow?: number;
    facePosition?: string;
    pdcCutter_Id?: number;
    createdDate?: any;
    shape_Id?: number;
    shape_Type?: string;
    zone?: string;
    modifiedBy?: number;
    modifiedDate?: any;
    pdcShapeName? : string;
}

export class PatchORDCutterMapDto implements IPatchORDCutterMapDto {
    id?: number;
    orderId?: number;
    bladeNumber?: number;
    rowNumber?: number;
    numberOnRow?: number;
    facePosition?: string;
    pdcCutter_Id?: number;
    createdDate?: any;
    shape_Id?: number;
    shape_Type?: string;
    zone?: string;
    modifiedBy?: number;
    modifiedDate?: any;
    pdcShapeName? : string;
    armNumber?: number;

    constructor(data?: IPatchORDCutterMapDto) {
        if (data) {
            for (const property of Object.keys(data)) {
                if ((data as any).hasOwnProperty(property)) {
                    (this as any)[property] = (data as any)[property];
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.bladeNumber = _data["bladeNumber"];
            this.rowNumber = _data["rowNumber"];
            this.numberOnRow = _data["numberOnRow"];
            this.facePosition = _data["facePosition"];
            this.pdcCutter_Id = _data["pdcCutter_Id"];
            this.createdDate = _data["createdDate"];
            this.shape_Id = _data["shape_Id"];
            this.shape_Type = _data["shape_Type"];
            this.zone = _data["zone"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"];
            this.pdcShapeName = _data["pdcShapeName"];
            this.armNumber = _data["armNumber"];
        }
    }

    static fromJS(data: any): PatchORDCutterMapDto {
        data = typeof data === "object" ? data : {};
        const result = new PatchORDCutterMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["bladeNumber"] = this.bladeNumber;
        data["rowNumber"] = this.rowNumber;
        data["numberOnRow"] = this.numberOnRow;
        data["facePosition"] = this.facePosition;
        data["pdcCutter_Id"] = this.pdcCutter_Id;
        data["createdDate"] = this.createdDate;
        data["shape_Id"] = this.shape_Id;
        data["shape_Type"] = this.shape_Type;
        data["zone"] = this.zone;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate;
        data["pdcShapeName"] = this.pdcShapeName;
        data["armNumber"] = this.armNumber;
        return data;
    }
}
export class PatchORDBitDto implements IPatchORDBitDto {
    orderId?: number | undefined;
    size?: number | undefined;
    type?: string | undefined;
    level?: number | undefined;
    sleeve?: boolean | undefined;
    retroFit?: boolean | undefined;
    gaugeLength?: number | undefined;
    hardfacing?: string | undefined;
    onePiece?: boolean | undefined;
    isBHSModified?: boolean | undefined;
    iadc?: string | undefined;
    coreSize?: number | undefined;
    bitFeatures?: string | undefined;
    bitFeatureIds?: number[] | undefined;
    uppersection_Id?: number | undefined;
    breaker_Id?: number | undefined;
    uppersection_Electronic_Id?: number | undefined;

    constructor(data?: IPatchORDBitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.size = _data["size"];
            this.type = _data["type"];
            this.level = _data["level"];
            this.sleeve = _data["sleeve"];
            this.retroFit = _data["retroFit"];
            this.gaugeLength = _data["gaugeLength"];
            this.hardfacing = _data["hardfacing"];
            this.onePiece = _data["onePiece"];
            this.isBHSModified = _data["isBHSModified"];
            this.iadc = _data["iadc"];
            this.coreSize = _data["coreSize"];
            this.bitFeatures = _data["bitFeatures"];
            if (Array.isArray(_data["bitFeatureIds"])) {
                this.bitFeatureIds = [] as any;
                for (let item of _data["bitFeatureIds"])
                    this.bitFeatureIds!.push(item);
            }
            this.uppersection_Id = _data["uppersection_Id"];
            this.breaker_Id = _data["breaker_Id"];
            this.uppersection_Electronic_Id = _data["uppersection_Electronic_Id"];
        }
    }

    static fromJS(data: any): PatchORDBitDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatchORDBitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["size"] = this.size;
        data["type"] = this.type;
        data["level"] = this.level;
        data["sleeve"] = this.sleeve;
        data["retroFit"] = this.retroFit;
        data["gaugeLength"] = this.gaugeLength;
        data["hardfacing"] = this.hardfacing;
        data["onePiece"] = this.onePiece;
        data["isBHSModified"] = this.isBHSModified;
        data["iadc"] = this.iadc;
        data["coreSize"] = this.coreSize;
        data["bitFeatures"] = this.bitFeatures;
        if (Array.isArray(this.bitFeatureIds)) {
            data["bitFeatureIds"] = [];
            for (let item of this.bitFeatureIds)
                data["bitFeatureIds"].push(item);
        }
        data["uppersection_Id"] = this.uppersection_Id;
        data["breaker_Id"] = this.breaker_Id;
        data["uppersection_Electronic_Id"] = this.uppersection_Electronic_Id;
        return data;
    }
}

export interface IPatchORDBitDto {
    orderId?: number | undefined;
    size?: number | undefined;
    type?: string | undefined;
    level?: number | undefined;
    sleeve?: boolean | undefined;
    retroFit?: boolean | undefined;
    gaugeLength?: number | undefined;
    hardfacing?: string | undefined;
    onePiece?: boolean | undefined;
    isBHSModified?: boolean | undefined;
    iadc?: string | undefined;
    coreSize?: number | undefined;
    bitFeatures?: string | undefined;
    bitFeatureIds?: number[] | undefined;
    uppersection_Id?: number | undefined;
    breaker_Id?: number | undefined;
    uppersection_Electronic_Id?: number | undefined;
}

export class PatchORDCerebroDto implements IPatchORDCerebroDto {
    orderId?: number | undefined;
    usedCerebroData?: boolean | undefined;
    cerebro_InfluenceDescription?: string | undefined;
    cerebro_ClosureComments?: string | undefined;
    automaticallyInherited?: boolean | undefined;

    constructor(data?: IPatchORDCerebroDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.usedCerebroData = _data["usedCerebroData"];
            this.cerebro_InfluenceDescription = _data["cerebro_InfluenceDescription"];
            this.cerebro_ClosureComments = _data["cerebro_ClosureComments"];
            this.automaticallyInherited = _data["automaticallyInherited"];
        }
    }

    static fromJS(data: any): PatchORDCerebroDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatchORDCerebroDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["usedCerebroData"] = this.usedCerebroData;
        data["cerebro_InfluenceDescription"] = this.cerebro_InfluenceDescription;
        data["cerebro_ClosureComments"] = this.cerebro_ClosureComments;
        data["automaticallyInherited"] = this.automaticallyInherited;
        return data;
    }
}

export interface IPatchORDCerebroDto {
    orderId?: number | undefined;
    usedCerebroData?: boolean | undefined;
    cerebro_InfluenceDescription?: string | undefined;
    cerebro_ClosureComments?: string | undefined;
    automaticallyInherited?: boolean | undefined;
}

export interface GaugeProtectionOption {
    value: string;
    Name?: string | undefined;
    Productline_Id?: number | undefined;
    isObsolete?: boolean | undefined;
}

export class PatchORDGaugeProtectionDto implements IPatchORDGaugeProtectionDto {
    id?: number;
    orderId?: number;
    protection?: string | undefined;

    constructor(data?: IPatchORDGaugeProtectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.protection = _data["protection"];
        }
    }

    static fromJS(data: any): PatchORDGaugeProtectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatchORDGaugeProtectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["protection"] = this.protection;
        return data;
    }
}

export interface IPatchORDGaugeProtectionDto {
    id?: number;
    orderId?: number;
    protection?: string | undefined;
}

export class PatchORDOrderDto implements IPatchORDOrderDto {
    seriesId?: number | undefined;
    submittedBy?: number | undefined;
    requiredDate?: Date | undefined;
    typeId?: number | undefined;
    priority?: number | undefined;
    statusId?: number | undefined;
    description?: string | undefined;
    applicationId?: number | undefined;
    subPsl?: number | undefined;
    productLine?: number | undefined;
    parent_ORD_OrderId?: number | undefined;
    partId?: number | undefined;
    nwA_ApplicationId?: number | undefined;
    onHold?: boolean | undefined;
    cancelled?: boolean | undefined;
    targetCustomer?: string | undefined;
    difference?: string | undefined;
    centralDesignRequested?: boolean | undefined;
    designedBy?: number | undefined;
    notesToDesignSupport?: string | undefined;
    requestExclusion?: boolean | undefined;
    isJuggernaut?: boolean | undefined;
    isOculusInfluenced?: boolean | undefined;
    fieldRequest_Id?: number | undefined;
    activeProblems?: ActiveProblem[] | undefined;
    customerRequirements?: string[] | undefined;
    reference?: number | undefined;

    constructor(data?: IPatchORDOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seriesId = _data["seriesId"];
            this.submittedBy = _data["submittedBy"];
            this.requiredDate = _data["requiredDate"] ? new Date(_data["requiredDate"].toString()) : <any>undefined;
            this.typeId = _data["typeId"];
            this.priority = _data["priority"];
            this.statusId = _data["statusId"];
            this.description = _data["description"];
            this.applicationId = _data["applicationId"];
            this.subPsl = _data["subPsl"];
            this.productLine = _data["productLine"];
            this.parent_ORD_OrderId = _data["parent_ORD_OrderId"];
            this.partId = _data["partId"];
            this.nwA_ApplicationId = _data["nwA_ApplicationId"];
            this.onHold = _data["onHold"];
            this.cancelled = _data["cancelled"];
            this.targetCustomer = _data["targetCustomer"];
            this.difference = _data["difference"];
            this.centralDesignRequested = _data["centralDesignRequested"];
            this.designedBy = _data["designedBy"];
            this.notesToDesignSupport = _data["notesToDesignSupport"];
            this.requestExclusion = _data["requestExclusion"];
            this.isJuggernaut = _data["isJuggernaut"];
            this.isOculusInfluenced = _data["isOculusInfluenced"];
            this.fieldRequest_Id = _data["fieldRequest_Id"];
            this.activeProblems = _data["activeProblems"];
            this.customerRequirements = _data["customerRequirements"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): PatchORDOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatchORDOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seriesId"] = this.seriesId;
        data["submittedBy"] = this.submittedBy;
        data["requiredDate"] = this.requiredDate ? this.requiredDate.toISOString() : <any>undefined;
        data["typeId"] = this.typeId;
        data["priority"] = this.priority;
        data["statusId"] = this.statusId;
        data["description"] = this.description;
        data["applicationId"] = this.applicationId;
        data["subPsl"] = this.subPsl;
        data["productLine"] = this.productLine;
        data["parent_ORD_OrderId"] = this.parent_ORD_OrderId;
        data["partId"] = this.partId;
        data["nwA_ApplicationId"] = this.nwA_ApplicationId;
        data["onHold"] = this.onHold;
        data["cancelled"] = this.cancelled;
        data["targetCustomer"] = this.targetCustomer;
        data["difference"] = this.difference;
        data["centralDesignRequested"] = this.centralDesignRequested;
        data["designedBy"] = this.designedBy;
        data["notesToDesignSupport"] = this.notesToDesignSupport;
        data["requestExclusion"] = this.requestExclusion;
        data["isJuggernaut"] = this.isJuggernaut;
        data["isOculusInfluenced"] = this.isOculusInfluenced;
        data["fieldRequest_Id"] = this.fieldRequest_Id;
        data["activeProblems"] = this.activeProblems;
        data["customerRequirements"] = this.customerRequirements;
        data["reference"] = this.reference;
        return data;
    }
}

export interface IPatchORDOrderDto {
    seriesId?: number | undefined;
    submittedBy?: number | undefined;
    requiredDate?: Date | undefined;
    typeId?: number | undefined;
    priority?: number | undefined;
    statusId?: number | undefined;
    description?: string | undefined;
    applicationId?: number | undefined;
    subPsl?: number | undefined;
    productLine?: number | undefined;
    parent_ORD_OrderId?: number | undefined;
    partId?: number | undefined;
    nwA_ApplicationId?: number | undefined;
    onHold?: boolean | undefined;
    cancelled?: boolean | undefined;
    targetCustomer?: string | undefined;
    difference?: string | undefined;
    centralDesignRequested?: boolean | undefined;
    designedBy?: number | undefined;
    notesToDesignSupport?: string | undefined;
    requestExclusion?: boolean | undefined;
    isJuggernaut?: boolean | undefined;
    isOculusInfluenced?: boolean | undefined;
    fieldRequest_Id?: number | undefined;
    activeProblems?: ActiveProblem[] | undefined;
    reference?: number | undefined;
}

export class PatchORDPowderDto implements IPatchORDPowderDto {
    id?: number;
    type?: string | undefined;
    location?: string | undefined;
    orderId?: number;

    constructor(data?: IPatchORDPowderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.location = _data["location"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): PatchORDPowderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatchORDPowderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["location"] = this.location;
        data["orderId"] = this.orderId;
        return data;
    }
}

export interface IPatchORDPowderDto {
    id?: number;
    type?: string | undefined;
    location?: string | undefined;
    orderId?: number;
}

export class PatchORDUppersectionDto implements IPatchORDUppersectionDto {
    apiSize?: string | undefined;
    length?: string | undefined;
    shortShank?: boolean | undefined;
    restrictor?: boolean | undefined;
    descriptor?: string | undefined;
    electronics_Id?: number | undefined;
    bitBreaker_Id?: number | undefined;
    uppersection_Id?: number | undefined;

    constructor(data?: IPatchORDUppersectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiSize = _data["apiSize"];
            this.length = _data["length"];
            this.shortShank = _data["shortShank"];
            this.restrictor = _data["restrictor"];
            this.descriptor = _data["descriptor"];
            this.electronics_Id = _data["electronics_Id"];
            this.bitBreaker_Id = _data["bitBreaker_Id"];
            this.uppersection_Id = _data["uppersection_Id"];
        }
    }

    static fromJS(data: any): PatchORDUppersectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatchORDUppersectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiSize"] = this.apiSize;
        data["length"] = this.length;
        data["shortShank"] = this.shortShank;
        data["restrictor"] = this.restrictor;
        data["descriptor"] = this.descriptor;
        data["electronics_Id"] = this.electronics_Id;
        data["bitBreaker_Id"] = this.bitBreaker_Id;
        data["uppersection_Id"] = this.uppersection_Id;
        return data;
    }
}

export interface IPatchORDUppersectionDto {
    apiSize?: string | undefined;
    length?: string | undefined;
    shortShank?: boolean | undefined;
    restrictor?: boolean | undefined;
    descriptor?: string | undefined;
    electronics_Id?: number | undefined;
    bitBreaker_Id?: number | undefined;
    uppersection_Id?: number | undefined;
}

export class PatchOrderCommunictionDto implements IPatchOrderCommunictionDto {
    orderId?: number;
    userId?: number;
    message?: string | undefined;
    timestamp?: Date;
    mentionedUserIds?: number[] | undefined;

    constructor(data?: IPatchOrderCommunictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.userId = _data["userId"];
            this.message = _data["message"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            if (Array.isArray(_data["mentionedUserIds"])) {
                this.mentionedUserIds = [] as any;
                for (let item of _data["mentionedUserIds"])
                    this.mentionedUserIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PatchOrderCommunictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatchOrderCommunictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["userId"] = this.userId;
        data["message"] = this.message;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        if (Array.isArray(this.mentionedUserIds)) {
            data["mentionedUserIds"] = [];
            for (let item of this.mentionedUserIds)
                data["mentionedUserIds"].push(item);
        }
        return data;
    }
}

export interface IPatchOrderCommunictionDto {
    orderId?: number;
    userId?: number;
    message?: string | undefined;
    timestamp?: Date;
    mentionedUserIds?: number[] | undefined;
}

export class PatchOrderTaskDto implements IPatchOrderTaskDto {
    id?: number;
    order_Id?: number;
    process_Id?: number;
    user_Id?: number | undefined;
    queue_Start?: Date | undefined;
    startDate?: Date | undefined;
    completeDate?: Date | undefined;
    sequence?: number;
    kickedBack_Task_Id?: number | undefined;
    notes?: string | undefined;
    ParentTaskId?: number | undefined;
    isParallel?: boolean;
    isRequired?: boolean;
    isRework?: boolean;
    subSequence?: number | undefined;


    constructor(data?: IPatchOrderTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order_Id = _data["order_Id"];
            this.process_Id = _data["process_Id"];
            this.user_Id = _data["user_Id"];
            this.queue_Start = _data["queue_Start"] ? new Date(_data["queue_Start"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.completeDate = _data["completeDate"] ? new Date(_data["completeDate"].toString()) : <any>undefined;
            this.sequence = _data["sequence"];
            this.kickedBack_Task_Id = _data["kickedBack_Task_Id"];
            this.notes = _data["notes"];
            this.ParentTaskId = _data["ParentTaskId"];
            this.isParallel = _data["isParallel"];
            this.isRequired = _data["isRequired"];
            this.isRework = _data["isRework"];
            this.subSequence = _data["subSequence"];
        }
    }

    static fromJS(data: any): PatchOrderTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatchOrderTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order_Id"] = this.order_Id;
        data["process_Id"] = this.process_Id;
        data["user_Id"] = this.user_Id;
        data["queue_Start"] = this.queue_Start ? this.queue_Start.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["completeDate"] = this.completeDate ? this.completeDate.toISOString() : <any>undefined;
        data["sequence"] = this.sequence;
        data["kickedBack_Task_Id"] = this.kickedBack_Task_Id;
        data["notes"] = this.notes;
        data["ParentTaskId"] = this.ParentTaskId;
        data["isParallel"] = this.isParallel;
        data["isRequired"] = this.isRequired;
        data["isRework"] = this.isRework;
        data["subSequence"] = this.subSequence;
        return data;
    }
}

export interface IPatchOrderTaskDto {
    id?: number;
    order_Id?: number;
    process_Id?: number;
    user_Id?: number | undefined;
    queue_Start?: Date | undefined;
    startDate?: Date | undefined;
    completeDate?: Date | undefined;
    sequence?: number;
    kickedBack_Task_Id?: number | undefined;
    notes?: string | undefined;
    ParentTaskId?: number | undefined;
    isParallel?: boolean;
    isRequired?: boolean;
    isRework?: boolean;
    subSequence?: number | undefined;
}

export class Permission implements IPermission {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isSAPRelated?: boolean;
    types?: RtaType[] | undefined;

    constructor(data?: IPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isSAPRelated = _data["isSAPRelated"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(RtaType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Permission {
        data = typeof data === 'object' ? data : {};
        let result = new Permission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isSAPRelated"] = this.isSAPRelated;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPermission {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isSAPRelated?: boolean;
    types?: RtaType[] | undefined;
}

export class Picklist implements IPicklist {
    pickList!: string | undefined;
    data!: string | undefined;

    constructor(data?: IPicklist) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pickList = _data["pickList"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): Picklist {
        data = typeof data === 'object' ? data : {};
        let result = new Picklist();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pickList"] = this.pickList;
        data["data"] = this.data;
        return data;
    }
}

export interface IPicklist {
    pickList: string | undefined;
    data: string | undefined;
}

export class Priority implements IPriority {
    id?: number;
    name?: string | undefined;
    order?: ORD_Order[] | undefined;
    orD_Priority?: ORD_Priority[] | undefined;

    constructor(data?: IPriority) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["order"])) {
                this.order = [] as any;
                for (let item of _data["order"])
                    this.order!.push(ORD_Order.fromJS(item));
            }
            if (Array.isArray(_data["orD_Priority"])) {
                this.orD_Priority = [] as any;
                for (let item of _data["orD_Priority"])
                    this.orD_Priority!.push(ORD_Priority.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Priority {
        data = typeof data === 'object' ? data : {};
        let result = new Priority();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.order)) {
            data["order"] = [];
            for (let item of this.order)
                data["order"].push(item.toJSON());
        }
        if (Array.isArray(this.orD_Priority)) {
            data["orD_Priority"] = [];
            for (let item of this.orD_Priority)
                data["orD_Priority"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPriority {
    id?: number;
    name?: string | undefined;
    order?: ORD_Order[] | undefined;
    orD_Priority?: ORD_Priority[] | undefined;
}

export class Process implements IProcess {
    id?: number;
    name?: string | undefined;
    isProcessing?: boolean;
    orD_Order?: ORD_Order[] | undefined;
    processSets?: ProcessSet[] | undefined;
    filterSets?: FilterSet[] | undefined;
    filterSets1?: FilterSet[] | undefined;
    assignments?: Assignment[] | undefined;
    checks?: Check[] | undefined;
    checkSheet_Template?: CheckSheet_Template[] | undefined;

    constructor(data?: IProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isProcessing = _data["isProcessing"];
            if (Array.isArray(_data["orD_Order"])) {
                this.orD_Order = [] as any;
                for (let item of _data["orD_Order"])
                    this.orD_Order!.push(ORD_Order.fromJS(item));
            }
            if (Array.isArray(_data["processSets"])) {
                this.processSets = [] as any;
                for (let item of _data["processSets"])
                    this.processSets!.push(ProcessSet.fromJS(item));
            }
            if (Array.isArray(_data["filterSets"])) {
                this.filterSets = [] as any;
                for (let item of _data["filterSets"])
                    this.filterSets!.push(FilterSet.fromJS(item));
            }
            if (Array.isArray(_data["filterSets1"])) {
                this.filterSets1 = [] as any;
                for (let item of _data["filterSets1"])
                    this.filterSets1!.push(FilterSet.fromJS(item));
            }
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(Assignment.fromJS(item));
            }
            if (Array.isArray(_data["checks"])) {
                this.checks = [] as any;
                for (let item of _data["checks"])
                    this.checks!.push(Check.fromJS(item));
            }
            if (Array.isArray(_data["checkSheet_Template"])) {
                this.checkSheet_Template = [] as any;
                for (let item of _data["checkSheet_Template"])
                    this.checkSheet_Template!.push(CheckSheet_Template.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Process {
        data = typeof data === 'object' ? data : {};
        let result = new Process();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isProcessing"] = this.isProcessing;
        if (Array.isArray(this.orD_Order)) {
            data["orD_Order"] = [];
            for (let item of this.orD_Order)
                data["orD_Order"].push(item.toJSON());
        }
        if (Array.isArray(this.processSets)) {
            data["processSets"] = [];
            for (let item of this.processSets)
                data["processSets"].push(item.toJSON());
        }
        if (Array.isArray(this.filterSets)) {
            data["filterSets"] = [];
            for (let item of this.filterSets)
                data["filterSets"].push(item.toJSON());
        }
        if (Array.isArray(this.filterSets1)) {
            data["filterSets1"] = [];
            for (let item of this.filterSets1)
                data["filterSets1"].push(item.toJSON());
        }
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item.toJSON());
        }
        if (Array.isArray(this.checks)) {
            data["checks"] = [];
            for (let item of this.checks)
                data["checks"].push(item.toJSON());
        }
        if (Array.isArray(this.checkSheet_Template)) {
            data["checkSheet_Template"] = [];
            for (let item of this.checkSheet_Template)
                data["checkSheet_Template"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProcess {
    id?: number;
    name?: string | undefined;
    isProcessing?: boolean;
    orD_Order?: ORD_Order[] | undefined;
    processSets?: ProcessSet[] | undefined;
    filterSets?: FilterSet[] | undefined;
    filterSets1?: FilterSet[] | undefined;
    assignments?: Assignment[] | undefined;
    checks?: Check[] | undefined;
    checkSheet_Template?: CheckSheet_Template[] | undefined;
}

export class ProcessSet implements IProcessSet {
    id?: number;
    processId?: number;
    parent_ProcessId?: number | undefined;
    typeId?: number;
    aggregate?: boolean;
    seriesId?: number;
    required?: boolean;
    processFlow?: number | undefined;
    series?: Series;
    processTasks?: ProcessTask[] | undefined;
    processSet1?: ProcessSet[] | undefined;
    processSet2?: ProcessSet;
    process?: Process;
    type?: RtaType;

    constructor(data?: IProcessSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processId = _data["processId"];
            this.parent_ProcessId = _data["parent_ProcessId"];
            this.typeId = _data["typeId"];
            this.aggregate = _data["aggregate"];
            this.seriesId = _data["seriesId"];
            this.required = _data["required"];
            this.processFlow = _data["processFlow"];
            this.series = _data["series"] ? Series.fromJS(_data["series"]) : <any>undefined;
            if (Array.isArray(_data["processTasks"])) {
                this.processTasks = [] as any;
                for (let item of _data["processTasks"])
                    this.processTasks!.push(ProcessTask.fromJS(item));
            }
            if (Array.isArray(_data["processSet1"])) {
                this.processSet1 = [] as any;
                for (let item of _data["processSet1"])
                    this.processSet1!.push(ProcessSet.fromJS(item));
            }
            this.processSet2 = _data["processSet2"] ? ProcessSet.fromJS(_data["processSet2"]) : <any>undefined;
            this.process = _data["process"] ? Process.fromJS(_data["process"]) : <any>undefined;
            this.type = _data["type"] ? RtaType.fromJS(_data["type"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProcessSet {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processId"] = this.processId;
        data["parent_ProcessId"] = this.parent_ProcessId;
        data["typeId"] = this.typeId;
        data["aggregate"] = this.aggregate;
        data["seriesId"] = this.seriesId;
        data["required"] = this.required;
        data["processFlow"] = this.processFlow;
        data["series"] = this.series ? this.series.toJSON() : <any>undefined;
        if (Array.isArray(this.processTasks)) {
            data["processTasks"] = [];
            for (let item of this.processTasks)
                data["processTasks"].push(item.toJSON());
        }
        if (Array.isArray(this.processSet1)) {
            data["processSet1"] = [];
            for (let item of this.processSet1)
                data["processSet1"].push(item.toJSON());
        }
        data["processSet2"] = this.processSet2 ? this.processSet2.toJSON() : <any>undefined;
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProcessSet {
    id?: number;
    processId?: number;
    parent_ProcessId?: number | undefined;
    typeId?: number;
    aggregate?: boolean;
    seriesId?: number;
    required?: boolean;
    processFlow?: number | undefined;
    series?: Series;
    processTasks?: ProcessTask[] | undefined;
    processSet1?: ProcessSet[] | undefined;
    processSet2?: ProcessSet;
    process?: Process;
    type?: RtaType;
}

export class ProcessTask implements IProcessTask {
    id?: number;
    taskId?: number;
    parent_STProcessID?: number | undefined;
    processSetId?: number;
    standardTime?: number | undefined;
    processSet?: ProcessSet;
    processTask1?: ProcessTask[] | undefined;
    processTask2?: ProcessTask;
    task?: Task;

    constructor(data?: IProcessTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.parent_STProcessID = _data["parent_STProcessID"];
            this.processSetId = _data["processSetId"];
            this.standardTime = _data["standardTime"];
            this.processSet = _data["processSet"] ? ProcessSet.fromJS(_data["processSet"]) : <any>undefined;
            if (Array.isArray(_data["processTask1"])) {
                this.processTask1 = [] as any;
                for (let item of _data["processTask1"])
                    this.processTask1!.push(ProcessTask.fromJS(item));
            }
            this.processTask2 = _data["processTask2"] ? ProcessTask.fromJS(_data["processTask2"]) : <any>undefined;
            this.task = _data["task"] ? Task.fromJS(_data["task"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProcessTask {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["parent_STProcessID"] = this.parent_STProcessID;
        data["processSetId"] = this.processSetId;
        data["standardTime"] = this.standardTime;
        data["processSet"] = this.processSet ? this.processSet.toJSON() : <any>undefined;
        if (Array.isArray(this.processTask1)) {
            data["processTask1"] = [];
            for (let item of this.processTask1)
                data["processTask1"].push(item.toJSON());
        }
        data["processTask2"] = this.processTask2 ? this.processTask2.toJSON() : <any>undefined;
        data["task"] = this.task ? this.task.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProcessTask {
    id?: number;
    taskId?: number;
    parent_STProcessID?: number | undefined;
    processSetId?: number;
    standardTime?: number | undefined;
    processSet?: ProcessSet;
    processTask1?: ProcessTask[] | undefined;
    processTask2?: ProcessTask;
    task?: Task;
}

export class ProductLine implements IProductLine {
    id?: number;
    subPsl?: number;
    name?: string | undefined;
    sortOrder?: number | undefined;
    orD_Order?: ORD_Order[] | undefined;
    subPsl1?: SubPSL;

    constructor(data?: IProductLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subPsl = _data["subPsl"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["orD_Order"])) {
                this.orD_Order = [] as any;
                for (let item of _data["orD_Order"])
                    this.orD_Order!.push(ORD_Order.fromJS(item));
            }
            this.subPsl1 = _data["subPsl1"] ? SubPSL.fromJS(_data["subPsl1"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductLine {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subPsl"] = this.subPsl;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.orD_Order)) {
            data["orD_Order"] = [];
            for (let item of this.orD_Order)
                data["orD_Order"].push(item.toJSON());
        }
        data["subPsl1"] = this.subPsl1 ? this.subPsl1.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProductLine {
    id?: number;
    subPsl?: number;
    name?: string | undefined;
    sortOrder?: number | undefined;
    orD_Order?: ORD_Order[] | undefined;
    subPsl1?: SubPSL;
}

export class ProgramTracker implements IProgramTracker {
    id?: number;
    orderId?: number;
    machineId?: number | undefined;
    categoryId?: number | undefined;
    etA_Completion?: Date;
    resolution?: string | undefined;
    serverityId?: number;
    program?: string | undefined;

    constructor(data?: IProgramTracker) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.machineId = _data["machineId"];
            this.categoryId = _data["categoryId"];
            this.etA_Completion = _data["etA_Completion"] ? new Date(_data["etA_Completion"].toString()) : <any>undefined;
            this.resolution = _data["resolution"];
            this.serverityId = _data["serverityId"];
            this.program = _data["program"];
        }
    }

    static fromJS(data: any): ProgramTracker {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramTracker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["machineId"] = this.machineId;
        data["categoryId"] = this.categoryId;
        data["etA_Completion"] = this.etA_Completion ? this.etA_Completion.toISOString() : <any>undefined;
        data["resolution"] = this.resolution;
        data["serverityId"] = this.serverityId;
        data["program"] = this.program;
        return data;
    }
}

export interface IProgramTracker {
    id?: number;
    orderId?: number;
    machineId?: number | undefined;
    categoryId?: number | undefined;
    etA_Completion?: Date;
    resolution?: string | undefined;
    serverityId?: number;
    program?: string | undefined;
}

export class RTAOptions implements IRTAOptions {
    field?: string | undefined;
    fieldOptions?: string | undefined;

    constructor(data?: IRTAOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.fieldOptions = _data["fieldOptions"];
        }
    }

    static fromJS(data: any): RTAOptions {
        data = typeof data === 'object' ? data : {};
        let result = new RTAOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["fieldOptions"] = this.fieldOptions;
        return data;
    }
}

export interface IRTAOptions {
    field?: string | undefined;
    fieldOptions?: string | undefined;
}

export class Resource implements IResource {
    id?: number;
    userId?: number;
    isActive?: boolean;
    user?: User;
    resourceAssignments?: ResourceAssignment[] | undefined;

    constructor(data?: IResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["resourceAssignments"])) {
                this.resourceAssignments = [] as any;
                for (let item of _data["resourceAssignments"])
                    this.resourceAssignments!.push(ResourceAssignment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Resource {
        data = typeof data === 'object' ? data : {};
        let result = new Resource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.resourceAssignments)) {
            data["resourceAssignments"] = [];
            for (let item of this.resourceAssignments)
                data["resourceAssignments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResource {
    id?: number;
    userId?: number;
    isActive?: boolean;
    user?: User;
    resourceAssignments?: ResourceAssignment[] | undefined;
}

export class ResourceAssignment implements IResourceAssignment {
    id?: number;
    resourceId?: number;
    isMain?: boolean;
    assignmentId?: number;
    resource?: Resource;
    assignment?: Assignment;
    resourceProductivities?: ResourceProductivity[] | undefined;

    constructor(data?: IResourceAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resourceId = _data["resourceId"];
            this.isMain = _data["isMain"];
            this.assignmentId = _data["assignmentId"];
            this.resource = _data["resource"] ? Resource.fromJS(_data["resource"]) : <any>undefined;
            this.assignment = _data["assignment"] ? Assignment.fromJS(_data["assignment"]) : <any>undefined;
            if (Array.isArray(_data["resourceProductivities"])) {
                this.resourceProductivities = [] as any;
                for (let item of _data["resourceProductivities"])
                    this.resourceProductivities!.push(ResourceProductivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResourceAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resourceId"] = this.resourceId;
        data["isMain"] = this.isMain;
        data["assignmentId"] = this.assignmentId;
        data["resource"] = this.resource ? this.resource.toJSON() : <any>undefined;
        data["assignment"] = this.assignment ? this.assignment.toJSON() : <any>undefined;
        if (Array.isArray(this.resourceProductivities)) {
            data["resourceProductivities"] = [];
            for (let item of this.resourceProductivities)
                data["resourceProductivities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResourceAssignment {
    id?: number;
    resourceId?: number;
    isMain?: boolean;
    assignmentId?: number;
    resource?: Resource;
    assignment?: Assignment;
    resourceProductivities?: ResourceProductivity[] | undefined;
}

export class ResourceProductivity implements IResourceProductivity {
    id?: number;
    resourceAssignmentId?: number;
    processingTime?: number | undefined;
    groupProcessingTime?: number | undefined;
    monthlyProcessed?: number | undefined;
    groupProcessed?: number | undefined;
    longestLeadTime_OrderId?: number | undefined;
    longestLeadTime?: number | undefined;
    shortestLeadTime_OrderId?: number | undefined;
    shortestLeadTime?: number | undefined;
    lastUpdated?: Date;
    userPTDelta?: number | undefined;
    userPTPDelta?: number | undefined;
    groupPTDelta?: number | undefined;
    groupPTPDelta?: number | undefined;
    orD_Order?: ORD_Order;
    orD_Order1?: ORD_Order;
    resourceAssignment?: ResourceAssignment;

    constructor(data?: IResourceProductivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resourceAssignmentId = _data["resourceAssignmentId"];
            this.processingTime = _data["processingTime"];
            this.groupProcessingTime = _data["groupProcessingTime"];
            this.monthlyProcessed = _data["monthlyProcessed"];
            this.groupProcessed = _data["groupProcessed"];
            this.longestLeadTime_OrderId = _data["longestLeadTime_OrderId"];
            this.longestLeadTime = _data["longestLeadTime"];
            this.shortestLeadTime_OrderId = _data["shortestLeadTime_OrderId"];
            this.shortestLeadTime = _data["shortestLeadTime"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.userPTDelta = _data["userPTDelta"];
            this.userPTPDelta = _data["userPTPDelta"];
            this.groupPTDelta = _data["groupPTDelta"];
            this.groupPTPDelta = _data["groupPTPDelta"];
            this.orD_Order = _data["orD_Order"] ? ORD_Order.fromJS(_data["orD_Order"]) : <any>undefined;
            this.orD_Order1 = _data["orD_Order1"] ? ORD_Order.fromJS(_data["orD_Order1"]) : <any>undefined;
            this.resourceAssignment = _data["resourceAssignment"] ? ResourceAssignment.fromJS(_data["resourceAssignment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResourceProductivity {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceProductivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resourceAssignmentId"] = this.resourceAssignmentId;
        data["processingTime"] = this.processingTime;
        data["groupProcessingTime"] = this.groupProcessingTime;
        data["monthlyProcessed"] = this.monthlyProcessed;
        data["groupProcessed"] = this.groupProcessed;
        data["longestLeadTime_OrderId"] = this.longestLeadTime_OrderId;
        data["longestLeadTime"] = this.longestLeadTime;
        data["shortestLeadTime_OrderId"] = this.shortestLeadTime_OrderId;
        data["shortestLeadTime"] = this.shortestLeadTime;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["userPTDelta"] = this.userPTDelta;
        data["userPTPDelta"] = this.userPTPDelta;
        data["groupPTDelta"] = this.groupPTDelta;
        data["groupPTPDelta"] = this.groupPTPDelta;
        data["orD_Order"] = this.orD_Order ? this.orD_Order.toJSON() : <any>undefined;
        data["orD_Order1"] = this.orD_Order1 ? this.orD_Order1.toJSON() : <any>undefined;
        data["resourceAssignment"] = this.resourceAssignment ? this.resourceAssignment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResourceProductivity {
    id?: number;
    resourceAssignmentId?: number;
    processingTime?: number | undefined;
    groupProcessingTime?: number | undefined;
    monthlyProcessed?: number | undefined;
    groupProcessed?: number | undefined;
    longestLeadTime_OrderId?: number | undefined;
    longestLeadTime?: number | undefined;
    shortestLeadTime_OrderId?: number | undefined;
    shortestLeadTime?: number | undefined;
    lastUpdated?: Date;
    userPTDelta?: number | undefined;
    userPTPDelta?: number | undefined;
    groupPTDelta?: number | undefined;
    groupPTPDelta?: number | undefined;
    orD_Order?: ORD_Order;
    orD_Order1?: ORD_Order;
    resourceAssignment?: ResourceAssignment;
}

export class Restrictor implements IRestrictor {
    id?: number;
    drawingLogId?: number;
    outerDemension?: number;
    length?: number;
    insideDemension?: number;
    orificeCount?: number;
    oRingId?: number;
    drawingLog?: DrawingLog;
    oRing?: ORing;

    constructor(data?: IRestrictor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.drawingLogId = _data["drawingLogId"];
            this.outerDemension = _data["outerDemension"];
            this.length = _data["length"];
            this.insideDemension = _data["insideDemension"];
            this.orificeCount = _data["orificeCount"];
            this.oRingId = _data["oRingId"];
            this.drawingLog = _data["drawingLog"] ? DrawingLog.fromJS(_data["drawingLog"]) : <any>undefined;
            this.oRing = _data["oRing"] ? ORing.fromJS(_data["oRing"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Restrictor {
        data = typeof data === 'object' ? data : {};
        let result = new Restrictor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["drawingLogId"] = this.drawingLogId;
        data["outerDemension"] = this.outerDemension;
        data["length"] = this.length;
        data["insideDemension"] = this.insideDemension;
        data["orificeCount"] = this.orificeCount;
        data["oRingId"] = this.oRingId;
        data["drawingLog"] = this.drawingLog ? this.drawingLog.toJSON() : <any>undefined;
        data["oRing"] = this.oRing ? this.oRing.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRestrictor {
    id?: number;
    drawingLogId?: number;
    outerDemension?: number;
    length?: number;
    insideDemension?: number;
    orificeCount?: number;
    oRingId?: number;
    drawingLog?: DrawingLog;
    oRing?: ORing;
}

export class ReturnViewModel implements IReturnViewModel {
    status?: boolean;
    message?: string | undefined;
    info?: any | undefined;

    constructor(data?: IReturnViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.info = _data["info"];
        }
    }

    static fromJS(data: any): ReturnViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["info"] = this.info;
        return data;
    }
}

export interface IReturnViewModel {
    status?: boolean;
    message?: string | undefined;
    info?: any | undefined;
}

export class RingGauge implements IRingGauge {
    id?: number;
    bitSize?: number;
    drawingNumber?: string | undefined;
    drawingTitle?: string | undefined;
    revision?: string | undefined;
    gosapNumber?: number | undefined;
    gosapStainless?: number | undefined;
    nogoStainless?: number | undefined;
    nogosapNumber?: number | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    fixedCutterRingGauges?: FixedCutterRingGauge[] | undefined;

    constructor(data?: IRingGauge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bitSize = _data["bitSize"];
            this.drawingNumber = _data["drawingNumber"];
            this.drawingTitle = _data["drawingTitle"];
            this.revision = _data["revision"];
            this.gosapNumber = _data["gosapNumber"];
            this.gosapStainless = _data["gosapStainless"];
            this.nogoStainless = _data["nogoStainless"];
            this.nogosapNumber = _data["nogosapNumber"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["fixedCutterRingGauges"])) {
                this.fixedCutterRingGauges = [] as any;
                for (let item of _data["fixedCutterRingGauges"])
                    this.fixedCutterRingGauges!.push(FixedCutterRingGauge.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RingGauge {
        data = typeof data === 'object' ? data : {};
        let result = new RingGauge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bitSize"] = this.bitSize;
        data["drawingNumber"] = this.drawingNumber;
        data["drawingTitle"] = this.drawingTitle;
        data["revision"] = this.revision;
        data["gosapNumber"] = this.gosapNumber;
        data["gosapStainless"] = this.gosapStainless;
        data["nogoStainless"] = this.nogoStainless;
        data["nogosapNumber"] = this.nogosapNumber;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.fixedCutterRingGauges)) {
            data["fixedCutterRingGauges"] = [];
            for (let item of this.fixedCutterRingGauges)
                data["fixedCutterRingGauges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRingGauge {
    id?: number;
    bitSize?: number;
    drawingNumber?: string | undefined;
    drawingTitle?: string | undefined;
    revision?: string | undefined;
    gosapNumber?: number | undefined;
    gosapStainless?: number | undefined;
    nogoStainless?: number | undefined;
    nogosapNumber?: number | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    fixedCutterRingGauges?: FixedCutterRingGauge[] | undefined;
}

export class RollerCone implements IRollerCone {
    id?: number;
    rtaNum?: number;
    bitCode?: string | undefined;
    bitClass?: string | undefined;
    pinAng?: number | undefined;
    offsetNum?: number | undefined;
    brgCode?: string | undefined;
    bkfc?: number | undefined;
    taskLevel?: number | undefined;
    techBit?: boolean | undefined;
    surfDiamond?: number | undefined;
    coneType?: string | undefined;
    faiRequired?: boolean;
    adero?: boolean;
    newCone?: boolean | undefined;
    newArm?: boolean | undefined;
    layout?: number | undefined;
    arm?: number | undefined;
    shirtTailProtection?: string | undefined;
    referenceLayout?: number | undefined;
    referenceArm?: number | undefined;
    retrofitFeature?: string | undefined;
    retrofitType?: string | undefined;

    constructor(data?: IRollerCone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rtaNum = _data["rtaNum"];
            this.bitCode = _data["bitCode"];
            this.bitClass = _data["bitClass"];
            this.pinAng = _data["pinAng"];
            this.offsetNum = _data["offsetNum"];
            this.brgCode = _data["brgCode"];
            this.bkfc = _data["bkfc"];
            this.taskLevel = _data["taskLevel"];
            this.techBit = _data["techBit"];
            this.surfDiamond = _data["surfDiamond"];
            this.coneType = _data["coneType"];
            this.faiRequired = _data["faiRequired"];
            this.adero = _data["adero"];
            this.newCone = _data["newCone"];
            this.newArm = _data["newArm"];
            this.layout = _data["layout"];
            this.arm = _data["arm"];
            this.shirtTailProtection = _data["shirtTailProtection"];
            this.referenceLayout = _data["referenceLayout"];
            this.referenceArm = _data["referenceArm"];
            this.retrofitFeature = _data["retrofitFeature"];
            this.retrofitType = _data["retrofitType"];
        }
    }

    static fromJS(data: any): RollerCone {
        data = typeof data === 'object' ? data : {};
        let result = new RollerCone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rtaNum"] = this.rtaNum;
        data["bitCode"] = this.bitCode;
        data["bitClass"] = this.bitClass;
        data["pinAng"] = this.pinAng;
        data["offsetNum"] = this.offsetNum;
        data["brgCode"] = this.brgCode;
        data["bkfc"] = this.bkfc;
        data["taskLevel"] = this.taskLevel;
        data["techBit"] = this.techBit;
        data["surfDiamond"] = this.surfDiamond;
        data["coneType"] = this.coneType;
        data["faiRequired"] = this.faiRequired;
        data["adero"] = this.adero;
        data["newCone"] = this.newCone;
        data["newArm"] = this.newArm;
        data["layout"] = this.layout;
        data["arm"] = this.arm;
        data["shirtTailProtection"] = this.shirtTailProtection;
        data["referenceLayout"] = this.referenceLayout;
        data["referenceArm"] = this.referenceArm;
        data["retrofitFeature"] = this.retrofitFeature;
        data["retrofitType"] = this.retrofitType;
        return data;
    }
}

export interface IRollerCone {
    id?: number;
    rtaNum?: number;
    bitCode?: string | undefined;
    bitClass?: string | undefined;
    pinAng?: number | undefined;
    offsetNum?: number | undefined;
    brgCode?: string | undefined;
    bkfc?: number | undefined;
    taskLevel?: number | undefined;
    techBit?: boolean | undefined;
    surfDiamond?: number | undefined;
    coneType?: string | undefined;
    faiRequired?: boolean;
    adero?: boolean;
    newCone?: boolean | undefined;
    newArm?: boolean | undefined;
    layout?: number | undefined;
    arm?: number | undefined;
    shirtTailProtection?: string | undefined;
    referenceLayout?: number | undefined;
    referenceArm?: number | undefined;
    retrofitFeature?: string | undefined;
    retrofitType?: string | undefined;
}

export class Router_Process implements IRouter_Process {
    id?: number;
    name?: string | undefined;
    prefix?: string | undefined;
    specialInstructions?: SpecialInstruction[] | undefined;

    constructor(data?: IRouter_Process) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.prefix = _data["prefix"];
            if (Array.isArray(_data["specialInstructions"])) {
                this.specialInstructions = [] as any;
                for (let item of _data["specialInstructions"])
                    this.specialInstructions!.push(SpecialInstruction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Router_Process {
        data = typeof data === 'object' ? data : {};
        let result = new Router_Process();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["prefix"] = this.prefix;
        if (Array.isArray(this.specialInstructions)) {
            data["specialInstructions"] = [];
            for (let item of this.specialInstructions)
                data["specialInstructions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRouter_Process {
    id?: number;
    name?: string | undefined;
    prefix?: string | undefined;
    specialInstructions?: SpecialInstruction[] | undefined;
}

export class Row implements IRow {
    number?: number;
    chamfer?: string | undefined;
    type?: string | undefined;
    cutters?: number[] | undefined;
    cutterCount?: number;
    rowWidth?: number;

    constructor(data?: IRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.chamfer = _data["chamfer"];
            this.type = _data["type"];
            if (Array.isArray(_data["cutters"])) {
                this.cutters = [] as any;
                for (let item of _data["cutters"])
                    this.cutters!.push(item);
            }
            this.cutterCount = _data["cutterCount"];
            this.rowWidth = _data["rowWidth"];
        }
    }

    static fromJS(data: any): Row {
        data = typeof data === 'object' ? data : {};
        let result = new Row();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["chamfer"] = this.chamfer;
        data["type"] = this.type;
        if (Array.isArray(this.cutters)) {
            data["cutters"] = [];
            for (let item of this.cutters)
                data["cutters"].push(item);
        }
        data["cutterCount"] = this.cutterCount;
        data["rowWidth"] = this.rowWidth;
        return data;
    }
}

export interface IRow {
    number?: number;
    chamfer?: string | undefined;
    type?: string | undefined;
    cutters?: number[] | undefined;
    cutterCount?: number;
    rowWidth?: number;
}

export class SOCreateReturnPayload implements ISOCreateReturnPayload {
    hdbsExternalId!: string;
    salesOrderId?: string | undefined;
    sapNumber?: string | undefined;
    createdById?: string | undefined;
    createdDate?: Date | undefined;
    ngType?: string | undefined;
    ngStatus!: string;
    errorMessage?: string | undefined;
    sapSync?: Date | undefined;

    constructor(data?: ISOCreateReturnPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hdbsExternalId = _data["hdbsExternalId"];
            this.salesOrderId = _data["salesOrderId"];
            this.sapNumber = _data["sapNumber"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.ngType = _data["ngType"];
            this.ngStatus = _data["ngStatus"];
            this.errorMessage = _data["errorMessage"];
            this.sapSync = _data["sapSync"] ? new Date(_data["sapSync"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SOCreateReturnPayload {
        data = typeof data === 'object' ? data : {};
        let result = new SOCreateReturnPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hdbsExternalId"] = this.hdbsExternalId;
        data["salesOrderId"] = this.salesOrderId;
        data["sapNumber"] = this.sapNumber;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["ngType"] = this.ngType;
        data["ngStatus"] = this.ngStatus;
        data["errorMessage"] = this.errorMessage;
        data["sapSync"] = this.sapSync ? this.sapSync.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISOCreateReturnPayload {
    hdbsExternalId: string;
    salesOrderId?: string | undefined;
    sapNumber?: string | undefined;
    createdById?: string | undefined;
    createdDate?: Date | undefined;
    ngType?: string | undefined;
    ngStatus: string;
    errorMessage?: string | undefined;
    sapSync?: Date | undefined;
}

export class SapNumType implements ISapNumType {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    sapNumbers?: SapNumber[] | undefined;
    pnA_Part?: PNA_Part[] | undefined;

    constructor(data?: ISapNumType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["sapNumbers"])) {
                this.sapNumbers = [] as any;
                for (let item of _data["sapNumbers"])
                    this.sapNumbers!.push(SapNumber.fromJS(item));
            }
            if (Array.isArray(_data["pnA_Part"])) {
                this.pnA_Part = [] as any;
                for (let item of _data["pnA_Part"])
                    this.pnA_Part!.push(PNA_Part.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SapNumType {
        data = typeof data === 'object' ? data : {};
        let result = new SapNumType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.sapNumbers)) {
            data["sapNumbers"] = [];
            for (let item of this.sapNumbers)
                data["sapNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.pnA_Part)) {
            data["pnA_Part"] = [];
            for (let item of this.pnA_Part)
                data["pnA_Part"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISapNumType {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    sapNumbers?: SapNumber[] | undefined;
    pnA_Part?: PNA_Part[] | undefined;
}

export class SapNumber implements ISapNumber {
    id?: number;
    orderId?: number;
    sapNumTypeId?: number;
    number?: number;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    description?: string | undefined;
    order?: ORD_Order;
    sapNumType?: SapNumType;
    createdByUser?: User;
    modifiedByUser?: User;

    constructor(data?: ISapNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.sapNumTypeId = _data["sapNumTypeId"];
            this.number = _data["number"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.order = _data["order"] ? ORD_Order.fromJS(_data["order"]) : <any>undefined;
            this.sapNumType = _data["sapNumType"] ? SapNumType.fromJS(_data["sapNumType"]) : <any>undefined;
            this.createdByUser = _data["createdByUser"] ? User.fromJS(_data["createdByUser"]) : <any>undefined;
            this.modifiedByUser = _data["modifiedByUser"] ? User.fromJS(_data["modifiedByUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SapNumber {
        data = typeof data === 'object' ? data : {};
        let result = new SapNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["sapNumTypeId"] = this.sapNumTypeId;
        data["number"] = this.number;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["sapNumType"] = this.sapNumType ? this.sapNumType.toJSON() : <any>undefined;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        data["modifiedByUser"] = this.modifiedByUser ? this.modifiedByUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISapNumber {
    id?: number;
    orderId?: number;
    sapNumTypeId?: number;
    number?: number;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    description?: string | undefined;
    order?: ORD_Order;
    sapNumType?: SapNumType;
    createdByUser?: User;
    modifiedByUser?: User;
}

export class Series implements ISeries {
    id?: number;
    name?: string | undefined;
    order?: ORD_Order[] | undefined;
    processSets?: ProcessSet[] | undefined;
    subPsls?: SubPSL[] | undefined;

    constructor(data?: ISeries) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["order"])) {
                this.order = [] as any;
                for (let item of _data["order"])
                    this.order!.push(ORD_Order.fromJS(item));
            }
            if (Array.isArray(_data["processSets"])) {
                this.processSets = [] as any;
                for (let item of _data["processSets"])
                    this.processSets!.push(ProcessSet.fromJS(item));
            }
            if (Array.isArray(_data["subPsls"])) {
                this.subPsls = [] as any;
                for (let item of _data["subPsls"])
                    this.subPsls!.push(SubPSL.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Series {
        data = typeof data === 'object' ? data : {};
        let result = new Series();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.order)) {
            data["order"] = [];
            for (let item of this.order)
                data["order"].push(item.toJSON());
        }
        if (Array.isArray(this.processSets)) {
            data["processSets"] = [];
            for (let item of this.processSets)
                data["processSets"].push(item.toJSON());
        }
        if (Array.isArray(this.subPsls)) {
            data["subPsls"] = [];
            for (let item of this.subPsls)
                data["subPsls"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeries {
    id?: number;
    name?: string | undefined;
    order?: ORD_Order[] | undefined;
    processSets?: ProcessSet[] | undefined;
    subPsls?: SubPSL[] | undefined;
}

export class SpecialInstruction implements ISpecialInstruction {
    id?: number;
    bitFeature_Id?: number | undefined;
    special_Instruction?: string | undefined;
    isObsolete?: boolean;
    router_Process_Id?: number;
    isCalculated?: boolean;
    isUserSelected?: boolean;
    productline_Id?: number | undefined;
    code?: string | undefined;
    bitFeature?: Features;
    productLine?: ProductLine;
    specialInstruction_RTAAssociation?: SpecialInstruction_RTAAssociation[] | undefined;
    router_Process?: Router_Process;

    constructor(data?: ISpecialInstruction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bitFeature_Id = _data["bitFeature_Id"];
            this.special_Instruction = _data["special_Instruction"];
            this.isObsolete = _data["isObsolete"];
            this.router_Process_Id = _data["router_Process_Id"];
            this.isCalculated = _data["isCalculated"];
            this.isUserSelected = _data["isUserSelected"];
            this.productline_Id = _data["productline_Id"];
            this.code = _data["code"];
            this.bitFeature = _data["bitFeature"] ? Features.fromJS(_data["bitFeature"]) : <any>undefined;
            this.productLine = _data["productLine"] ? ProductLine.fromJS(_data["productLine"]) : <any>undefined;
            if (Array.isArray(_data["specialInstruction_RTAAssociation"])) {
                this.specialInstruction_RTAAssociation = [] as any;
                for (let item of _data["specialInstruction_RTAAssociation"])
                    this.specialInstruction_RTAAssociation!.push(SpecialInstruction_RTAAssociation.fromJS(item));
            }
            this.router_Process = _data["router_Process"] ? Router_Process.fromJS(_data["router_Process"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SpecialInstruction {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialInstruction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bitFeature_Id"] = this.bitFeature_Id;
        data["special_Instruction"] = this.special_Instruction;
        data["isObsolete"] = this.isObsolete;
        data["router_Process_Id"] = this.router_Process_Id;
        data["isCalculated"] = this.isCalculated;
        data["isUserSelected"] = this.isUserSelected;
        data["productline_Id"] = this.productline_Id;
        data["code"] = this.code;
        data["bitFeature"] = this.bitFeature ? this.bitFeature.toJSON() : <any>undefined;
        data["productLine"] = this.productLine ? this.productLine.toJSON() : <any>undefined;
        if (Array.isArray(this.specialInstruction_RTAAssociation)) {
            data["specialInstruction_RTAAssociation"] = [];
            for (let item of this.specialInstruction_RTAAssociation)
                data["specialInstruction_RTAAssociation"].push(item.toJSON());
        }
        data["router_Process"] = this.router_Process ? this.router_Process.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISpecialInstruction {
    id?: number;
    bitFeature_Id?: number | undefined;
    special_Instruction?: string | undefined;
    isObsolete?: boolean;
    router_Process_Id?: number;
    isCalculated?: boolean;
    isUserSelected?: boolean;
    productline_Id?: number | undefined;
    code?: string | undefined;
    bitFeature?: Features;
    productLine?: ProductLine;
    specialInstruction_RTAAssociation?: SpecialInstruction_RTAAssociation[] | undefined;
    router_Process?: Router_Process;
}

export class SpecialInstruction_RTAAssociation implements ISpecialInstruction_RTAAssociation {
    id?: number;
    specialInstruction_Id?: number;
    order_Id?: number;
    specialInstruction_Altered?: string | undefined;
    orD_Order?: ORD_Order;
    specialInstruction?: SpecialInstruction;

    constructor(data?: ISpecialInstruction_RTAAssociation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.specialInstruction_Id = _data["specialInstruction_Id"];
            this.order_Id = _data["order_Id"];
            this.specialInstruction_Altered = _data["specialInstruction_Altered"];
            this.orD_Order = _data["orD_Order"] ? ORD_Order.fromJS(_data["orD_Order"]) : <any>undefined;
            this.specialInstruction = _data["specialInstruction"] ? SpecialInstruction.fromJS(_data["specialInstruction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SpecialInstruction_RTAAssociation {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialInstruction_RTAAssociation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["specialInstruction_Id"] = this.specialInstruction_Id;
        data["order_Id"] = this.order_Id;
        data["specialInstruction_Altered"] = this.specialInstruction_Altered;
        data["orD_Order"] = this.orD_Order ? this.orD_Order.toJSON() : <any>undefined;
        data["specialInstruction"] = this.specialInstruction ? this.specialInstruction.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISpecialInstruction_RTAAssociation {
    id?: number;
    specialInstruction_Id?: number;
    order_Id?: number;
    specialInstruction_Altered?: string | undefined;
    orD_Order?: ORD_Order;
    specialInstruction?: SpecialInstruction;
}

export class StandardJunkSlotMold implements IStandardJunkSlotMold {
    id?: number;
    diameter?: number;
    exposure?: number;
    gaugePadLengthMin?: number;
    gaugePadLengthMax?: number;
    drawingLogId?: number;
    drawingLog?: DrawingLog;

    constructor(data?: IStandardJunkSlotMold) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.diameter = _data["diameter"];
            this.exposure = _data["exposure"];
            this.gaugePadLengthMin = _data["gaugePadLengthMin"];
            this.gaugePadLengthMax = _data["gaugePadLengthMax"];
            this.drawingLogId = _data["drawingLogId"];
            this.drawingLog = _data["drawingLog"] ? DrawingLog.fromJS(_data["drawingLog"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StandardJunkSlotMold {
        data = typeof data === 'object' ? data : {};
        let result = new StandardJunkSlotMold();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["diameter"] = this.diameter;
        data["exposure"] = this.exposure;
        data["gaugePadLengthMin"] = this.gaugePadLengthMin;
        data["gaugePadLengthMax"] = this.gaugePadLengthMax;
        data["drawingLogId"] = this.drawingLogId;
        data["drawingLog"] = this.drawingLog ? this.drawingLog.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStandardJunkSlotMold {
    id?: number;
    diameter?: number;
    exposure?: number;
    gaugePadLengthMin?: number;
    gaugePadLengthMax?: number;
    drawingLogId?: number;
    drawingLog?: DrawingLog;
}

export class Steel4130 implements ISteel4130 {
    id?: number;
    sapNumber?: number;
    description?: string | undefined;
    size?: number;
    minSize?: number;
    maxSize?: number;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    standardCost?: number | undefined;
    lastUpdatedDateFromSAP?: Date | undefined;
    upperSections?: Uppersection[] | undefined;

    constructor(data?: ISteel4130) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sapNumber = _data["sapNumber"];
            this.description = _data["description"];
            this.size = _data["size"];
            this.minSize = _data["minSize"];
            this.maxSize = _data["maxSize"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.standardCost = _data["standardCost"];
            this.lastUpdatedDateFromSAP = _data["lastUpdatedDateFromSAP"] ? new Date(_data["lastUpdatedDateFromSAP"].toString()) : <any>undefined;
            if (Array.isArray(_data["upperSections"])) {
                this.upperSections = [] as any;
                for (let item of _data["upperSections"])
                    this.upperSections!.push(Uppersection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Steel4130 {
        data = typeof data === 'object' ? data : {};
        let result = new Steel4130();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sapNumber"] = this.sapNumber;
        data["description"] = this.description;
        data["size"] = this.size;
        data["minSize"] = this.minSize;
        data["maxSize"] = this.maxSize;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["standardCost"] = this.standardCost;
        data["lastUpdatedDateFromSAP"] = this.lastUpdatedDateFromSAP ? this.lastUpdatedDateFromSAP.toISOString() : <any>undefined;
        if (Array.isArray(this.upperSections)) {
            data["upperSections"] = [];
            for (let item of this.upperSections)
                data["upperSections"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISteel4130 {
    id?: number;
    sapNumber?: number;
    description?: string | undefined;
    size?: number;
    minSize?: number;
    maxSize?: number;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    standardCost?: number | undefined;
    lastUpdatedDateFromSAP?: Date | undefined;
    upperSections?: Uppersection[] | undefined;
}

export class SubApplicationLabels implements ISubApplicationLabels {
    maxInclination?: string | undefined;
    doglegSeverity?: string | undefined;
    depthIn?: string | undefined;
    depthOut?: string | undefined;
    rop?: string | undefined;
    rpm?: string | undefined;
    flowRate?: string | undefined;
    wob?: string | undefined;
    tob?: string | undefined;

    constructor(data?: ISubApplicationLabels) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxInclination = _data["maxInclination"];
            this.doglegSeverity = _data["doglegSeverity"];
            this.depthIn = _data["depthIn"];
            this.depthOut = _data["depthOut"];
            this.rop = _data["rop"];
            this.rpm = _data["rpm"];
            this.flowRate = _data["flowRate"];
            this.wob = _data["wob"];
            this.tob = _data["tob"];
        }
    }

    static fromJS(data: any): SubApplicationLabels {
        data = typeof data === 'object' ? data : {};
        let result = new SubApplicationLabels();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxInclination"] = this.maxInclination;
        data["doglegSeverity"] = this.doglegSeverity;
        data["depthIn"] = this.depthIn;
        data["depthOut"] = this.depthOut;
        data["rop"] = this.rop;
        data["rpm"] = this.rpm;
        data["flowRate"] = this.flowRate;
        data["wob"] = this.wob;
        data["tob"] = this.tob;
        return data;
    }
}

export interface ISubApplicationLabels {
    maxInclination?: string | undefined;
    doglegSeverity?: string | undefined;
    depthIn?: string | undefined;
    depthOut?: string | undefined;
    rop?: string | undefined;
    rpm?: string | undefined;
    flowRate?: string | undefined;
    wob?: string | undefined;
    tob?: string | undefined;
}

export class SubApplicationSearchOptions implements ISubApplicationSearchOptions {
    maxInclination?: Int32Limits;
    dogLegSeverity?: DecimalLimits;
    depthIn?: DecimalLimits;
    depthOut?: DecimalLimits;
    rop?: DecimalLimits;
    rpm?: DecimalLimits;
    flowRate?: DecimalLimits;
    wob?: DecimalLimits;
    tob?: DecimalLimits;

    constructor(data?: ISubApplicationSearchOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxInclination = _data["maxInclination"] ? Int32Limits.fromJS(_data["maxInclination"]) : <any>undefined;
            this.dogLegSeverity = _data["dogLegSeverity"] ? DecimalLimits.fromJS(_data["dogLegSeverity"]) : <any>undefined;
            this.depthIn = _data["depthIn"] ? DecimalLimits.fromJS(_data["depthIn"]) : <any>undefined;
            this.depthOut = _data["depthOut"] ? DecimalLimits.fromJS(_data["depthOut"]) : <any>undefined;
            this.rop = _data["rop"] ? DecimalLimits.fromJS(_data["rop"]) : <any>undefined;
            this.rpm = _data["rpm"] ? DecimalLimits.fromJS(_data["rpm"]) : <any>undefined;
            this.flowRate = _data["flowRate"] ? DecimalLimits.fromJS(_data["flowRate"]) : <any>undefined;
            this.wob = _data["wob"] ? DecimalLimits.fromJS(_data["wob"]) : <any>undefined;
            this.tob = _data["tob"] ? DecimalLimits.fromJS(_data["tob"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubApplicationSearchOptions {
        data = typeof data === 'object' ? data : {};
        let result = new SubApplicationSearchOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxInclination"] = this.maxInclination ? this.maxInclination.toJSON() : <any>undefined;
        data["dogLegSeverity"] = this.dogLegSeverity ? this.dogLegSeverity.toJSON() : <any>undefined;
        data["depthIn"] = this.depthIn ? this.depthIn.toJSON() : <any>undefined;
        data["depthOut"] = this.depthOut ? this.depthOut.toJSON() : <any>undefined;
        data["rop"] = this.rop ? this.rop.toJSON() : <any>undefined;
        data["rpm"] = this.rpm ? this.rpm.toJSON() : <any>undefined;
        data["flowRate"] = this.flowRate ? this.flowRate.toJSON() : <any>undefined;
        data["wob"] = this.wob ? this.wob.toJSON() : <any>undefined;
        data["tob"] = this.tob ? this.tob.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubApplicationSearchOptions {
    maxInclination?: Int32Limits;
    dogLegSeverity?: DecimalLimits;
    depthIn?: DecimalLimits;
    depthOut?: DecimalLimits;
    rop?: DecimalLimits;
    rpm?: DecimalLimits;
    flowRate?: DecimalLimits;
    wob?: DecimalLimits;
    tob?: DecimalLimits;
}

export class SubPSL implements ISubPSL {
    id?: number;
    name?: string | undefined;
    default_SeriesId?: number;
    permissionId?: number;
    productLines?: ProductLine[] | undefined;
    orD_Order?: ORD_Order[] | undefined;
    filterSets?: FilterSet[] | undefined;
    series?: Series;
    permission?: Permission;
    pnA_Part?: PNA_Part[] | undefined;

    constructor(data?: ISubPSL) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.default_SeriesId = _data["default_SeriesId"];
            this.permissionId = _data["permissionId"];
            if (Array.isArray(_data["productLines"])) {
                this.productLines = [] as any;
                for (let item of _data["productLines"])
                    this.productLines!.push(ProductLine.fromJS(item));
            }
            if (Array.isArray(_data["orD_Order"])) {
                this.orD_Order = [] as any;
                for (let item of _data["orD_Order"])
                    this.orD_Order!.push(ORD_Order.fromJS(item));
            }
            if (Array.isArray(_data["filterSets"])) {
                this.filterSets = [] as any;
                for (let item of _data["filterSets"])
                    this.filterSets!.push(FilterSet.fromJS(item));
            }
            this.series = _data["series"] ? Series.fromJS(_data["series"]) : <any>undefined;
            this.permission = _data["permission"] ? Permission.fromJS(_data["permission"]) : <any>undefined;
            if (Array.isArray(_data["pnA_Part"])) {
                this.pnA_Part = [] as any;
                for (let item of _data["pnA_Part"])
                    this.pnA_Part!.push(PNA_Part.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubPSL {
        data = typeof data === 'object' ? data : {};
        let result = new SubPSL();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["default_SeriesId"] = this.default_SeriesId;
        data["permissionId"] = this.permissionId;
        if (Array.isArray(this.productLines)) {
            data["productLines"] = [];
            for (let item of this.productLines)
                data["productLines"].push(item.toJSON());
        }
        if (Array.isArray(this.orD_Order)) {
            data["orD_Order"] = [];
            for (let item of this.orD_Order)
                data["orD_Order"].push(item.toJSON());
        }
        if (Array.isArray(this.filterSets)) {
            data["filterSets"] = [];
            for (let item of this.filterSets)
                data["filterSets"].push(item.toJSON());
        }
        data["series"] = this.series ? this.series.toJSON() : <any>undefined;
        data["permission"] = this.permission ? this.permission.toJSON() : <any>undefined;
        if (Array.isArray(this.pnA_Part)) {
            data["pnA_Part"] = [];
            for (let item of this.pnA_Part)
                data["pnA_Part"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubPSL {
    id?: number;
    name?: string | undefined;
    default_SeriesId?: number;
    permissionId?: number;
    productLines?: ProductLine[] | undefined;
    orD_Order?: ORD_Order[] | undefined;
    filterSets?: FilterSet[] | undefined;
    series?: Series;
    permission?: Permission;
    pnA_Part?: PNA_Part[] | undefined;
}

export class Task implements ITask {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    processTasks?: ProcessTask[] | undefined;

    constructor(data?: ITask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["processTasks"])) {
                this.processTasks = [] as any;
                for (let item of _data["processTasks"])
                    this.processTasks!.push(ProcessTask.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Task {
        data = typeof data === 'object' ? data : {};
        let result = new Task();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.processTasks)) {
            data["processTasks"] = [];
            for (let item of this.processTasks)
                data["processTasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITask {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    processTasks?: ProcessTask[] | undefined;
}

export class ThreadProtector implements IThreadProtector {
    id?: number;
    sapNumber?: number;
    apiid?: number;
    description?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    upperSections?: Uppersection[] | undefined;

    constructor(data?: IThreadProtector) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sapNumber = _data["sapNumber"];
            this.apiid = _data["apiid"];
            this.description = _data["description"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["upperSections"])) {
                this.upperSections = [] as any;
                for (let item of _data["upperSections"])
                    this.upperSections!.push(Uppersection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ThreadProtector {
        data = typeof data === 'object' ? data : {};
        let result = new ThreadProtector();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sapNumber"] = this.sapNumber;
        data["apiid"] = this.apiid;
        data["description"] = this.description;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        if (Array.isArray(this.upperSections)) {
            data["upperSections"] = [];
            for (let item of this.upperSections)
                data["upperSections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IThreadProtector {
    id?: number;
    sapNumber?: number;
    apiid?: number;
    description?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    upperSections?: Uppersection[] | undefined;
}

export class RtaType implements IRtaType {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    rank?: number | undefined;
    typeGroupId?: number | undefined;
    permissionId?: number;
    order?: ORD_Order[] | undefined;
    processSets?: ProcessSet[] | undefined;
    typeGroup?: TypeGroup;
    permissions?: Permission[] | undefined;
    parts?: Part[] | undefined;
    permission?: Permission;

    constructor(data?: IRtaType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.rank = _data["rank"];
            this.typeGroupId = _data["typeGroupId"];
            this.permissionId = _data["permissionId"];
            if (Array.isArray(_data["order"])) {
                this.order = [] as any;
                for (let item of _data["order"])
                    this.order!.push(ORD_Order.fromJS(item));
            }
            if (Array.isArray(_data["processSets"])) {
                this.processSets = [] as any;
                for (let item of _data["processSets"])
                    this.processSets!.push(ProcessSet.fromJS(item));
            }
            this.typeGroup = _data["typeGroup"] ? TypeGroup.fromJS(_data["typeGroup"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(Permission.fromJS(item));
            }
            if (Array.isArray(_data["parts"])) {
                this.parts = [] as any;
                for (let item of _data["parts"])
                    this.parts!.push(Part.fromJS(item));
            }
            this.permission = _data["permission"] ? Permission.fromJS(_data["permission"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RtaType {
        data = typeof data === 'object' ? data : {};
        let result = new RtaType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["rank"] = this.rank;
        data["typeGroupId"] = this.typeGroupId;
        data["permissionId"] = this.permissionId;
        if (Array.isArray(this.order)) {
            data["order"] = [];
            for (let item of this.order)
                data["order"].push(item.toJSON());
        }
        if (Array.isArray(this.processSets)) {
            data["processSets"] = [];
            for (let item of this.processSets)
                data["processSets"].push(item.toJSON());
        }
        data["typeGroup"] = this.typeGroup ? this.typeGroup.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.parts)) {
            data["parts"] = [];
            for (let item of this.parts)
                data["parts"].push(item.toJSON());
        }
        data["permission"] = this.permission ? this.permission.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRtaType {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    rank?: number | undefined;
    typeGroupId?: number | undefined;
    permissionId?: number;
    order?: ORD_Order[] | undefined;
    processSets?: ProcessSet[] | undefined;
    typeGroup?: TypeGroup;
    permissions?: Permission[] | undefined;
    parts?: Part[] | undefined;
    permission?: Permission;
}

export class TypeGroup implements ITypeGroup {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    color?: string | undefined;
    permissionId?: number;
    assignments?: Assignment[] | undefined;
    types?: RtaType[] | undefined;
    checks?: Check[] | undefined;
    checkSheet_Template?: CheckSheet_Template[] | undefined;

    constructor(data?: ITypeGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.color = _data["color"];
            this.permissionId = _data["permissionId"];
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(Assignment.fromJS(item));
            }
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(RtaType.fromJS(item));
            }
            if (Array.isArray(_data["checks"])) {
                this.checks = [] as any;
                for (let item of _data["checks"])
                    this.checks!.push(Check.fromJS(item));
            }
            if (Array.isArray(_data["checkSheet_Template"])) {
                this.checkSheet_Template = [] as any;
                for (let item of _data["checkSheet_Template"])
                    this.checkSheet_Template!.push(CheckSheet_Template.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TypeGroup {
        data = typeof data === 'object' ? data : {};
        let result = new TypeGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["color"] = this.color;
        data["permissionId"] = this.permissionId;
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item.toJSON());
        }
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item.toJSON());
        }
        if (Array.isArray(this.checks)) {
            data["checks"] = [];
            for (let item of this.checks)
                data["checks"].push(item.toJSON());
        }
        if (Array.isArray(this.checkSheet_Template)) {
            data["checkSheet_Template"] = [];
            for (let item of this.checkSheet_Template)
                data["checkSheet_Template"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITypeGroup {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    color?: string | undefined;
    permissionId?: number;
    assignments?: Assignment[] | undefined;
    types?: RtaType[] | undefined;
    checks?: Check[] | undefined;
    checkSheet_Template?: CheckSheet_Template[] | undefined;
}

export class Uppersection implements IUppersection {
    id?: number;
    sapNumber?: number | undefined;
    drawingNumber?: string | undefined;
    productLineID?: number | undefined;
    apiid?: number | undefined;
    bitBreakerID?: number | undefined;
    threadProtectorID?: number | undefined;
    steel4130ID?: number;
    upperSectionDefault?: number;
    bitMin?: number;
    bitMax?: number | undefined;
    restrictor?: boolean | undefined;
    shortShank?: boolean | undefined;
    isSleeve?: boolean;
    comments?: string | undefined;
    breakerSlotWidth?: number;
    restrictorBoreInternalDiameter?: number;
    length?: number | undefined;
    isObsolete?: boolean;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    description?: string | undefined;
    standardCost?: number | undefined;
    isHighEnergy?: boolean | undefined;
    lastUpdatedDateFromSAP?: Date | undefined;
    electronicId?: number | undefined;
    isColdWorked?: boolean;
    permissionLocked?: boolean;
    oRingId?: number | undefined;
    bomSequence_Id?: number | undefined;
    groupSequence?: number | undefined;
    slotOverWeld?: boolean;
    deepWeldGroove?: boolean;
    productLine?: ProductLine;
    bitBreaker?: BitBreaker;
    steel4130?: Steel4130;
    threadProtector?: ThreadProtector;
    oRing?: ORing;
    electronic?: Electronic;

    constructor(data?: IUppersection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sapNumber = _data["sapNumber"];
            this.drawingNumber = _data["drawingNumber"];
            this.productLineID = _data["productLineID"];
            this.apiid = _data["apiid"];
            this.bitBreakerID = _data["bitBreakerID"];
            this.threadProtectorID = _data["threadProtectorID"];
            this.steel4130ID = _data["steel4130ID"];
            this.upperSectionDefault = _data["upperSectionDefault"];
            this.bitMin = _data["bitMin"];
            this.bitMax = _data["bitMax"];
            this.restrictor = _data["restrictor"];
            this.shortShank = _data["shortShank"];
            this.isSleeve = _data["isSleeve"];
            this.comments = _data["comments"];
            this.breakerSlotWidth = _data["breakerSlotWidth"];
            this.restrictorBoreInternalDiameter = _data["restrictorBoreInternalDiameter"];
            this.length = _data["length"];
            this.isObsolete = _data["isObsolete"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.standardCost = _data["standardCost"];
            this.isHighEnergy = _data["isHighEnergy"];
            this.lastUpdatedDateFromSAP = _data["lastUpdatedDateFromSAP"] ? new Date(_data["lastUpdatedDateFromSAP"].toString()) : <any>undefined;
            this.electronicId = _data["electronicId"];
            this.isColdWorked = _data["isColdWorked"];
            this.permissionLocked = _data["permissionLocked"];
            this.oRingId = _data["oRingId"];
            this.bomSequence_Id = _data["bomSequence_Id"];
            this.groupSequence = _data["groupSequence"];
            this.slotOverWeld = _data["slotOverWeld"];
            this.deepWeldGroove = _data["deepWeldGroove"];
            this.productLine = _data["productLine"] ? ProductLine.fromJS(_data["productLine"]) : <any>undefined;
            this.bitBreaker = _data["bitBreaker"] ? BitBreaker.fromJS(_data["bitBreaker"]) : <any>undefined;
            this.steel4130 = _data["steel4130"] ? Steel4130.fromJS(_data["steel4130"]) : <any>undefined;
            this.threadProtector = _data["threadProtector"] ? ThreadProtector.fromJS(_data["threadProtector"]) : <any>undefined;
            this.oRing = _data["oRing"] ? ORing.fromJS(_data["oRing"]) : <any>undefined;
            this.electronic = _data["electronic"] ? Electronic.fromJS(_data["electronic"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Uppersection {
        data = typeof data === 'object' ? data : {};
        let result = new Uppersection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sapNumber"] = this.sapNumber;
        data["drawingNumber"] = this.drawingNumber;
        data["productLineID"] = this.productLineID;
        data["apiid"] = this.apiid;
        data["bitBreakerID"] = this.bitBreakerID;
        data["threadProtectorID"] = this.threadProtectorID;
        data["steel4130ID"] = this.steel4130ID;
        data["upperSectionDefault"] = this.upperSectionDefault;
        data["bitMin"] = this.bitMin;
        data["bitMax"] = this.bitMax;
        data["restrictor"] = this.restrictor;
        data["shortShank"] = this.shortShank;
        data["isSleeve"] = this.isSleeve;
        data["comments"] = this.comments;
        data["breakerSlotWidth"] = this.breakerSlotWidth;
        data["restrictorBoreInternalDiameter"] = this.restrictorBoreInternalDiameter;
        data["length"] = this.length;
        data["isObsolete"] = this.isObsolete;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["standardCost"] = this.standardCost;
        data["isHighEnergy"] = this.isHighEnergy;
        data["lastUpdatedDateFromSAP"] = this.lastUpdatedDateFromSAP ? this.lastUpdatedDateFromSAP.toISOString() : <any>undefined;
        data["electronicId"] = this.electronicId;
        data["isColdWorked"] = this.isColdWorked;
        data["permissionLocked"] = this.permissionLocked;
        data["oRingId"] = this.oRingId;
        data["bomSequence_Id"] = this.bomSequence_Id;
        data["groupSequence"] = this.groupSequence;
        data["slotOverWeld"] = this.slotOverWeld;
        data["deepWeldGroove"] = this.deepWeldGroove;
        data["productLine"] = this.productLine ? this.productLine.toJSON() : <any>undefined;
        data["bitBreaker"] = this.bitBreaker ? this.bitBreaker.toJSON() : <any>undefined;
        data["steel4130"] = this.steel4130 ? this.steel4130.toJSON() : <any>undefined;
        data["threadProtector"] = this.threadProtector ? this.threadProtector.toJSON() : <any>undefined;
        data["oRing"] = this.oRing ? this.oRing.toJSON() : <any>undefined;
        data["electronic"] = this.electronic ? this.electronic.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUppersection {
    id?: number;
    sapNumber?: number | undefined;
    drawingNumber?: string | undefined;
    productLineID?: number | undefined;
    apiid?: number | undefined;
    bitBreakerID?: number | undefined;
    threadProtectorID?: number | undefined;
    steel4130ID?: number;
    upperSectionDefault?: number;
    bitMin?: number;
    bitMax?: number | undefined;
    restrictor?: boolean | undefined;
    shortShank?: boolean | undefined;
    isSleeve?: boolean;
    comments?: string | undefined;
    breakerSlotWidth?: number;
    restrictorBoreInternalDiameter?: number;
    length?: number | undefined;
    isObsolete?: boolean;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    description?: string | undefined;
    standardCost?: number | undefined;
    isHighEnergy?: boolean | undefined;
    lastUpdatedDateFromSAP?: Date | undefined;
    electronicId?: number | undefined;
    isColdWorked?: boolean;
    permissionLocked?: boolean;
    oRingId?: number | undefined;
    bomSequence_Id?: number | undefined;
    groupSequence?: number | undefined;
    slotOverWeld?: boolean;
    deepWeldGroove?: boolean;
    productLine?: ProductLine;
    bitBreaker?: BitBreaker;
    steel4130?: Steel4130;
    threadProtector?: ThreadProtector;
    oRing?: ORing;
    electronic?: Electronic;
}

export class User implements IUser {
    id?: number;
    displayName!: string | undefined;
    loginID!: string | undefined;
    email?: string | undefined;
    active?: boolean;
    roleId?: number;
    createdDate?: Date;
    createdBy?: number;
    modifiedDate?: Date | undefined;
    modifiedBy?: number | undefined;
    pin?: string | undefined;
    isInternal?: boolean | undefined;
    oktaId?: string | undefined;
    permissions?: Permission[] | undefined;
    orderTasks?: OrderTask[] | undefined;
    communications?: ORD_Communication[] | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.loginID = _data["loginID"];
            this.email = _data["email"];
            this.active = _data["active"];
            this.roleId = _data["roleId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.pin = _data["pin"];
            this.isInternal = _data["isInternal"];
            this.oktaId = _data["oktaId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(Permission.fromJS(item));
            }
            if (Array.isArray(_data["orderTasks"])) {
                this.orderTasks = [] as any;
                for (let item of _data["orderTasks"])
                    this.orderTasks!.push(OrderTask.fromJS(item));
            }
            if (Array.isArray(_data["communications"])) {
                this.communications = [] as any;
                for (let item of _data["communications"])
                    this.communications!.push(ORD_Communication.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["loginID"] = this.loginID;
        data["email"] = this.email;
        data["active"] = this.active;
        data["roleId"] = this.roleId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["pin"] = this.pin;
        data["isInternal"] = this.isInternal;
        data["oktaId"] = this.oktaId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.orderTasks)) {
            data["orderTasks"] = [];
            for (let item of this.orderTasks)
                data["orderTasks"].push(item.toJSON());
        }
        if (Array.isArray(this.communications)) {
            data["communications"] = [];
            for (let item of this.communications)
                data["communications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUser {
    id?: number;
    displayName: string | undefined;
    loginID: string | undefined;
    email?: string | undefined;
    active?: boolean;
    roleId?: number;
    createdDate?: Date;
    createdBy?: number;
    modifiedDate?: Date | undefined;
    modifiedBy?: number | undefined;
    pin?: string | undefined;
    isInternal?: boolean | undefined;
    oktaId?: string | undefined;
    permissions?: Permission[] | undefined;
    orderTasks?: OrderTask[] | undefined;
    communications?: ORD_Communication[] | undefined;
}

export class ValidationType implements IValidationType {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    value?: string | undefined;
    fileValidations?: FileVault_FileValidation[] | undefined;

    constructor(data?: IValidationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.value = _data["value"];
            if (Array.isArray(_data["fileValidations"])) {
                this.fileValidations = [] as any;
                for (let item of _data["fileValidations"])
                    this.fileValidations!.push(FileVault_FileValidation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationType {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["value"] = this.value;
        if (Array.isArray(this.fileValidations)) {
            data["fileValidations"] = [];
            for (let item of this.fileValidations)
                data["fileValidations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidationType {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    value?: string | undefined;
    fileValidations?: FileVault_FileValidation[] | undefined;
}

export class Zone implements IZone {
    location?: string | undefined;
    isBackupElement?: boolean;
    groupNumber?: string | undefined;
    allowedChamfers?: string[] | undefined;
    pdcCutterTypes?: PDCCutterType[] | undefined;

    constructor(data?: IZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            this.isBackupElement = _data["isBackupElement"];
            this.groupNumber = _data["groupNumber"];
            if (Array.isArray(_data["allowedChamfers"])) {
                this.allowedChamfers = [] as any;
                for (let item of _data["allowedChamfers"])
                    this.allowedChamfers!.push(item);
            }
            if (Array.isArray(_data["pdcCutterTypes"])) {
                this.pdcCutterTypes = [] as any;
                for (let item of _data["pdcCutterTypes"])
                    this.pdcCutterTypes!.push(PDCCutterType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Zone {
        data = typeof data === 'object' ? data : {};
        let result = new Zone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["isBackupElement"] = this.isBackupElement;
        data["groupNumber"] = this.groupNumber;
        if (Array.isArray(this.allowedChamfers)) {
            data["allowedChamfers"] = [];
            for (let item of this.allowedChamfers)
                data["allowedChamfers"].push(item);
        }
        if (Array.isArray(this.pdcCutterTypes)) {
            data["pdcCutterTypes"] = [];
            for (let item of this.pdcCutterTypes)
                data["pdcCutterTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IZone {
    location?: string | undefined;
    isBackupElement?: boolean;
    groupNumber?: string | undefined;
    allowedChamfers?: string[] | undefined;
    pdcCutterTypes?: PDCCutterType[] | undefined;
}

export class TaskViewModel implements ITaskViewModel {
    id?: number;
    order_Id?: number;
    process_Id?: number;
    processName?: string;
    user_Id?: number;
    displayName?: string;
    loginID?: string;
    queue_Start?: Date;
    startDate?: Date;
    completeDate?: Date;
    sequence?: number;
    kickedBack_Task_Id?: number;
    notes?: string;
    parentTask_Id?: number;
    parentProcessName?: string;
    isParallel?: boolean;
    isRequired?: boolean;
    isRework?: boolean;
    subSequence?: number;
    subTasks?: SubtaskViewModel[];
    onHoldData?: OnholdViewModel[];

    isLastTask?: boolean;
    isEdit?: boolean;
    canRollback?: boolean;
    taskActive?: boolean;

    constructor(data?: ITaskViewModel) {
        if (data) {
            for (let property in data)
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order_Id = _data["order_Id"];
            this.process_Id = _data["process_Id"];
            this.processName = _data["processName"];
            this.user_Id = _data["user_Id"];
            this.displayName = _data["displayName"];
            this.loginID = _data["loginID"];
            this.queue_Start = _data["queue_Start"] ? new Date(_data["queue_Start"]) : undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"]) : undefined;
            this.completeDate = _data["completeDate"] ? new Date(_data["completeDate"]) : undefined;
            this.sequence = _data["sequence"];
            this.kickedBack_Task_Id = _data["kickedBack_Task_Id"];
            this.notes = _data["notes"];
            this.parentTask_Id = _data["parentTask_Id"];
            this.parentProcessName = _data["parentProcessName"];
            this.isParallel = _data["isParallel"];
            this.isRequired = _data["isRequired"];
            this.isRework = _data["isRework"];
            this.subSequence = _data["subSequence"];
            if (Array.isArray(_data["subTasks"])) {
                this.subTasks = _data["subTasks"].map((s: any) => SubtaskViewModel.fromJS(s));
            }
            if (Array.isArray(_data["onHoldData"])) {
                this.onHoldData = _data["onHoldData"].map((h: any) => OnholdViewModel.fromJS(h));
            }
        }
    }

    static fromJS(data: any): TaskViewModel {
        data = typeof data === 'object' ? data : {};
        const result = new TaskViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order_Id"] = this.order_Id;
        data["process_Id"] = this.process_Id;
        data["processName"] = this.processName;
        data["user_Id"] = this.user_Id;
        data["displayName"] = this.displayName;
        data["loginID"] = this.loginID;
        data["queue_Start"] = this.queue_Start?.toISOString();
        data["startDate"] = this.startDate?.toISOString();
        data["completeDate"] = this.completeDate?.toISOString();
        data["sequence"] = this.sequence;
        data["kickedBack_Task_Id"] = this.kickedBack_Task_Id;
        data["notes"] = this.notes;
        data["parentTask_Id"] = this.parentTask_Id;
        data["parentProcessName"] = this.parentProcessName;
        data["isParallel"] = this.isParallel;
        data["isRequired"] = this.isRequired;
        data["isRework"] = this.isRework;
        data["subSequence"] = this.subSequence;
        if (Array.isArray(this.subTasks)) {
            data["subTasks"] = this.subTasks.map(item => item.toJSON());
        }
        if (Array.isArray(this.onHoldData)) {
            data["onHoldData"] = this.onHoldData.map(item => item.toJSON());
        }
        return data;
    }
}

export interface ITaskViewModel {
    id?: number;
    order_Id?: number;
    process_Id?: number;
    processName?: string;
    user_Id?: number;
    displayName?: string;
    loginID?: string;
    queue_Start?: Date;
    startDate?: Date;
    completeDate?: Date;
    sequence?: number;
    kickedBack_Task_Id?: number;
    notes?: string;
    parentTask_Id?: number;
    parentProcessName?: string;
    isParallel?: boolean;
    isRequired?: boolean;
    isRework?: boolean;
    subSequence?: number;
    subTasks?: SubtaskViewModel[];
    onHoldData?: OnholdViewModel[];

    isLastTask?: boolean;
    isEdit?: boolean;
    canRollback?: boolean;
    taskActive?: boolean;
}
export class SubtaskViewModel implements ISubtaskViewModel {
    id?: number;
    order_Id?: number;
    process_Id?: number;
    processName?: string;
    user_Id?: number;
    displayName?: string;
    loginID?: string;
    queue_Start?: Date;
    startDate?: Date;
    completeDate?: Date;
    sequence?: number;
    kickedBack_Task_Id?: number;
    notes?: string;
    parentTask_Id?: number;
    parentProcessName?: string;
    isParallel?: boolean;
    isRequired?: boolean;
    isRework?: boolean;
    subSequence?: number;

    constructor(data?: ISubtaskViewModel) {
        if (data) {
            for (let property in data)
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order_Id = _data["order_Id"];
            this.process_Id = _data["process_Id"];
            this.processName = _data["processName"];
            this.user_Id = _data["user_Id"];
            this.displayName = _data["displayName"];
            this.loginID = _data["loginID"];
            this.queue_Start = _data["queue_Start"] ? new Date(_data["queue_Start"]) : undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"]) : undefined;
            this.completeDate = _data["completeDate"] ? new Date(_data["completeDate"]) : undefined;
            this.sequence = _data["sequence"];
            this.kickedBack_Task_Id = _data["kickedBack_Task_Id"];
            this.notes = _data["notes"];
            this.parentTask_Id = _data["parentTask_Id"];
            this.parentProcessName = _data["parentProcessName"];
            this.isParallel = _data["isParallel"];
            this.isRequired = _data["isRequired"];
            this.isRework = _data["isRework"];
            this.subSequence = _data["subSequence"];
        }
    }

    static fromJS(data: any): SubtaskViewModel {
        data = typeof data === 'object' ? data : {};
        const result = new SubtaskViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order_Id"] = this.order_Id;
        data["process_Id"] = this.process_Id;
        data["processName"] = this.processName;
        data["user_Id"] = this.user_Id;
        data["displayName"] = this.displayName;
        data["loginID"] = this.loginID;
        data["queue_Start"] = this.queue_Start?.toISOString();
        data["startDate"] = this.startDate?.toISOString();
        data["completeDate"] = this.completeDate?.toISOString();
        data["sequence"] = this.sequence;
        data["kickedBack_Task_Id"] = this.kickedBack_Task_Id;
        data["notes"] = this.notes;
        data["parentTask_Id"] = this.parentTask_Id;
        data["parentProcessName"] = this.parentProcessName;
        data["isParallel"] = this.isParallel;
        data["isRequired"] = this.isRequired;
        data["isRework"] = this.isRework;
        data["subSequence"] = this.subSequence;
        return data;
    }
}

export interface ISubtaskViewModel {
    id?: number;
    order_Id?: number;
    process_Id?: number;
    processName?: string;
    user_Id?: number;
    displayName?: string;
    loginID?: string;
    queue_Start?: Date;
    startDate?: Date;
    completeDate?: Date;
    sequence?: number;
    kickedBack_Task_Id?: number;
    notes?: string;
    parentTask_Id?: number;
    parentProcessName?: string;
    isParallel?: boolean;
    isRequired?: boolean;
    isRework?: boolean;
    subSequence?: number;

    isLastTask?: boolean;
    isEdit?: boolean;
    canRollback?: boolean;
    taskActive?: boolean;
}
export class OnholdViewModel implements IOnholdViewModel {
    id?: number;
    start?: Date;
    removed?: Date;
    user?: string;
    reason?: string;

    constructor(data?: IOnholdViewModel) {
        if (data) {
            for (let property in data)
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.start = _data["start"] ? new Date(_data["start"]) : undefined;
            this.removed = _data["removed"] ? new Date(_data["removed"]) : undefined;
            this.user = _data["user"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): OnholdViewModel {
        data = typeof data === 'object' ? data : {};
        const result = new OnholdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["start"] = this.start?.toISOString();
        data["removed"] = this.removed?.toISOString();
        data["user"] = this.user;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IOnholdViewModel {
    id?: number;
    start?: Date;
    removed?: Date;
    user?: string;
    reason?: string;
}

export interface PatchORDOrderOnHoldDto {
    user_Id: number;
    onHoldCat_Id: number;
    reason?: string | undefined;
    order_Id: number;
}

export interface PatchPartElementDto {
    id: number;
    preBOMID: number;
    type: string;
    sapMaterialNumber: number;
    quantity: number;
}

export interface PartElementsStateModel {
    elementsByPartKey: {
        [key: string]: PatchPartElementDto[];
    };
}


export interface RawFeature {
    name: string;
    subPSL: string;
    subcat: string;
    value: number | string;
    IsCostSavingFeature?: boolean;
    IsDisplayedInMarketingSheet?: boolean;
}
export type OptionId = string;
export interface FeatureOption {
    id: OptionId;
    label: string;
    raw: RawFeature;
}

export interface FeatureGroup {
    id: string;
    label: string;
    options: FeatureOption[];
}

export interface ICutterOverrideRequest {
    id?: number;
    order_Id?: number;
    requestedBy_UserId?: number;
    requestedByEmail?: string | undefined;
    requestedOnUtc?: Date;
    requestType?: string | undefined;
    cutterFamily_Id?: number;
    cutterFamilyName?: string;
    nomenclatureRequested?: string | undefined;
    justification?: string;
    status?: string;
    approvalCode?: string | undefined;
    approvalCodeExpiresUtc?: Date | undefined;
    approvedBy_UserId?: number | undefined;
    approvedOnUtc?: Date | undefined;
    responseNotes?: string | undefined;
}

export class CutterOverrideRequest implements ICutterOverrideRequest {
    id?: number;
    order_Id?: number;
    requestedBy_UserId?: number;
    requestedByEmail?: string | undefined;
    requestedOnUtc?: Date;
    requestType?: string | undefined;
    cutterFamily_Id?: number;
    cutterFamilyName?: string;
    nomenclatureRequested?: string | undefined;
    justification?: string;
    status?: string;
    approvalCode?: string | undefined;
    approvalCodeExpiresUtc?: Date | undefined;
    approvedBy_UserId?: number | undefined;
    approvedOnUtc?: Date | undefined;
    responseNotes?: string | undefined;

    constructor(data?: ICutterOverrideRequest) {
        if (data) {
            for (let property in data)
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order_Id = _data["order_Id"];
            this.requestedBy_UserId = _data["requestedBy_UserId"];
            this.requestedByEmail = _data["requestedByEmail"];
            this.requestedOnUtc = _data["requestedOnUtc"] ? new Date(_data["requestedOnUtc"]) : undefined;
            this.requestType = _data["requestType"];
            this.cutterFamily_Id = _data["cutterFamily_Id"];
            this.cutterFamilyName = _data["cutterFamilyName"];
            this.nomenclatureRequested = _data["nomenclatureRequested"];
            this.justification = _data["justification"];
            this.status = _data["status"];
            this.approvalCode = _data["approvalCode"];
            this.approvalCodeExpiresUtc = _data["approvalCodeExpiresUtc"] ? new Date(_data["approvalCodeExpiresUtc"]) : undefined;
            this.approvedBy_UserId = _data["approvedBy_UserId"];
            this.approvedOnUtc = _data["approvedOnUtc"] ? new Date(_data["approvedOnUtc"]) : undefined;
            this.responseNotes = _data["responseNotes"];
        }
    }

    static fromJS(data: any): CutterOverrideRequest {
        data = typeof data === 'object' ? data : {};
        const result = new CutterOverrideRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order_Id"] = this.order_Id;
        data["requestedBy_UserId"] = this.requestedBy_UserId;
        data["requestedByEmail"] = this.requestedByEmail;
        data["requestedOnUtc"] = this.requestedOnUtc ? this.requestedOnUtc.toISOString() : undefined;
        data["requestType"] = this.requestType;
        data["cutterFamily_Id"] = this.cutterFamily_Id;
        data["cutterFamilyName"] = this.cutterFamilyName;
        data["nomenclatureRequested"] = this.nomenclatureRequested;
        data["justification"] = this.justification;
        data["status"] = this.status;
        data["approvalCode"] = this.approvalCode;
        data["approvalCodeExpiresUtc"] = this.approvalCodeExpiresUtc ? this.approvalCodeExpiresUtc.toISOString() : undefined;
        data["approvedBy_UserId"] = this.approvedBy_UserId;
        data["approvedOnUtc"] = this.approvedOnUtc ? this.approvedOnUtc.toISOString() : undefined;
        data["responseNotes"] = this.responseNotes;
        return data;
    }
}

export interface CreateCutterOverrideRequestDto {
    requestType?: string | undefined;
    cutterFamilyId?: number;
    cutterFamilyName?: string;
    nomenclatureRequested?: string | undefined;
    justification: string;
    requesterEmail?: string | undefined;
}

export interface ApproveCutterOverrideRequestDto {
    approvalCodeExpiresUtc?: Date | undefined;
}

export interface DenyCutterOverrideRequestDto {
    responseNotes?: string | undefined;
}

export interface ValidateOverrideCodeDto {
    orderId: number;
    code: string;
}

export interface MarketingSheetCutterDto {
    matNum: number;
    c8f: number;
    c8g: number;
    c10f: number;
    c10g: number;
    c13f: number;
    c13g: number;
    c16f: number;
    c16g: number;
    c19f: number;
    c19g: number;
    c25f: number;
    c25g: number;
}

export class ORD_Arm implements IORD_Arm {
    id?: number;
    orderId?: number;
    size?: number | undefined;
    type?: string | undefined;
    bitFeatures?: string | undefined;
    level?: number | undefined;
    gaugeLength?: number | undefined;
    openingSize?: number;
    cutterRow?: number;
    newArm?: boolean;
    order?: ORD_Order;

    constructor(data?: IORD_Arm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.size = _data["size"];
            this.type = _data["type"];
            this.bitFeatures = _data["bitFeatures"];
            this.level = _data["level"];
            this.gaugeLength = _data["gaugeLength"];
            this.openingSize = _data["openingSize"];
            this.cutterRow = _data["cutterRow"];
            this.newArm = _data["newArm"];
            this.order = _data["order"] ? ORD_Order.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ORD_Arm {
        data = typeof data === 'object' ? data : {};
        let result = new ORD_Arm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["size"] = this.size;
        data["type"] = this.type;
        data["bitFeatures"] = this.bitFeatures;
        data["level"] = this.level;
        data["gaugeLength"] = this.gaugeLength;
        data["openingSize"] = this.openingSize;
        data["cutterRow"] = this.cutterRow;
        data["newArm"] = this.newArm;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data;
    }
}

export interface IORD_Arm {
    id?: number;
    orderId?: number;
    size?: number | undefined;
    type?: string | undefined;
    bitFeatures?: string | undefined;
    level?: number | undefined;
    gaugeLength?: number | undefined;
    hardfacing?: string | undefined;
    openingSize?: number;
    cutterRow?: number;
    newArm?: boolean;
    order?: ORD_Order;
}

export interface PatchORDArmDto {
    id: number;
    orderId: number;
    size?: number | null;
    type?: string | null;
    bitFeatures?: string | null;
    level?: number | null;
    gaugeLength?: number | null;
    hardfacing?: string | null;
    openingSize?: number;
    cutterRow?: number;
    newArm?: boolean;
}

export interface PatchRollerConeDto {
    id: number;
    rtaNum: number;
    bitCode?: string | null;
    bitClass?: string | null;
    pinAng?: number | null;
    offsetNum?: number | null;
    brgCode?: string | null;
    bkfc?: number | null;
    taskLevel?: number | null;
    techBit?: boolean | null;
    surfDiamond?: number | null;
    coneType?: string | null;
    faiRequired: boolean;
    adero: boolean;
    newCone?: boolean | null;
    newArm?: boolean | null;
    layout?: number | null;
    arm?: number | null;
    shirtTailProtection?: string | null;
    referenceLayout?: number | null;
    referenceArm?: number | null;
    retrofitFeature?: string | null;
    retrofitType?: string | null;
}

